export enum MicroServer {
  config = '/config-web', //配置系统
  task = '/task-web', //任务系统
  crm = '/crm-web', //crm系统
  caas = '/caas-web', //权限系统
  userWeb = '/ucenter-user-web', //权限系统
  clue = '/clue-web', //线索系统?
  report = '/report-web', //文件系统
  portal = '/api-portal', //portal系统
  file = '/file-web', //file系统
  platform = '/platform-web', //platform系统
  export = '/plus-export-web', //export系统
  ucenter = '/ucenter-web', //平台 用户
  pns = '/pns-web', // 消息
  workOrder = '/workorder-web', // 工单 待办
  cacheWeb = '/cache-web', // 缓存服务
  vmsWeb = '/vms-web', // 供应商
  plusPmWeb = '/plus-pm-web', //服务配置
  content = '/plus-content-web', // 内容管理
  member = 'plus-member-web', // 会员管理
  plusProductWeb = '/plus-product-web', // 标准版-产品
  platformWeb = '/platform-web', // 标准版-平台
  plusGoodsWeb = '/plus-goods-web', // 标准版-商品
  plusTradeWeb = '/plus-trade-web', // 交易
  plusCrmWeb = '/plus-crm-web', // 标准版 crm系统
  plusClueWeb = '/plus-clue-web', // 标准版 线索
  fms = '/fm-web', //收款服务
  plusFmsWeb = '/plus-fms-web', //标准版-收款服务
  kingdee = '/kingdee-web', //组织账套
  esign = '/esign-web', //电子合同
  bd = '/bd-web',
  deal = '/deal-web',
  pmsWeb = '/pms-web',
  dispatcher = '/dispatcher-web',
  mpmsWeb = '/mpms-web',
  sviMoa = '/api-moa',
  crmTool = '/crm-tools-web', //工具（呼叫, 量房）
  plusJdTenantWed = '/plus-jd-tenant-web',
  custTenantWeb = '/cust-tenant-web',
  goodsFrontendTenantWeb = '/goods-frontend-tenant-web',
  esWeb = '/es-web',
  bpmWeb = '/bpm-web',
}

const UrlConfig = {
  DispatcherWeb: {
    GetDisPatchMethodList: MicroServer.dispatcher + '/dispatchMethod/search/list',
  },
  EsWeb: {
    SearchBankBranch: MicroServer.esWeb + '/es/bankBranch/search', //带银行条件的跳词搜索
  },
  PlusCrmWeb: {
    //开发商管理
    EstateDeveloperExistsByName: MicroServer.plusCrmWeb + '/estateDeveloper/existsByName', //检查开发商名称是否重名
    EstateDeveloper: MicroServer.plusCrmWeb + '/estateDeveloper', // 开发商列表---增|删|查
    EstateDeveloperUpdateById: MicroServer.plusCrmWeb + '/estateDeveloper/updateById', // 开发商列表---编辑
    EstateDeveloperSearchPage: MicroServer.plusCrmWeb + '/estateDeveloper/search/page', // 开发商列表
    //标签管理
    TagLibraryGetTagsTreeByType: MicroServer.plusCrmWeb + '/tagLibrary/getTagsTreeByType/', //
    TagLibraryGetTagsTree: MicroServer.plusCrmWeb + '/tagLibrary/getTagsTree/', //
    TagLibrary: MicroServer.plusCrmWeb + '/tagLibrary', //
    TagLibraryUpdateById: MicroServer.plusCrmWeb + '/tagLibrary/updateById', //
    TagLibraryBatchSaveTags: MicroServer.plusCrmWeb + '/tagLibrary/batchSaveTags', //
    GetPlusEnums: MicroServer.plusCrmWeb + '/enums/', //枚举值参数获取
    // 楼盘区域
    BuildingAreaSearchPage: MicroServer.plusCrmWeb + '/buildingArea/search/page', //楼盘区域列表
    BuildingArea: MicroServer.plusCrmWeb + '/buildingArea', //楼盘区域根据id查询信息
    BuildingAreaUpdateById: MicroServer.plusCrmWeb + '/buildingArea/updateById', //楼盘区域编辑
    // 楼盘管理
    BuildingInfo: MicroServer.plusCrmWeb + '/buildingInfo/search/list', //楼盘列表
    TreeWithChannel: MicroServer.plusClueWeb + '/channelTree/select/tree', //客户来源
    BuildingInfoExportBuildingInfoList:
      MicroServer.plusCrmWeb + '/buildingInfo/exportBuildingInfoList', //楼盘信息--导出
    BuildingInfoExportBuildingInfoTemplate:
      MicroServer.plusCrmWeb + '/buildingInfo/exportBuildingInfoTemplate', //楼盘信息--下载批量添加模板
    BuildingInfoSearchPage: MicroServer.plusCrmWeb + '/buildingInfo/search/page', //楼盘列表
    BuildingAreaSearchList: MicroServer.plusCrmWeb + '/buildingArea/search/list', //根据公司id查询楼盘区域列表
    BuildingInfoOperate: MicroServer.plusCrmWeb + '/buildingInfo', //新增Or编辑楼盘
    BuildingInfoSearchOne: MicroServer.plusCrmWeb + '/buildingInfo/search/one', //楼盘列表查询详情
    EstateDeveloperSearchList: MicroServer.plusCrmWeb + '/estateDeveloper/search/list', //开发商列表
    RegionSearchList: MicroServer.plusCrmWeb + '/region/search/list', //城市列表
    BuildingInfoGetBuildingCode: MicroServer.plusCrmWeb + '/buildingInfo/getBuildingCode', //生成楼盘编号
    LayoutInfoSearchPage: MicroServer.plusCrmWeb + '/layoutInfo/search/page', //楼盘信息详情户型信息列表
    LayoutInfoOperate: MicroServer.plusCrmWeb + '/layoutInfo', //楼盘信息详情户型信息---增|删|查
    // 分配人管理
    DispatchMnrDelete: MicroServer.plusCrmWeb + '/dispatchMnr/deleteById',
    DispatchMnrFindResponseListByPage:
      MicroServer.plusCrmWeb + '/dispatchMnr/findResponseListByPage',
    DispatchMnrSaveOrUpdateEntity: MicroServer.plusCrmWeb + '/dispatchMnr/saveOrUpdateEntity',
    SaveDispatchUser: MicroServer.plusCrmWeb + '/dispatchMnr/saveDispatchUser',
    //目标
    AchievementChannelTypePage: MicroServer.plusCrmWeb + '/achievementChannelType/search/page', //军种
    AchievementChannelTypeList: MicroServer.plusCrmWeb + '/achievementChannelType/search/list', //军种
    AchievementChannelType: MicroServer.plusCrmWeb + '/achievementChannelType', //军种
    AchievementChannelTypeUpdateById: MicroServer.plusCrmWeb + '/achievementChannelType/updateById', //军种

    AchievementManage: MicroServer.plusCrmWeb + '/achievementManage', // 获取详情目标配置
    AchievementManageUpdateById: MicroServer.plusCrmWeb + '/achievementManage/updateById', // 修改详情目标配置
    AchievementManageExport: MicroServer.plusCrmWeb + '/achievementManage/export', // 问题列表导出
    AchievementManageSearch: MicroServer.plusCrmWeb + '/achievementManage/search', // 工单管理 - 问题列表
    SynAchievementDateWeekConfig:
      MicroServer.plusCrmWeb + '/achievementManageDetail/synAchievementDateWeekConfig', // 同步目标周次配置
    AchievementDateList: MicroServer.plusCrmWeb + '/achievementDate/list', // 获取周次配置列表
    AchievementDepartment: MicroServer.plusCrmWeb + '/achievementDepartment', // 目标管理 - 删除部门
    AchievementDepartmentGetById: MicroServer.plusCrmWeb + '/achievementDepartment/getById', // 目标管理 - 部门详情
    AchievementDepartmentGetPageInfo: MicroServer.plusCrmWeb + '/achievementDepartment/getPageInfo', // 目标管理 - 部门列表
    AchievementDepartmentUpdateStatus:
      MicroServer.plusCrmWeb + '/achievementDepartment/updateStatus', // 目标管理 - 部门状态
    AchievementDepartmentSave: MicroServer.plusCrmWeb + '/achievementDepartment/save', // 目标管理 - 新增部门
    AchievementDepartmentSaveBatch: MicroServer.plusCrmWeb + '/achievementDepartment/saveBatch', // 目标管理 - 新增
    AchievementShowForDept:
      MicroServer.plusCrmWeb + '/achievementDepartment/achievementShowForDept', // 目标管理
    AchievementDepartmentUpdate: MicroServer.plusCrmWeb + '/achievementDepartment/update', // 目标管理 - 更新部门
    AchievementPersonalGetById: MicroServer.plusCrmWeb + '/achievementPersonal/getById', // 获取部门人员信息
    AchievementPersonal: MicroServer.plusCrmWeb + '/achievementPersonal', // 删除部门人员信息
    AchievementPersonalUpdateStatus: MicroServer.plusCrmWeb + '/achievementPersonal/updateStatus', // 更新部门人员状态信息
    AchievementPersonalGetPageInfo: MicroServer.plusCrmWeb + '/achievementPersonal/getPageInfo', // 获取个人配置列表
    AchievementDateFindById: MicroServer.plusCrmWeb + '/achievementDate/findById', // 目标周期配置 查询
    AchievementDate: MicroServer.plusCrmWeb + '/achievementDate', // 业绩期管理
    AchievementDatePage: MicroServer.plusCrmWeb + '/achievementDate/page', // 业绩期管理 - 列表
    //渠道
    ChannelPageChannel: MicroServer.plusCrmWeb + '/channel/pageChannel', // 渠道库 - 列表
    ChannelCategoryTree: MicroServer.plusCrmWeb + '/channelCategory/tree', // 渠道分类 - tree
    ChannelSwitchChannelState: MicroServer.plusCrmWeb + '/channel/switchChannelState/', // 渠道库 - 修改状态
    ChannelDownloadRelatedChannelFiles:
      MicroServer.plusCrmWeb + '/channel/downloadRelatedChannelFiles', // 渠道库 - 下载关系附件
    ChannelMarkSave: MicroServer.plusCrmWeb + '/channelMark/save', // 渠道库 - 标记保存
    ChannelMarkFindByChannelId: MicroServer.plusCrmWeb + '/channelMark/findByChannelId', // 渠道库 - 标记列表
    ChannelFindChannelById: MicroServer.plusCrmWeb + '/channel/findChannelById', // 渠道库 - 操作
    ChannelLogFindChannelLogPage: MicroServer.plusCrmWeb + '/channelLog/findChannelLogPage/', // 渠道库 - 日志列表
    ChannelSave: MicroServer.plusCrmWeb + '/channel/save', // 渠道库 - 新增
    ChannelCategorySwitchEnabled: MicroServer.plusCrmWeb + '/channelCategory/switchEnabled/', //渠道分类 - 修改状态
    ChannelCategory: MicroServer.plusCrmWeb + '/channelCategory', //渠道分类 - 增|删|查
    ChannelCategoryUpdate: MicroServer.plusCrmWeb + '/channelCategory/updateById', //渠道分类 - 编辑
    //客户档案
    CustomerFindResponseListByPage: MicroServer.custTenantWeb + '/customer/findResponseListByPage', //客户信息 - 列表
    DispatchMnrPage: MicroServer.plusCrmWeb + '/dispatchMnr/search/page', //派门店分页查询
    AddDispatchStore: MicroServer.plusCrmWeb + '/dispatchMnr/addDispatchStore', // 新增门店
    UpdateDispatchStore: MicroServer.plusCrmWeb + '/dispatchMnr/updateDispatchStore', // 编辑门店
    DelDispatchStore: MicroServer.plusCrmWeb + '/dispatchMnr/', // 删除门店
    DataCloseTree: MicroServer.plusCrmWeb + '/dataClose/tree', //关闭管理 - tree
    AddDataClose: MicroServer.plusCrmWeb + '/dataClose', //新增 删除 关闭管理数据
    DataCloseModify: MicroServer.plusCrmWeb + '/dataClose/updateById', //修改关闭管理数据
    BizOpTypeEnum: MicroServer.plusCrmWeb + '/enums/com.shj.saas.plus.crm.enums.BizOpTypeEnum', //需求标签枚举 - tree
    SalesTemplateTaskEnum: MicroServer.plusCrmWeb + '/salesTemplate/getTaskList', //跟进任务管理查询
    // 商机列表
    GetNicheListByPage: MicroServer.plusCrmWeb + '/baseBizOp/search/page',
    // 销售计划
    GetTrackPlanPage: MicroServer.plusCrmWeb + '/trackPlan/trackPlanPage',
    TrackPlanUpdate: MicroServer.plusCrmWeb + '/trackPlan/updateById',
    TrackPlan: MicroServer.plusCrmWeb + '/trackPlan',
    GetTrackPlanReceive: MicroServer.plusCrmWeb + '/trackPlan/receive',
    FindCustomerMemberInfo: MicroServer.custTenantWeb + '/customer/findCustomerMemberInfo/', // 客户信息 会员信息
    TrackPlanBaseInfo: MicroServer.plusCrmWeb + '/trackPlan/detail/', // 基本信息
    TrackPlanViewPhone: MicroServer.plusCrmWeb + '/trackPlan/viewPhone/', // 查看电话号码

    // 报事报修- 对内
    GetTicketsInternalConfig: MicroServer.plusCrmWeb + '/ticketsInternalConfig/search/list',
    TicketsInternalConfigUpdate: MicroServer.plusCrmWeb + '/ticketsInternalConfig/updateById',
    TicketsInternalConfigAdd: MicroServer.plusCrmWeb + '/ticketsInternalConfig',
    // 报事报修- 对外
    GetTicketsExternalConfig: MicroServer.plusCrmWeb + '/ticketsExternalConfig/search/list',
    TicketsExternalConfigUpdate: MicroServer.plusCrmWeb + '/ticketsExternalConfig/updateById',
    TicketsExternalConfigAdd: MicroServer.plusCrmWeb + '/ticketsExternalConfig',
    // 报事报修- 渠道
    GetTicketsChannelConfig: MicroServer.plusCrmWeb + '/ticketsChannelConfig/search/list',
    TicketsChannelConfigUpdate: MicroServer.plusCrmWeb + '/ticketsChannelConfig/updateById',
    TicketsChannelConfigAdd: MicroServer.plusCrmWeb + '/ticketsChannelConfig',
    // 报事报修- 曝光渠道
    GetTicketsExposureConfig: MicroServer.plusCrmWeb + '/ticketsExposureConfig/search/list',
    TicketsExposureConfigUpdate: MicroServer.plusCrmWeb + '/ticketsExposureConfig/updateById',
    TicketsExposureConfigAdd: MicroServer.plusCrmWeb + '/ticketsExposureConfig',
    // 报事报修- 解决方案
    GetTicketsSolutionConfig: MicroServer.plusCrmWeb + '/ticketsSolutionConfig/search/list',
    TicketsSolutionConfigUpdate: MicroServer.plusCrmWeb + '/ticketsSolutionConfig/updateById',
    TicketsSolutionConfigAdd: MicroServer.plusCrmWeb + '/ticketsSolutionConfig',
    // 报事报修- 问题列表
    GetTicketsIssueListPage: MicroServer.plusCrmWeb + '/ticketsIssueList/search/page',
    TicketsIssueSaveOrUpdate: MicroServer.plusCrmWeb + '/ticketsIssueList/saveOrUpdate',
    TicketsIssueDetail: MicroServer.plusCrmWeb + '/ticketsIssueList/selectById/',
    TicketsIssueViewPhone: MicroServer.plusCrmWeb + '/ticketsIssueList/viewPhone',
    TicketsIssuePushComment: MicroServer.plusCrmWeb + '/ticketsIssueList/pushComment',
    TicketsIssueReplay: MicroServer.plusCrmWeb + '/ticketsIssueList/reply',
    // 操作日志
    TicketsOperateLog: MicroServer.plusCrmWeb + '/ticketsOperateLog/search/page',
    /**
     * 销售计划
     */
    AddNewTrackPlan: MicroServer.plusCrmWeb + '/baseBizOp/addForApp', // 新增销售计划
    UpdateTrackPlan: MicroServer.plusCrmWeb + '/trackPlan/updateTrackPlan', // 编辑销售计划
    UpdateCustomerInfo: MicroServer.custTenantWeb + '/customer/updateCustomer', // 编辑客户信息
    ContractAreaRangeEnum:
      MicroServer.plusCrmWeb + '/enums/com.shj.saas.plus.crm.enums.ContractAreaRangeEnum', // 建筑面积区间
    CustomerCareerEnum:
      MicroServer.plusCrmWeb + '/enums/com.shj.saas.plus.crm.enums.CustomerCareerEnum', // 客户职业
    HouseDecorateStyleEnum:
      MicroServer.plusCrmWeb + '/enums/com.shj.saas.plus.crm.enums.HouseDecorateStyleEnum', // 装修风格
    HouseKindEnum: MicroServer.plusCrmWeb + '/enums/com.shj.saas.plus.crm.enums.HouseKindEnum', // 房屋类型
    HouseNatureEnum: MicroServer.plusCrmWeb + '/enums/com.shj.saas.plus.crm.enums.HouseNatureEnum', // 房屋属性
    HouseStatusEnum: MicroServer.plusCrmWeb + '/enums/com.shj.saas.plus.crm.enums.HouseStatusEnum', // 房屋状态
    HouseTypeEnum: MicroServer.plusCrmWeb + '/enums/com.shj.saas.plus.crm.enums.HouseTypeEnum', // 户型
    PermanentResidentsEnum:
      MicroServer.plusCrmWeb + '/enums/com.shj.saas.plus.crm.enums.PermanentResidentsEnum', // 常住人口
    ProductionTypeEnum:
      MicroServer.plusCrmWeb + '/enums/com.shj.saas.plus.crm.enums.ProductionTypeEnum', // 产品意向
    ResidencePurposeEnum:
      MicroServer.plusCrmWeb + '/enums/com.shj.saas.plus.crm.enums.ResidencePurposeEnum', // 居住目的
    SignBillIntentEnum:
      MicroServer.plusCrmWeb + '/enums/com.shj.saas.plus.crm.enums.SignBillIntentEnum', // 签单意向
    AddRecordTypeEnum:
      MicroServer.plusCrmWeb + '/enums/com.shj.saas.plus.crm.enums.AddRecordTypeEnum', // 新增跟进记录-跟进方式
    TrackPlanStatusEnum:
      MicroServer.plusCrmWeb + '/enums/com.shj.saas.plus.crm.enums.TrackPlanStatusEnum', // 客户状态
    BudGetEnums: MicroServer.plusCrmWeb + '/enums/com.shj.saas.plus.crm.enums.BudGetEnums', // 装修预算
    GetCustomerMemberInfo: MicroServer.custTenantWeb + '/customer/findCustomerMemberInfo', // 获取客户信息
    GetAppointmentList: MicroServer.plusCrmWeb + '/appointment/search/list', // 获取云客服回显列表
    GetTrackPlanInfo: MicroServer.plusCrmWeb + '/trackPlan/detail', // 获取客户信息
    AddNewTrackLog: MicroServer.plusCrmWeb + '/trackPlan/addTrackLog', // 新增跟进记录
    SubmitPending: MicroServer.plusCrmWeb + '/trackPlan/judgePending', // 提交待定
    SubmitEffecive: MicroServer.plusCrmWeb + '/trackPlan/judgeValid', // 新增有效
    SubscribeArrive: MicroServer.plusCrmWeb + '/trackPlan/appointment', // 预约到店
    ConfirmArrive: MicroServer.plusCrmWeb + '/trackPlan/confirmToShop', // 确认到店
    SubmitInvalid: MicroServer.plusCrmWeb + '/trackPlan/judgeInvalid', // 转无效
    AppointmentTypeEnum:
      MicroServer.plusCrmWeb + '/enums/com.shj.saas.plus.crm.enums.AppointmentTypeEnum', // 预约见面-见面类型
    ArrivalTypeEnum: MicroServer.plusCrmWeb + '/enums/com.shj.saas.plus.crm.enums.ArrivalTypeEnum', // 确认到店-是否到店
    FunctionNeedEnum:
      MicroServer.plusCrmWeb + '/enums/com.shj.saas.plus.crm.enums.FunctionNeedEnum', // 功能需求
    PendingReasonEnum:
      MicroServer.plusCrmWeb + '/enums/com.shj.saas.plus.crm.enums.PendingReasonEnum', // 待定原因
    GetTrackDetailCount: MicroServer.plusCrmWeb + '/trackPlan/detailCount', // 详情统计
    GetTabPageCount: MicroServer.plusCrmWeb + '/trackPlan/pageCount', // 分tab数量统计
    GetTrackPlanLog: MicroServer.plusCrmWeb + '/trackPlanLog/search/list', // 跟进记录
    GetTrackPlanRelatives: MicroServer.plusCrmWeb + '/relatives/search/list', // 服务人员分配列表
    AssignSales: MicroServer.plusCrmWeb + '/trackPlanRelatives/assignSales', // 分配营销员
    AssignDesigner: MicroServer.plusCrmWeb + '/trackPlanRelatives/assignDesigner', // 分配设计师
    AssignDesignerMnr: MicroServer.plusCrmWeb + '/trackPlanRelatives/assignDesignerMnr', // 分配设计经理
    AssignRelatives: MicroServer.plusCrmWeb + '/trackPlanRelatives/assignRelatives', // 分配设计经理
    AddPartner: MicroServer.plusCrmWeb + '/trackPlanRelatives/addPartner', // 添加协作人
    GetAuthorizeEmployee: MicroServer.plusCrmWeb + '/trackPlanRelatives/queryEmployee', // 查询授权员工
    QueryEmployeeForReassign:
      MicroServer.plusCrmWeb + '/trackPlanRelatives/queryEmployeeForReassign', // 变更-查询授权员工
    GetEmployee: MicroServer.caas + '/authorizeUserIdentity/search/page', // 改派-查询授权员工
    ViewPhone: MicroServer.plusCrmWeb + '/trackPlan/viewPhone', // 查看电话
    UpdateBizType: MicroServer.plusCrmWeb + '/trackPlan/updateBizType', // 更新需求标签
    GetDrawTags: MicroServer.plusCrmWeb + '/trackPlan/queryTags', // 销售计划详情-画像-已有标签查询
    GetTrackPlanNode: MicroServer.plusCrmWeb + '/trackPlanNode/search/list', // 销售计划详情-流程
    UpdateTrackPlanTag: MicroServer.plusCrmWeb + '/trackPlan/updateTrackPlanTag', // 编辑销售计划标签
    RemovePartner: MicroServer.plusCrmWeb + '/trackPlanRelatives/removePartner', // 移除协作人
    GetButtonList: MicroServer.plusCrmWeb + '/trackPlan/getButton', // 按钮查询
    GetButtonByTemplateId: MicroServer.plusCrmWeb + '/trackPlan/getButtonByTemplateId', // 按钮查询-计划改派
    GetOrderList: MicroServer.plusTradeWeb + '/order/search/list', // 订单列表
    /**
     * 商机详情
     */
    GetDetailByBizOpId: MicroServer.plusCrmWeb + '/trackPlan/detailByBizOpId', // 商机详情
    QueryAllTags: MicroServer.plusCrmWeb + '/baseBizOp/queryTags', // 商机详情
    // 报事报修- 工单
    GetTicketsListPage: MicroServer.plusCrmWeb + '/ticketsList/search/page',
    GetTicketsListByIssueId: MicroServer.plusCrmWeb + '/ticketsList/getListByIssueId/',
    TicketsSaveOrUpdate: MicroServer.plusCrmWeb + '/ticketsList/addOrUpdate',
    TicketsDetail: MicroServer.plusCrmWeb + '/ticketsList/detail/',
    TicketsRemind: MicroServer.plusCrmWeb + '/ticketsList/remind',
    TicketsBack: MicroServer.plusCrmWeb + '/ticketsList/back',
    TicketsAnewOpen: MicroServer.plusCrmWeb + '/ticketsList/anewOpen/',
    TicketsAccept: MicroServer.plusCrmWeb + '/ticketsList/accept/',
    TicketsGetLoginUserAttr: MicroServer.plusCrmWeb + '/ticketsList/getLoginUserAttr',
    TicketsBatchUpdateDisposePerson:
      MicroServer.plusCrmWeb + '/ticketsList/batchUpdateDisposePerson',
    TicketsAddChargePerson: MicroServer.plusCrmWeb + '/ticketsList/addChargePerson',

    GetTicketsDisposeLog: MicroServer.plusCrmWeb + '/ticketsDisposeLog/search/list', // 根据工单ID查询处理记录列表
    GetTicketsDisposeTicketsClassify: MicroServer.plusCrmWeb + '/ticketsClassify/search/list', // 根据工单ID查询未处理分类列表
    AddTicketsDisposeLog: MicroServer.plusCrmWeb + '/ticketsDisposeLog', // add记录列表
    GetTicketsCallbackLog: MicroServer.plusCrmWeb + '/ticketsCallbackLog/search/list', // 根据工单ID查询回访记录列表
    TicketsCallbackLog: MicroServer.plusCrmWeb + '/ticketsCallbackLog', // 根据工单ID查询回访记录列表
    // 报事报修- 报修
    GetTicketsRepairsListPage: MicroServer.plusCrmWeb + '/ticketsRepairs/search/page',
    TicketsRepairsSave: MicroServer.plusCrmWeb + '/ticketsRepairs',
    TicketsRepairsReplay: MicroServer.plusCrmWeb + '/ticketsRepairs/reply',

    DispatchMnrUpdateById: MicroServer.plusCrmWeb + '/dispatchMnr/updateById', // 修改分配人状态
    // 销售计划模板
    GetSalesTemplatePage: MicroServer.plusCrmWeb + '/salesTemplate/search/page',
    GetSalesTemplateSearchList: MicroServer.plusCrmWeb + '/salesTemplate/search/list',
    SalesTemplateSave: MicroServer.plusCrmWeb + '/salesTemplate/addSalesTemplate',
    SalesTemplateDel: MicroServer.plusCrmWeb + '/salesTemplate/',
    SalesTemplateDetail: MicroServer.plusCrmWeb + '/salesTemplate/detail/',
    SalesTemplateUpdate: MicroServer.plusCrmWeb + '/salesTemplate/updateSalesTemplate',
    SalesTemplateUpdateState: MicroServer.plusCrmWeb + '/salesTemplate/updateById',
    SalesTemplateSort: MicroServer.plusCrmWeb + '/salesTemplate/sort',
    // 订单详情
    GetTrackPlanRelativesList: MicroServer.plusCrmWeb + '/relatives/search/list', // 订单详情-各下拉设计师选项数据
    // 通道回调配置
    GetSeatIpConfigPage: MicroServer.plusCrmWeb + '/seatIpConfig/search/page',
    GetSeatIpConfigList: MicroServer.plusCrmWeb + '/seatIpConfig/search/list',
    SeatIpConfigSave: MicroServer.plusCrmWeb + '/seatIpConfig',
    SeatIpConfigDel: MicroServer.plusCrmWeb + '/seatIpConfig/',
    SeatIpConfigUpdate: MicroServer.plusCrmWeb + '/seatIpConfig/updateById',
    // 坐席配置
    GetSeatAccountPage: MicroServer.plusCrmWeb + '/seatAccount/search/page',
    GetSeatAccountList: MicroServer.plusCrmWeb + '/seatAccount/search/list',
    SeatAccountSave: MicroServer.plusCrmWeb + '/seatAccount',
    SeatAccountDel: MicroServer.plusCrmWeb + '/seatAccount/',
    SeatAccountUpdate: MicroServer.plusCrmWeb + '/seatAccount/updateById',
    //   智能外呼-通话记录
    GetAudioRecordPage: MicroServer.plusCrmWeb + '/audioRecord/search/page',
    ExportAudioRecord: MicroServer.plusCrmWeb + '/audioRecord/exportAudioRecord',
    AudioRecordConformity: MicroServer.plusCrmWeb + '/audioRecord/conformity',

    // 查看电话号码
    ViewPhoneByClueId: MicroServer.plusCrmWeb + '/clueInfo/viewPhone/',
    ViewPhoneBySource: MicroServer.plusCrmWeb + '/clueInfo/viewPhoneBySource/',

    //   智能外呼-呼叫管理
    UpdateLastCallTime: MicroServer.plusCrmWeb + '/clueInfo/update/lastCallTime/', //更新最近通话时间
    GetCallPage: MicroServer.plusCrmWeb + '/clueInfo/callPage',
    CallBatchReceive: MicroServer.plusCrmWeb + '/clueInfo/callBatchReceive', //领取线索
    UpdateClue: MicroServer.plusCrmWeb + '/clueInfo/updateClue', //
    GetClueDetail: MicroServer.plusCrmWeb + '/clueInfo/detail/', //
    CluePending: MicroServer.plusCrmWeb + '/clueInfo/cluePending', //提交待定
    CallValid: MicroServer.plusCrmWeb + '/clueInfo/callValid', //提交有效
    CallInvValid: MicroServer.plusCrmWeb + '/clueInfo/callInvValid', //提交无效
    startClueInvaildProcess: MicroServer.plusCrmWeb + '/flow/startClueInvaildProcess/{clueId}', // 线索提交无效
    startClueLostProcess: MicroServer.plusCrmWeb + '/flow/startClueLostProcess/{trackPlanId}', // 线索提交无效
    CallDispatchSales: MicroServer.plusCrmWeb + '/clueInfo/callDispatchSales', //派单
    CallAppointDispatch: MicroServer.plusCrmWeb + '/clueInfo/callAppointDispatch', //指定派单
    ClueFollowLogList: MicroServer.plusCrmWeb + '/followLog/search/list', //跟进日志
    ClueFollowLogAdd: MicroServer.plusCrmWeb + '/clueInfo/addFollowLog', //跟进日志
    AssignEmployee: MicroServer.plusCrmWeb + '/relatives/assignRelatives', //分配按钮-分配、改派员工（通用）
    QueryEmployeePage: MicroServer.plusCrmWeb + '/relatives/queryEmployee', //分配按钮-查询员工
    QueryAnchor: MicroServer.plusCrmWeb + '/relatives/queryAnchor/', //查直播业务相关人员
    // 改派
    QueryClueEmployeeForReassign: MicroServer.plusCrmWeb + '/relatives/queryEmployeeForReassign', //改派-查询员工（通用）
    ClueBizConver: MicroServer.plusCrmWeb + '/clueInfo/bizConver', //分配按钮- 保存
    // 商机运营
    ClueExport: MicroServer.plusCrmWeb + '/export/clue',
    GetCluePage: MicroServer.plusCrmWeb + '/clueInfo/cluePage',
    GetClueButton: MicroServer.plusCrmWeb + '/clueInfo/getButton/',
    GetEditBuildingPermission: MicroServer.plusCrmWeb + '/clueInfo/getEditBuildingPermission/',
    AddClue: MicroServer.plusCrmWeb + '/clueInfo/addClue',
    ClueBatchAssign: MicroServer.plusCrmWeb + '/relatives/batchAssign',
    GetTagsByClueId: MicroServer.plusCrmWeb + '/clueInfo/queryTags/',
    UpdateClueTag: MicroServer.plusCrmWeb + '/clueInfo/updateClueTag',
    GetSalesTemplateList: MicroServer.plusCrmWeb + '/salesTemplateNode/search/list',
    GetAllRelatives: MicroServer.plusCrmWeb + '/relatives/getAllRelatives/',
    ClueSalesValid: MicroServer.plusCrmWeb + '/clueInfo/salesValid', //提交有效
    ClueAppointment: MicroServer.plusCrmWeb + '/clueInfo/appointment', //预约到店
    AppointmentForCall: MicroServer.plusCrmWeb + '/clueInfo/appointmentForCall', //云客服邀约
    ClueConfirmToShop: MicroServer.plusCrmWeb + '/clueInfo/confirmToShop', //确认到店
    QueryClueDispatchFlag: MicroServer.plusCrmWeb + '/clueInfo/queryDispatchFlag/', //转设计-查询是否自动派单
    GetTrackDetailByClueId: MicroServer.plusCrmWeb + '/trackPlan/detailByClueId/', //转设计-查询是否自动派单
    GetBizTypes: MicroServer.plusCrmWeb + '/clueInfo/getBizTypes', //新增线索-需求类型
    // 营销公海池-无效列表
    SalesReceive: MicroServer.plusCrmWeb + '/clueInfo/salesReceive/', //领取线索
    SalesSeaDispatch: MicroServer.plusCrmWeb + '/clueInfo/salesSeaDispatch', //指定分配
    SalesSeaBatchDispatch: MicroServer.plusCrmWeb + '/clueInfo/salesSeaBatchDispatch', //批量指定分配
    SalesBatchReceive: MicroServer.plusCrmWeb + '/clueInfo/salesBatchReceive', //批量领取
    // 销运数据权限
    OrgPermissionsPage: MicroServer.plusCrmWeb + '/orgPermissions/search/page',
    OrgPermissionsSave: MicroServer.plusCrmWeb + '/orgPermissions/save',
    OrgPermissions: MicroServer.plusCrmWeb + '/orgPermissions/',
    OrgPermissionsUpdate: MicroServer.plusCrmWeb + '/orgPermissions/updateById',
    // 销运数据权限 -添加人员
    EmployeePermissionsPage: MicroServer.plusCrmWeb + '/employeePermissions/search/page',
    EmployeePermissionsSave: MicroServer.plusCrmWeb + '/employeePermissions/addUser',
    EmployeePermissions: MicroServer.plusCrmWeb + '/employeePermissions/',
    EmployeePermissionsUpdate: MicroServer.plusCrmWeb + '/employeePermissions/editPermissions',

    // 已入库线索
    GetAllCluePage: MicroServer.plusCrmWeb + '/clueInfo/allCluePage',
    AllClueExport: MicroServer.plusCrmWeb + '/export/allClue',
    // 飞单列表（设计公海池）
    GetInvalidPage: MicroServer.plusCrmWeb + '/trackPlan/invalidPage',
    GetTrackPlanButton: MicroServer.plusCrmWeb + '/trackPlan/getButton/', // 销售计划详情查询按钮
    // 派单异常
    GetDispatchExceptionPage: MicroServer.plusCrmWeb + '/clueInfo/dispatchExceptionPage',
    CallReceive: MicroServer.plusCrmWeb + '/clueInfo/callReceive/',
    DispatchClueAgain: MicroServer.plusCrmWeb + '/clueInfo/dispatchClueAgain',
    // 撞单异常
    GetCollisionPage: MicroServer.plusCrmWeb + '/clueInfo/collisionPage',
    // 无效列表
    GetClueInvalidPage: MicroServer.plusCrmWeb + '/clueInfo/clueInvalidPage',
    DesignerReceive: MicroServer.plusCrmWeb + '/trackPlan/designerReceive/', //领取
    LostDispatch: MicroServer.plusCrmWeb + '/trackPlan/lostDispatch', //指定分配
    LostBatchDispatch: MicroServer.plusCrmWeb + '/trackPlan/lostBatchDispatch', //批量指定分配
    DesignerBatchReceive: MicroServer.plusCrmWeb + '/trackPlan/designerBatchReceive', //批量领取

    GetDispatchMnrList: MicroServer.plusCrmWeb + '/dispatchMnr/search/list', // 区域
    GetSeatAccount: MicroServer.plusCrmWeb + '/seatAccount/getByUserId/', // 云客服坐席电话
    CheckRepeatByPhone: MicroServer.plusCrmWeb + '/clueInfo/checkRepeat/', // 查重

    DcpAppUserSearch: MicroServer.plusCrmWeb + '/dcpAppUser/search', // 酷家乐 - 列表
    DcpAppUser: MicroServer.plusCrmWeb + '/dcpAppUser', // 酷家乐 - 删除
    DcpAppUserDownLoad: MicroServer.plusCrmWeb + '/dcpAppUser/downloadTemplate', // 酷家乐 - 下载模板
    DcpAppUserClaim: MicroServer.plusCrmWeb + '/dcpAppUser/claim', // 酷家乐 - 领用账号
    DcpAppUserReturn: MicroServer.plusCrmWeb + '/dcpAppUser/return', // 酷家乐 - 释放账号
    DcpAppUserSearchList: MicroServer.plusCrmWeb + '/dcpAppUser/search/list', // 酷家乐 - 保存
    DcpAppUserIncrementalSyncKjl2Shj: MicroServer.plusCrmWeb + '/dcpAppUser/incrementalSyncKjl2Shj', // 酷家乐账号 - 更新酷家乐账户信息
    DcpAppUserBatchImport: MicroServer.plusCrmWeb + '/dcpAppUser/batchImport', //  酷家乐账号-导入
    DcpHiShjAccountSearch: MicroServer.plusCrmWeb + '/dcpHiShjAccount/search', //  酷家乐 - 领用记录列表
    DcpHiShjAccountExport: MicroServer.plusCrmWeb + '/dcpHiShjAccount/export', //  酷家乐 - 领用记录导出
    ReassignDesigner: MicroServer.plusCrmWeb + '/bizAssign/reAssign/assignDesigner/', //  改派 - 设计师
    ReassignCustomDesigner: MicroServer.plusCrmWeb + '/bizAssign/assignCustomDesigner/', //  改派 - 橱柜设计师 定制设计师
    ReassignAchievementDesigner: MicroServer.plusCrmWeb + '/bizAssign/assignAchievementDesigner/', //  改派 - 关联业绩设计师
    ReassignDesignServer: MicroServer.plusCrmWeb + '/bizOpRelatives/assign/designServer', //  改派 - 服务设计师
    GenerateIframeSrc: MicroServer.plusCrmWeb + '/dcpAppUser/generateIframeSrc', // 线索：去做酷家乐方案
    DcpDesignInfoSearchKjl: MicroServer.plusCrmWeb + '/dcpDesignInfo/searchKjl', //酷家乐方案列表
    DcpDesignInfoSearchOwnerCompany: MicroServer.plusCrmWeb + '/dcpAppUser/searchOwnerCompany', //酷家乐方案列表
    DcpBizOpDesignRelListBizOpDesignInfo:
      MicroServer.plusCrmWeb + '/dcpBizOpDesignRel/listBizOpDesignInfo', //酷家乐方案-已经绑定需求和方案1
    DcpBizOpDesignRelBindBizOp: MicroServer.plusCrmWeb + '/dcpBizOpDesignRel/bindBizOp', //酷家乐方案-绑定需求和方案
    SearchSelfDesignInfo: MicroServer.plusCrmWeb + '/dcpDesignInfo/searchSelfDesignInfo', //酷家乐方案列表-复制
    DcpDesignInfoSave: MicroServer.plusCrmWeb + '/dcpDesignInfo/copyDesign', //酷家乐方案列表-复制-保存
    DcpDesignInfoSave2: MicroServer.plusCrmWeb + '/dcpDesignInfo/copySelf2Business', //手动复制方案到企业空间-复制-保存
    // 提案大师
    FindMoaFlag: MicroServer.plusCrmWeb + '/trackPlan/findMoaFlag', //根据商机ID查询美学大师职责
    BizEdit: MicroServer.plusCrmWeb + '/trackPlan/updateById', //根据商机ID更新
    FindBaseBizOpInfoById: MicroServer.plusCrmWeb + '/trackPlan/search/list', //根据商机ID查询列表
    //销售工作台
    getAppointmentData: MicroServer.plusCrmWeb + '/clueInfo/getAppointmentData', //销售工作台-获取预约到店数据
    appointmentPage: MicroServer.plusCrmWeb + '/clueInfo/appointmentPage', //销售工作台-到店列表
    getTaskAll: MicroServer.plusCrmWeb + '/urgencyTask/getTaskAll', //销售工作台-获取全部紧急任务
    getTaskLimit: MicroServer.plusCrmWeb + '/urgencyTask/getTaskLimit', //销售工作台-获取限定数量紧急任务
    getTaskId: MicroServer.plusCrmWeb + '/urgencyTask/',
    salesWorkPage: MicroServer.plusCrmWeb + '/clueInfo/salesWorkPage',
    getBizStatus: MicroServer.plusCrmWeb + '/clueInfo/getBizStatus', //商机状态
    getBizOrder: MicroServer.plusCrmWeb + '/trackPlan/getBizOrder', //根据线索ID查询商机订单信息
    queryTrackPlan: MicroServer.plusCrmWeb + '/relatives/queryTrackPlan', //查询线索是否有指定需求标签的商机
    batchAssignDesigner: MicroServer.plusCrmWeb + '/relatives/batchAssignDesigner', //批量分配设计师
    // 去美学大师
    FindBizOpRelEmpVo: MicroServer.plusCrmWeb + '/relatives/getTrackPlanRelatives', //获取案例成员
    UpdateByIdCustomer: MicroServer.custTenantWeb + '/customer/updateKdCustomer', // 更新金额客户
    busFlowList: MicroServer.plusCrmWeb + '/busFlow/search/list',
  },
  PlusClueWeb: {
    // 入库前线索
    GetBeforeCluePage: MicroServer.plusClueWeb + '/baseClue/search/page',
    BeforeClueResend: MicroServer.plusClueWeb + '/baseClue/resend/', // 手动推送入库

    AddClue: MicroServer.plusClueWeb + '/channelClue/addClue', // 新增线索

    GetPlusEnums: MicroServer.plusClueWeb + '/enums/', //枚举值参数获取

    ClueInfoList: MicroServer.plusClueWeb + '/clueInfo/search/page', //线索列表
    ClueInfoDispatchClueAgain: MicroServer.plusClueWeb + '/clueInfo/dispatchClueAgain/', //线索 再次分配
    ClueInfoImportData: MicroServer.plusClueWeb + '/importData/search/page', //导入线索 分页
    ExportTemplate: MicroServer.plusClueWeb + '/importData/exportTemplate', //导入线索 模板下载
    ImportTemplate: MicroServer.plusClueWeb + '/importData/import', //导入线索 模板上传
    LaunchAccountSearchWithoutPermission:
      MicroServer.plusClueWeb + '/launchAccountQuery/search/page', //线索账号 -- 忽略权限
    LaunchAccountSearch: MicroServer.plusClueWeb + '/launchAccount/search/page', //线索账号
    LaunchAccountUpdateById: MicroServer.plusClueWeb + '/launchAccount/updateById', // 线索账号-保存
    LaunchAccountOperate: MicroServer.plusClueWeb + '/launchAccount', // 线索账号-增|删|查
    GetQvEnumAll: MicroServer.plusClueWeb + '/enums/', // 枚举值参数获取
    GetLaunchPlatformList: MicroServer.plusClueWeb + '/launchPlatform/getPlatformList', // 获取平台列表
    LaunchAccountChangeLogSearchPage: MicroServer.clue + '/launchAccountChangeLog/search/page', // 线索账号变更记录-分页列表
    LaunchAccountCashAllocationConfigSearchPage:
      MicroServer.clue + '/launchAccountCashAllocationConfig/search/page', // 投放账号现金消费配置-分页列表
    LaunchAccountCashAllocationConfigOperate:
      MicroServer.clue + '/launchAccountCashAllocationConfig', // 投放账号现金消费配置-增|删|查
    LaunchAccountCashAllocationConfigUpdateById:
      MicroServer.clue + '/launchAccountCashAllocationConfig/updateById', // 投放账号现金消费配置-编辑
    LaunchPlatformOperate: MicroServer.clue + '/launchPlatform', // 投放平台---增|删|查
    LaunchPlatformUpdateById: MicroServer.clue + '/launchPlatform/updateById', // 编辑投放平台
    LaunchPlatformSearchPage: MicroServer.clue + '/launchPlatform/search/page', //投放平台

    ChannelCategoryTree: MicroServer.plusClueWeb + '/channelCategory/select/tree', //渠道分类树
    GetChannelCategory: MicroServer.plusClueWeb + '/channelCategory/', //渠道分类 -- 根据ID查询
    ChannelCategoryInsert: MicroServer.plusClueWeb + '/channelCategory', //渠道分类 -- 添加
    ChannelCategoryUpdateById: MicroServer.plusClueWeb + '/channelCategory/updateById', //渠道分类 -- 编辑
    ChannelCategoryBatchUpdateStatus:
      MicroServer.plusClueWeb + '/channelCategory/batchUpdateStatus', //渠道分类 -- 批量更新分类状态

    GetChannelTypeById: MicroServer.plusClueWeb + '/channelType/', //军种 -- 根据ID查询
    ChannelTypeInsert: MicroServer.plusClueWeb + '/channelType', //军种 -- 添加
    ChannelTypeUpdateById: MicroServer.plusClueWeb + '/channelType/updateById', //军种 -- 编辑
    ChannelTypeDelete: MicroServer.plusClueWeb + '/channelType/', //军种 -- 删除
    ChannelTypeList: MicroServer.plusClueWeb + '/channelType/search/list', // 军种 -- 列表
    ChannelTypePage: MicroServer.plusClueWeb + '/channelType/search/page', //军种 -- 分页

    ChannelPage: MicroServer.plusClueWeb + '/channel/search/page', //渠道 -- 分页
    ChannelSave: MicroServer.plusClueWeb + '/channel/save', //渠道 -- 分页
    GetChannelById: MicroServer.plusClueWeb + '/channel/', //渠道 -- 根据ID查询
    ChannelChangeState: MicroServer.plusClueWeb + '/channel/switchChannelState/', //渠道 -- 切换状态

    ChannelLogPage: MicroServer.plusClueWeb + '/channelLog/search/page', // 渠道修改日志 - 列表

    ChannelMarkListByChannelId: MicroServer.plusClueWeb + '/channelMark/findByChannelId/', // 渠道标记 - 列表
    ChannelMarkSave: MicroServer.plusClueWeb + '/channelMark', // 渠道标记 - 添加
    ChannelMarkUpdateById: MicroServer.plusClueWeb + '/channelMark/updateById', // 渠道标记 - 编辑

    GetChannelTree: MicroServer.plusClueWeb + '/channelTree/select/tree', // 渠道树 - 查询渠道树
    GetChannelTreeWithAuthorize: MicroServer.plusClueWeb + '/channelTree/select/authorizeTree', // 渠道树 - 基于授权范围查询渠道树
    getChannelTree: MicroServer.plusClueWeb + '/channelTree/select/tree', //
    GetChannelBrandList: MicroServer.plusClueWeb + '/channelBrand/search/list', // 获取业务线列表
    GetChannelTypeIds: MicroServer.plusClueWeb + '/channelType/search/list', // 获取军种列表
    // 线索代理商
    GetLaunchAccountAgent: MicroServer.plusClueWeb + '/launchAccountAgent/search/list', // 获取代理商列表
    GetLaunchAccountAgentPage: MicroServer.plusClueWeb + '/launchAccountAgent/search/page', // 获取代理商
    LaunchAccountAgentAdd: MicroServer.plusClueWeb + '/launchAccountAgent',
    LaunchAccountAgentUpdateById: MicroServer.plusClueWeb + '/launchAccountAgent/updateById',
    DelLaunchAccountAgent: MicroServer.plusClueWeb + '/launchAccountAgent/',
    // 线索军种
    GetChannelType: MicroServer.plusClueWeb + '/channelType/search/list', // 获取军种列表
    GetChannelTypePage: MicroServer.plusClueWeb + '/channelType/search/page', // 获取军种
    // ChannelTypeUpdateById: MicroServer.plusClueWeb + '/channelType/updateById',
    ChannelTypeAdd: MicroServer.plusClueWeb + '/channelType',
    DelChannelType: MicroServer.plusClueWeb + '/channelType/',
    // 线索品牌
    GetChannelBrand: MicroServer.plusClueWeb + '/channelBrand/search/list', // 获取品牌列表
    GetChannelBrandPage: MicroServer.plusClueWeb + '/channelBrand/search/page', // 获取品牌
    ChannelBrandUpdateById: MicroServer.plusClueWeb + '/channelBrand/updateById',
    ChannelBrandAdd: MicroServer.plusClueWeb + '/channelBrand',
    DelChannelBrand: MicroServer.plusClueWeb + '/channelBrand/',
  },
  Config: {
    GetTenantConfig: MicroServer.config + '/tenant/config',
    // TenantLoginConfig: MicroServer.config + '/tenant/loginConfig', // 查询 / 修改租户登录配置
    GetRealEstateList: MicroServer.config + '/buildingInfo/search/list',
    FetchBusinessLineList: MicroServer.config + '/businessLine/search/list',
    EstateDeveloperExistsByName: MicroServer.config + '/estateDeveloper/existsByName', //检查开发商名称是否重名
    EstateDeveloper: MicroServer.config + '/estateDeveloper', // 开发商列表---增|删|查
    EstateDeveloperUpdateById: MicroServer.config + '/estateDeveloper/updateById', // 开发商列表---编辑
    EstateDeveloperSearchPage: MicroServer.config + '/estateDeveloper/search/page', // 开发商列表

    GetQvEnumConfigAll: MicroServer.config + '/qv/enum/all', // 枚举值参数获取
    GetOrgSaleProductTree: MicroServer.config + '/orgSaleProduct/getOrgSaleProductTree', // 组织销售产品配置 查询分页列表
    OrgSaleProductBatchAddOrgSaleProduct:
      MicroServer.config + '/orgSaleProduct/batchAddOrgSaleProduct', // 批量新增-组织与产品关系
    GetBusinessLinesList: MicroServer.config + '/businessLine/search/list', // 获取业务线列表
    GetTreeWithChannelList: MicroServer.config + '/channelCategory/treeWithChannel', // 获取渠道树列表
    GetCustomerSourceByCompony:
      MicroServer.config + '/channelCategory/findChannelCategoryTreeByOrg', //根据公司获取客户来源
    TreeWithChannel: MicroServer.config + '/channelCategory/treeWithChannel', //客户来源
    GetChannelMark: MicroServer.config + '/channelMark/findByChannelId', //渠道标记
    GetBusinessLine: MicroServer.config + '/businessLine/search/list', //业务线列表
  },
  Task: {
    CompensationSigningPage: MicroServer.task + '/commonBusinessTask/page',
  },
  UserWeb: {
    UcenterControlPanelAuth: MicroServer.userWeb + '/controlPanel/auth', // 认证
  },
  Crm: {
    TicketsListAccept: MicroServer.crm + '/ticketsList/accept',
    TicketsBack: MicroServer.crm + '/ticketsList/back',
    GetWorkerOrderDetail: MicroServer.crm + '/ticketsList/detail',
    FindBizState: MicroServer.crm + '/biz/findBizState/',
    GetCustomerInfo: MicroServer.crm + '/ticketsIssueList/getCustomerInfo',
    GetIssueDetail: MicroServer.crm + '/ticketsIssueList/',
    TicketsIssueListUpdate: MicroServer.crm + '/ticketsIssueList/updateById',
    TicketsIssueListAdd: MicroServer.crm + '/ticketsIssueList',
    GetTicketsChannelConfigTree: MicroServer.crm + '/ticketsChannelConfig/getTree',
    GetTicketsInternalConfigTree: MicroServer.crm + '/ticketsInternalConfig/getTree',
    GetTicketsExposureConfigTree: MicroServer.crm + '/ticketsExposureConfig/getTree',
    GetPhoneDecodeValue: MicroServer.crm + '/ticketsIssueList/viewPhone',
    AddOperatePhoneLog: MicroServer.crm + '/ticketsOperateLog',
  },
  Caas: {
    //标准版
    GetCompanyList: MicroServer.caas + '/company/search/page', // 组织-公司
    GetCompanyMrn: MicroServer.caas + '/employee/search/list', // 组织-公司-员工
    TagsCategory: MicroServer.caas + '/tagCategory/search/list', //用户标签分类
    TagsSearch: MicroServer.caas + '/tag/search/list', // 用户标签管理
    GetRolePage: MicroServer.caas + '/role/search/page', // 角色查询
    GetRoleList: MicroServer.caas + '/role/search/list', // 角色查询

    GetUserIdentities: MicroServer.caas + '/controlPanel/getUserIdentities', // 获取身份列表
    ChangeUserIdentity: MicroServer.caas + '/controlPanel/changeUserIdentity/', // 切换身份
    // 旧的
    FastFunctionMenuSettingList:
      MicroServer.caas + '/fastFunctionMenuSetting/userCollectFastMenuList',
    FastFunctionMenuSettingAddOrDel: MicroServer.caas + '/fastFunctionMenuSetting/collect',
    GetWorkerOrderDetail: MicroServer.caas + '/ticketsList/detail',
    GetCompany: MicroServer.caas + '/org/search/list',
    EmployeeCheck: MicroServer.caas + '/employee/employee/valid',
    GetEmployeeList: MicroServer.caas + '/employee/employee/search/page',
    ResetPassword: MicroServer.caas + '/loginAccount/resetPassword',
    GetPositionList: MicroServer.caas + '/departmentPosition/search/list',
    GetOrgList: MicroServer.caas + '/org/tree/list',
    GetDictService: MicroServer.plusProductWeb + '/dataDictionary/search/list',
    HttpCompanyList: MicroServer.caas + '/company/search/list',
    SelectcompanyByFront: MicroServer.caas + '/org/selectCompanyByFront', //获取公司列表+通用
    HttpOrgList: MicroServer.caas + '/org/search/list',
    SaasLogin: MicroServer.caas + '/controlPanel/grantAuthorization',
    // SaasQrCodeLogin: MicroServer.caas + '/wxControlPanel/loginByCode',
    // SaasQrCodeLogin: MicroServer.caas + '/wxControlPanel/{agentId}/loginByCode',
    SaasQrCodeLogin: MicroServer.caas + '/wxControlPanel/loginByCode', // code={code}
    SaasProfile: MicroServer.caas + '/controlPanel/profile',
    SendVerificationCode: MicroServer.caas + '/lostFound/sendVerificationCode',
    FoundPassword: MicroServer.caas + '/lostFound/foundPassword',
    // GetCurrentResources: MicroServer.caas + '/controlPanel/currentResources',
    GetCurrentResources: MicroServer.caas + '/controlPanel/currentResources',
    RefreshTokenApi: MicroServer.caas + '/controlPanel/refreshToken',
    ChangePosition: MicroServer.caas + '/controlPanel/changePost/',
    UpdatePassword: MicroServer.caas + '/controlPanel/updatePassword',
    GetPrivilegesComPany: MicroServer.caas + '/authorizeOrg/companies', //所有公司
    GetGeneralParamConfField: MicroServer.caas + '/generalParam/getGeneralParamConfField ', //参数配置 字段控制

    UcenterControlPanelAuth: MicroServer.caas + '/controlPanel/auth', // 认证
    // UcenterControlPanelAuthCode:
    //   MicroServer.caas + '/controlPanel/grantAuthorizationByAuthCode', // 登录

    UcenterControlPanelAuthCode: MicroServer.caas + '/controlPanel/auth', // 登录 多租户多身份
    GrantAuthorizationByAuthCode: MicroServer.caas + '/controlPanel/grantAuthorizationByAuthCode', // 登录 - 获取员工信息
    UcenterControlResetPassword: MicroServer.caas + '/controlPanel/resetPassword', // 重置密码
    resetPasswordWithRequireChangePassword:
      MicroServer.caas + '/controlPanel/resetPasswordWithRequireChangePassword', // 初次登录修改密码
    resetPasswordWithSendCode: MicroServer.caas + '/controlPanel/sendPhoneCodeNonAuth', // 忘记密码-发送验证码
    resetPasswordWithCheckCode: MicroServer.caas + '/controlPanel/verifyPhoneCodeNonAuth', // 忘记密码-验证验证码

    GetTenantList: MicroServer.caas + '/controlPanel/getTenants', // 租户list
    ChangeTenant: MicroServer.caas + '/controlPanel/changeTenant/', // 切换租户
    // 个人中心-编辑资料
    GetUCenterInfo: MicroServer.caas + '/controlPanel/profile',
    UCenterUpdateName: MicroServer.caas + '/controlPanel/updateName',
    UCenterVerifyPhoneCode: MicroServer.caas + '/controlPanel/verifyPhoneCode',
    UCenterUpdatePhone: MicroServer.caas + '/controlPanel/updatePhone',
    UCenterSendPhoneCode: MicroServer.caas + '/controlPanel/sendPhoneCode',
    UCenterSendPhoneCodeNonAuth: MicroServer.caas + '/controlPanel/sendPhoneCodeNonAuth',
    UCenterUpdatePassword: MicroServer.caas + '/controlPanel/updatePassword',
    updatePasswordByPhoneValidate: MicroServer.caas + '/controlPanel/updatePasswordByPhoneValidate',
    ControlPanel_sendUpdatePhoneCode: MicroServer.caas + '/controlPanel/sendUpdatePhoneCode',
    ControlPanel_updatePhone: MicroServer.caas + '/controlPanel/updatePhone',
    ControlPanel_sendUpdateMailCode: MicroServer.caas + '/controlPanel/sendUpdateMailCode',
    ControlPanel_updateMail: MicroServer.caas + '/controlPanel/updateMail',
    UCenterUpdateAvatar: MicroServer.caas + '/controlPanel/updateAvatar',

    GetUCenterFlowShortcutsList: MicroServer.caas + '/ucenter/appProcessFlow/search/list',
    // 应用
    GetUCenterAppTypeList: MicroServer.caas + '/ucenter/appCategory/list',
    GetUCenterAppList: MicroServer.caas + '/ucenter/app/search/list',
    GetUCenterAopMarketList: MicroServer.caas + '/ucenter/appMarket/search/list',
    GetUCenterApp: MicroServer.caas + '/ucenter/app/',
    GetUCenterAppDetail: MicroServer.caas + '/ucenter/app/detail/',

    AppCollect: MicroServer.caas + '/ucenter/appCollect/add', // /{appCode}/{type} // 添加收藏
    AppCollectRemove: MicroServer.caas + '/ucenter/appCollect/remove', // /{appCode}/{type} // 移除收藏
    AppCollectList: MicroServer.caas + '/ucenter/appCollect', // /{type} // 获取收藏列表

    SendLoginVerifyCode: MicroServer.caas + '/controlPanel/sendLoginVerifyCode', // 发送登录验证码
    DepartmentSearchList: MicroServer.caas + '/department/search/list', // 开发部门

    GetQueryDeptListt: MicroServer.caas + '/org/search/treeByParentId/', // 获取部门
    // GetQueryDeptListOther: MicroServer.plusPmWeb + '/laborEmployee/selectLaborEmployeeOrg', // 获取部门
    // GetValueByKey: MicroServer.caas + '/dataDictionary/getValueByKey/', // 获取数据字典
    // GetCompanyBranchList: MicroServer.caas + '/company/branch/list', // 获取门店列表
    // GetPrivilegesCompanyList: MicroServer.caas + `/company/privileges/list`, //获取门店

    GetDataDictionaryList: MicroServer.plusProductWeb + '/dataDictionary/search/list', // 门店管理 数据字典
    GetCompanySearchList: MicroServer.caas + '/company/search/list', // 获取公司列表
    EmployeeSearchList: MicroServer.caas + '/employee/employee/search/list', // 公司员工list
    EmployeeSearchByOrgIdList: MicroServer.caas + '/employee/getEmpsByCompanyIdAndRoleCodes/', // 公司员工list
    GetCompanyBranchList: MicroServer.caas + '/org/search/list', // 获取公司列表
    OrgList: MicroServer.caas + '/org/search/tree', //业务组织查询
    OrgTree: MicroServer.caas + '/authorizeOrg/orgTree', //带权限的业务组织查询
    GetEmployee: '/employee/search/page', //业务组织查询
    GetNoPrivilegesList: MicroServer.caas + '/authorizeEmployee/search/list',
    departmentTree: MicroServer.caas + '/department/search/tree/',
    FindSeatDeptCode: MicroServer.caas + '/department/queryDeptList/privileges', // 坐席部门列表
    DataDictionaryTree: MicroServer.caas + '/dataDictionary/tree',
    GetDepartPosPage: MicroServer.caas + '/employee/employee/departPos/page', //查询非营销员

    GetUserIdentityPage: MicroServer.caas + '/userIdentity/search/page', // 用户身份
    GetUserIdentityList: MicroServer.caas + '/userIdentity/search/list', // 用户身份

    getLoginParams: MicroServer.caas + '/wxControlPanel/getLoginParams', // 获取登录参数
    GetTags: MicroServer.caas + '/tag/search/list', // 用户标签
  },
  Clue: {
    FindByPhoneExt: MicroServer.clue + '/customer/findDetailByPhone/',
    AddClue: MicroServer.clue + '/clueInfo/receive/clue/add',
    GetPublicSeaDetail: MicroServer.clue + '/clueInfo/publicSeaDetail/',
    GetClueInfoDetail: MicroServer.clue + '/clueInfo/detail/',
    GetSeatAccountByWorkNumber: MicroServer.clue + '/seatAccount/getByWorkNumber/',
    UpdateClue: MicroServer.clue + '/clueInfo/updateClue', //线索：编辑
    SearchCustomerPage: MicroServer.clue + `/customer/search/page`,
    SearchClueInfoPage: MicroServer.clue + `/clueInfo/search/page`,
    GetCallCenterSignUpRegion: MicroServer.clue + '/clueInfo/company/city',
    GetCallCenterDateRangeEnum: MicroServer.plusCrmWeb + '/clueInfo/getDateRangeEnum',
    getCallCenterClueRelatives: MicroServer.clue + '/clueInfo/getClueRelatives',
    AddCallCenterClue: MicroServer.clue + '/clue/artificial_clue',
    GetCallCenterSeatByDeptCode: MicroServer.clue + '/clueInfo/findSeatByDeptCode',
    GetCallCenterPage: MicroServer.clue + '/clueInfo/listByCall',
    GetCallCenterCount: MicroServer.clue + '/clueInfo/listByCallCount',
    GetCallCenterDetail: MicroServer.clue + '/clueInfo/detail',
    GetCallCenterLogList: MicroServer.clue + '/clueLog/search/list',
    AddCallCenterLog: MicroServer.clue + '/clueLog',
    CallCenterDispatch: MicroServer.clue + '/clueInfo/clue/manual/dispatch/sale',
    AddCallCenterAudio: MicroServer.clue + '/audioRecord/addAudio',
    CallCenterClueInfoBatchReceive: MicroServer.clue + '/clueInfo/clue/batchReceive',
    GetCallCenterSeatAccountByWorkNumber: MicroServer.clue + '/seatAccount/getByWorkNumber',
    ClueSubmitValid: MicroServer.clue + '/clueInfo/clue/submitValid', //呼叫管理-提交有效
    GetSeatAccountPage: MicroServer.clue + '/seatAccount/page',
    UpdateSeatAccountBindState: MicroServer.clue + '/seatAccount/updateBind',
    UpdateLastCallTime: MicroServer.clue + '/clueInfo/update/lastCallTime',
    QueryCallUser: MicroServer.clue + '/clueInfo/queryCallUser/', //云客服

    CreatePromoteLink: MicroServer.clue + '/link/createLink',
    QueryAnchor: MicroServer.clue + '/clueInfo/queryAnchor', //查直播业务相关人员
    updateById: MicroServer.clue + '/clueInfoDtl/updateClueDtl', //根据Id编辑数据
    ClueSubmitInvalid: MicroServer.clue + '/clueInfo/clue/submit/invalid', //呼叫管理-提交无效
    PendingClue: MicroServer.clue + '/clueInfo/clue/pending', //提交待定--提交
    QWueryEcommerce: MicroServer.clue + '/clueInfo/queryEcommerce/', //电商专员
    QuerySalesMan: MicroServer.clue + '/clueInfo/querySalesMan/', //营销员
    ClueDispatch: MicroServer.clue + '/clueInfo/clue/appoint/dispatch', //指定派单-改派营销员
  },
  Report: {
    GetCompany: MicroServer.report + '/company/branch/list',
    GalleryGetData: MicroServer.report + '/gallery/getData',
    WeatherCurrent: MicroServer.report + '/weather/current',
    StaffSatisfactionReport: MicroServer.report + '/member/report/staffSatisfactionReport', //满意度报表-员工维度
    CompanySatisfactionReport: MicroServer.report + '/member/report/companySatisfactionReport', //满意度报表-城市维度
    // 外呼工作量
    GetSeatWorkload: MicroServer.report + '/crm/audioRecord/seatWorkload',
    // 通话监控
    GetMonitor: MicroServer.report + '/crm/audioRecord/monitor',
  },
  Portal: {
    HttpGetPswKey: MicroServer.portal + '/sys/getPasswordKey',
    HttpLogin: MicroServer.portal + '/sys/auth',
    FetchUnifiedProfile: MicroServer.portal + '/sys/unifiedProfile',
  },
  File: {
    // FetchUnifiedProfile: MicroServer.file + '/fileStoreConfig/getFileUrlPrefix',
    UploadFile: MicroServer.file + '/file/upload',
    // FileStoreConfigGetFileUrlPrefix: MicroServer.file + '/fileStoreConfig/getFileUrlPrefix', // 获取文件前缀
    FetchUnifiedProfile: MicroServer.file + '/file/getConfig', // 获取文件前缀
  },
  Export: {
    DownloadPage: MicroServer.export + '/asyncImportExportTask/search/page',
    DeleteExportTask: MicroServer.export + '/asyncImportExportTask/',
    AsyncImportExportTaskRetry: MicroServer.export + '/asyncImportExportTask/retry/',
    AsyncImportExportTaskUpdateById: MicroServer.export + '/asyncImportExportTask/updateById',
    ExportDownCount: MicroServer.export + '/asyncImportExportTask/downCount',
    downloadExcel: MicroServer.export + '/asyncImportExportTask/downloadExcel', //评价记录导出

    // 线索-导出
    ImportExportTaskDownloadExcel: MicroServer.export + '/asyncImportExportTask/downloadExcel',
  },
  Platform: {
    GetPlatformWebConfig: MicroServer.platform + '/config',
    PlatformLogin: MicroServer.platform + '/controlPanel/grantAuthorization',
    GetBanksList: MicroServer.platform + '/bankCommons/bank/search/page', // 银行
    GetBanksAreasList: MicroServer.platform + '/bankCommons/bankArea/search/page', // 地区
    GetBanksLocationsList: MicroServer.platform + '/bankCommons/bankBranch/search/page', // 支行
    GetRegionList: MicroServer.platform + '/region/region/', //公共接口 地区
    GetRegionTree: MicroServer.platform + '/region/regionCommons/tree', //公共接口 地区树
    GetRegionLists: MicroServer.platform + '/region/regionCommons/cities', //公共接口 地区列表
    DataDictionary: MicroServer.platform + '/dataDictionary/dataDictionaryCommons/search/page', //数据字典
    DataDictionaryList: MicroServer.platform + '/dataDictionary/dataDictionaryCommons/search/list', //数据字典
    regionCommons: MicroServer.platform + '/region/regionCommons/tree', //获取完整地区树
    regionChildren: MicroServer.platform + '/region/regionCommons',
    GetBankList: MicroServer.platform + '/bankCommons/bank/search/list', //银行列表
    GetBankAreaList: MicroServer.platform + '/bankCommons/bankArea/search/list', //银行地区
    GetBankBranchList: MicroServer.platform + '/bankCommons/bankBranch/search/list', //银行网点
  },
  Base: {
    GetEmpowerBatchAuthList: '/batchAuthz/list',
  },
  PNS: {
    getLastMessage: MicroServer.pns + '/message/getLastMessage', // 获取消息 对话列表
    getMessages: MicroServer.pns + '/message/getMessages', // /{size} 获取消息列表
    getUnReadCount: MicroServer.pns + '/message/getUnReadCount', // ?fromType=App&fromId=xxxx 获取未读消息数量
  },
  WorkOrder: {
    GetTodoList: MicroServer.workOrder + '/todo/appTodo', // 查询待办列表
    GetTodoItem: MicroServer.workOrder + '/todo/list', // 查询待办详情
    GetFollowAppList: MicroServer.workOrder + '/follow/appList', // 查询我关注的待办
    GetFollowList: MicroServer.workOrder + '/follow/list', // 查询我关注的流程列表 
    GetTodoCount: MicroServer.workOrder + '/todo/count', // 待办数量
    GetJumpUrl: MicroServer.workOrder + '/todo/jumpUrl', // /{id} 获取跳转URL
    GetWorkOrder: MicroServer.workOrder + '/workorder/{id}', // 根据id查询单条
  },
  Cache: {
    mapByKeysForAuth: MicroServer.cacheWeb + '/cacheAuth/mapByKeysForAuth', // map-批量key查询-授权
    batchSaveOrUpdateForAuth: MicroServer.cacheWeb + '/cacheAuth/batchSaveOrUpdateForAuth', // 批量保存或者修改缓存-授权
    batchGetForAuth: MicroServer.cacheWeb + '/cacheAuth/mapByKeysForAuth', // 批量查询 缓存数据
  },
  Vms: {
    VendorRuleUnReadPage: MicroServer.vmsWeb + '/vendorRule/unRead/page', // 供应商制度
    VendorRuleViewTimes: MicroServer.vmsWeb + '/vendorRuleViewTimes/saveOrUpdateInfo ', // 供应商制度
  },
  plusPmWeb: {
    SelectLaborEmployeeResponse:
      MicroServer.plusPmWeb + '/laborEmployee/selectLaborEmployeeResponse', //查询成员、承包商相关信息
    WorkTypePageAdd: MicroServer.plusPmWeb + '/workType/addOrUpdateWorkType', // 工种列表 新增编辑
    NewInsurAccountsId: MicroServer.plusPmWeb + '/newInsurAccounts', //保险通过id查询
    PrintConfigSearchList: MicroServer.plusPmWeb + '/printConfig/search/list', //配置中心-打印模板配置-列表
    GetQvEnumTamsAll: MicroServer.plusPmWeb + '/enums', // 枚举值参数获取
    VendorInfoSelectByVoderCode: MicroServer.plusPmWeb + '/vendorInfo/selectByVoderCode', //企业资料---根据承包商编码获取门店相关信息
    vendorInfoList: MicroServer.plusPmWeb + '/vendorInfo/findVendorInfoList', //承包商列表-不分页
    GetWorkTypeSearchList: MicroServer.plusPmWeb + '/workType/search/list', //费用管理-工费列表-技能标签下拉
    ProjectExternalEmployeeList: MicroServer.plusPmWeb + '/projectExternalEmployee/searchPage', //工人管理列表
    ProjectExternalEmployeeDetail:
      MicroServer.plusPmWeb + '/projectExternalEmployee/findProjectExternalEmployeeByExtEmpId', //工人管理列表-详情
    FindExtContractByExtEmpId:
      MicroServer.plusPmWeb + '/projectExternalEmployee/findExtContractByExtEmpId', //工人管理-工人详情-合同列表
    FindExtAccountByExtEmpId:
      MicroServer.plusPmWeb + '/projectExternalEmployee/findExtAccountByExtEmpId', //工人-银行卡-列表查询
    AddExtAccountByExtEmpId:
      MicroServer.plusPmWeb + '/projectExternalEmployee/addExtAccountByExtEmpId', //工人-银行卡-银行卡添加
    EditExtAccount: MicroServer.plusPmWeb + '/projectExternalEmployee/editExtAccount', //工人-银行卡-银行卡编辑
    findExtAccountById: MicroServer.plusPmWeb + '/projectExternalEmployee/findExtAccountById',
    DeleteExtAccountById: MicroServer.plusPmWeb + '/projectExternalEmployee/deleteExtAccountById', //工人-银行卡-删除
    InsertProjectExternalEmployee:
      MicroServer.plusPmWeb + '/projectExternalEmployee/insertOrUpdate', //工人管理列表-新增
    UpdateExtActStatusByExtEmpId:
      MicroServer.plusPmWeb + '/projectExternalEmployee/updateExtActStatusByExtEmpId', //工人管理-工人详情-离职/启用
    EditFile: MicroServer.plusPmWeb + '/projectExternalEmployee/editFile', //工人管理-工人详情-附件编辑
    SaveContractProjectExternalEmployee:
      MicroServer.plusPmWeb + '/projectExternalEmployee/saveContract', //新增合同
    DeleteContractById: MicroServer.plusPmWeb + '/projectExternalEmployee/deleteContractById', //人管理-工人详情-删除合同
    findExtEmpOrgByExtEmpId:
      MicroServer.plusPmWeb + '/projectExternalEmployee/findExtEmpOrgByExtEmpId', //工人管理-工人详情-查询用户组织
    deleteEmpOrg: MicroServer.plusPmWeb + '/projectExternalEmployee/deleteEmpOrgById', //工人管理-工人详情-删除用户组织id
    saveOrUpdateEmpOrg: MicroServer.plusPmWeb + '/projectExternalEmployee/saveOrUpdateEmpOrg', //工人管理-工人详情-用户组织启用禁用新增
    searchEmpList: MicroServer.plusPmWeb + '/projectExternalEmployee/searchEmpList', //工人管理-工人详情-推荐人查询
    FindAccountsPageByRequest: MicroServer.plusPmWeb + '/insurAccounts/findAccountsPage', //保险账户查询
    ManualAddBlance: MicroServer.plusPmWeb + '/insurAccounts/manualAddBlance', //手动充值
    UpdateInsuranceStatus: MicroServer.plusPmWeb + '/insurAccounts/updateRenewalStatus', //保险管理列表-修改续保状态接口
    FindAccountsDtlPageByRequest: MicroServer.plusPmWeb + '/insurAccounts/findInsurPayLogPage', //账户流水列表
    FindAccountsDtlPage: MicroServer.plusPmWeb + '/insurAccounts/findAccountsDtlPage', //投保记录列表
    NewInsurAccountsFindConfPageByRequest: MicroServer.plusPmWeb + '/insurAccounts/findConfPage', //保险管理-保险配置-分页查询
    AddInsurAccount: MicroServer.plusPmWeb + '/insurAccounts/addInsurAccount', //保险账户-列表页面-初始化账户
    NewInsurAccountsDeleteById: MicroServer.plusPmWeb + '/insurAccounts/deleteConfigById', //保险管理-保险配置-根据Id删除数据
    ManualDiscountInsurAmountFromAccount:
      MicroServer.plusPmWeb + '/insurAccounts/manualDiscountInsurAmountFromAccount', //保险账户-手动续保
    NewInsurAccountsDetail: MicroServer.plusPmWeb + '/insurAccounts/findConfById', //保险管理-保险配置-详情
    NewInsurAccountsInsertConfBatch: MicroServer.plusPmWeb + '/insurAccounts/insertConf', //保险管理-保险配置-新增
    NewInsurAccountsUpdateConfigStatus: MicroServer.plusPmWeb + '/insurAccounts/editConf', //保险管理-保险配置-编辑
    QualityMoneyAccountPage: MicroServer.plusPmWeb + '/quaMoneyAccount/findAccountPage', //质保金账户-查询分页
    QualityMoneyAccountById: MicroServer.plusPmWeb + '/quaMoneyAccount/findAccountById', //质保金账户-根据id查询详情
    QualityMoneyAccountDetailPage: MicroServer.plusPmWeb + '/quaMoneyAccount/findAccountDetailPage', //质保金账户-明细分页查询
    RealRetreatQualityMoney: MicroServer.plusPmWeb + '/quaMoneyAccount/realRetreatQualityMoney', //质保金账户-退质保金
    QualityMoneyConfigDelete: MicroServer.plusPmWeb + '/quaMoneyAccount/deleteConfigById', //质保金账户-质保金配置-根据Id删除数据
    QualityMoneyConfigSave: MicroServer.plusPmWeb + '/quaMoneyAccount/addQualityMoneyAccount', //质保金-质保金明细-新增质保金
    AddAccountDetail: MicroServer.plusPmWeb + '/quaMoneyAccount/addAccountDetail', //质保金-质保金明细-新增质保金明细
    QualityMoneyConfigPage: MicroServer.plusPmWeb + '/quaMoneyAccount/findConfigPage', //质保金账户-质保金配置-分页查询
    QualityMoneyConfigSelectAllById: MicroServer.plusPmWeb + '/qualityMoneyConfig/selectAllById/', //质保金账户-质保金配置-根据Id查询数据
    FindConfigById: MicroServer.plusPmWeb + '/quaMoneyAccount/findConfigById', //质保金-质保金配置-根据ID查询配置
    SaveConfig: MicroServer.plusPmWeb + '/quaMoneyAccount/saveConfig', //质保金-质保金配置-配置保存
    FindProjectExternalEmployeeList:
      MicroServer.plusPmWeb + '/projectExternalEmployee/findProjectExternalEmployeeList', //工人管理-质保金-补充账户查询
    VendorInfoPage: MicroServer.plusPmWeb + '/vendorInfo/findVendorInfoPage', // 承包商列表
    FindVendorInfoOne: MicroServer.plusPmWeb + '/vendorInfo/findVendorInfoOne', // 承包商-承包商配置-根据ID查询
    VendorInfoAddOrUpdate: MicroServer.plusPmWeb + '/vendorInfo/insertOrUpdateVendorInfo', // 承包商
    VendorInfoAttestationInfo: MicroServer.plusPmWeb + '/vendorInfo/attestationInfo', //承包商-商家认证
    FindNodeConfig: MicroServer.plusPmWeb + '/serviceNodeConfig/findNodeConfig', //客户服务配置-节点管理-列表节点
    insertOrUpdateNodeConfig: MicroServer.plusPmWeb + '/serviceNodeConfig/insertOrUpdateNodeConfig', //服务配置-节点管理-新增节点
    FindNodeConfigById: MicroServer.plusPmWeb + '/serviceNodeConfig/findNodeConfigById', //服务配置-节点管理-ID查询
    DeleteNodeConfigById: MicroServer.plusPmWeb + '/serviceNodeConfig/deleteNodeConfigById', //服务配置-节点管理-删除节点
    FindServiceNodeConfig: MicroServer.plusPmWeb + '/serviceNodeConfig/findServiceNodeConfig', //服务配置-客户服务列表-新增服务
    FindServiceNodeConfigById:
      MicroServer.plusPmWeb + '/serviceNodeConfig/findServiceNodeConfigById', //服务配置-客户服务配置-根据ID查询
    InsertOrUpdateServiceNodeConfig:
      MicroServer.plusPmWeb + '/serviceNodeConfig/insertOrUpdateServiceNodeConfig', //服务配置-客户服务配置-新增/编辑服务
    DeleteServiceNodeConfigById:
      MicroServer.plusPmWeb + '/serviceNodeConfig/deleteServiceNodeConfigById', //服务配置-客户服务配置-删除
    FindServiceNodeConfigDtlById:
      MicroServer.plusPmWeb + '/serviceNodeConfig/findServiceNodeConfigDtlById', //服务配置-客户服务详情-ID查询
    FindServiceNodeConfigDtl: MicroServer.plusPmWeb + '/serviceNodeConfig/findServiceNodeConfigDtl', //服务配置-客户服务详情-列表
    sortNumServiceNodeConfigDtl:
      MicroServer.plusPmWeb + '/serviceNodeConfig/sortNumServiceNodeConfigDtl', //服务配置-客户服务详情-排序
    DeleteServiceNodeConfigDtlById:
      MicroServer.plusPmWeb + '/serviceNodeConfig/deleteServiceNodeConfigDtlById', //服务配置-客户服务详情-删除详情
    InsertOrUpdateServiceNodeConfigDtl:
      MicroServer.plusPmWeb + '/serviceNodeConfig/insertOrUpdateServiceNodeConfigDtl', //服务配置-客户服务详情-新增/编辑详情
    CopyServiceNodeConfig: MicroServer.plusPmWeb + '/serviceNodeConfig/copyServiceNodeConfig', //服务配置-客户服务列表-新增服务
    OrgList: MicroServer.plusPmWeb + '/projectExternalEmployee/searchOrgList', //业务组织查询
    SearchCompanyList: MicroServer.plusPmWeb + '/projectExternalEmployee/searchCompanyList', //公司查询
    findProjectExternalEmployeeByExtEmpId:
      MicroServer.plusPmWeb + 'projectExternalEmployee/findProjectExternalEmployeeByExtEmpId', //承包商处理
    FindServiceId: MicroServer.plusPmWeb + '/serviceNodePlan/findServiceId', //承包商处理
    ManualSendEdoc: MicroServer.plusPmWeb + '/extContractInfo/manualSendEdoc', //手动续签-发起电子合同前端接口
    SyncOutsourcingSyncKd: MicroServer.plusPmWeb + '/projectExternalEmployee/syncOutsourcingSyncKd', // 同步金蝶
  },
  PlatformWeb: {
    GetDataDictionaryChildren:
      MicroServer.platformWeb + '/dataDictionary/dataDictionary/search/list', //
  },
  PlusProductWeb: {
    GetEnums: MicroServer.plusProductWeb + '/enums/',
    // 数据字典
    GetDataDictionaryList: MicroServer.plusProductWeb + '/dataDictionary/search/list',
    GetDataDictionaryChildren: MicroServer.plusProductWeb + '/dataDictionary/getChildrenDicts', // 批量获取字典数据
    // 参数管理
    GetArgPage: MicroServer.plusProductWeb + '/argManage/search/page',
    GetArgList: MicroServer.plusProductWeb + '/argManage/search/list',
    ArgSave: MicroServer.plusProductWeb + '/argManage',
    ArgUpdateById: MicroServer.plusProductWeb + '/argManage/updateById',
    ArgDelete: MicroServer.plusProductWeb + '/argManage/',
    ArgUpdateState: MicroServer.plusProductWeb + '/argManage/updateState',
    // 项目管理
    GetProjectPage: MicroServer.plusProductWeb + '/itemManage/search/page',
    GetProjectList: MicroServer.plusProductWeb + '/itemManage/search/list',
    ProjectSave: MicroServer.plusProductWeb + '/itemManage',
    ProjectUpdateState: MicroServer.plusProductWeb + '/itemManage/updateState',
    ProjectUpdateById: MicroServer.plusProductWeb + '/itemManage/updateById',
    ProjectDelete: MicroServer.plusProductWeb + '/itemManage/',
    // 价格计算
    priceCalculatePriceCalculate: MicroServer.plusProductWeb + '/priceCalculate/priceCalculate',
    querySkuPricePage: MicroServer.plusProductWeb + '/priceCalculate/querySkuPricePage', // 价格查询列表
    GetAuthSkuCount: MicroServer.plusProductWeb + '/productSku/search/count', // sku数量
    getBatchSize: MicroServer.plusProductWeb + '/priceExportRecord/getBatchSize', // 拉价格数据导出限制条数
    priceExportRecord: MicroServer.plusProductWeb + '/priceExportRecord/submit', // 提交导出记录
    getPriceExportRecord: MicroServer.plusProductWeb + '/priceExportRecord/search/list', // 查询分批导出记录
    doExport: MicroServer.plusProductWeb + '/priceExportRecord/doExport', // 执行导出
    exportQuerySkuPriceExcel: MicroServer.plusProductWeb + '/priceCalculate/exportQuerySkuPriceExcel', // 直接导出
    productSearchList: MicroServer.plusProductWeb + '/product/search/list',
    // 品牌管理
    GetBrandPage: MicroServer.plusProductWeb + '/brand/search/page',
    GetBrandList: MicroServer.plusProductWeb + '/brand/search/list',
    BrandSave: MicroServer.plusProductWeb + '/brand',
    BrandUpdateState: MicroServer.plusProductWeb + '/brand/updateState',
    BrandUpdateById: MicroServer.plusProductWeb + '/brand/updateById',
    BrandDelete: MicroServer.plusProductWeb + '/brand/',
    // 业务字典
    GetBusinessDictPage: MicroServer.plusProductWeb + '/dataDictionary/search/page',
    GetBusinessDictList: MicroServer.plusProductWeb + '/dataDictionary/findList',
    BusinessDictSave: MicroServer.plusProductWeb + '/dataDictionary',
    BusinessDictUpdateState: MicroServer.plusProductWeb + '/dataDictionary/updateState',
    BusinessDictUpdateById: MicroServer.plusProductWeb + '/dataDictionary/updateById',
    BusinessDictDelete: MicroServer.plusProductWeb + '/dataDictionary/',
    // 费用项管理
    GetPriceItemPage: MicroServer.plusProductWeb + '/priceItemManage/search/page',
    GetPriceItemList: MicroServer.plusProductWeb + '/priceItemManage/search/list',
    PriceItemSave: MicroServer.plusProductWeb + '/priceItemManage',
    PriceItemUpdateState: MicroServer.plusProductWeb + '/priceItemManage/updateState',
    PriceItemUpdateShowFlag: MicroServer.plusProductWeb + '/priceItemManage/updateShowFlag',
    PriceItemUpdateById: MicroServer.plusProductWeb + '/priceItemManage/updateById',
    PriceItemDelete: MicroServer.plusProductWeb + '/priceItemManage/',
    PriceItemImportFile: MicroServer.plusProductWeb + '/priceImportFees/importFile',
    // 费用项管理 - 特殊配置
    GetPriceItemSpecialConfigPage: MicroServer.plusProductWeb + '/priceSpecialConfig/search/page',
    GetPriceItemSpecialConfigList: MicroServer.plusProductWeb + '/priceSpecialConfig/search/list',
    PriceItemSpecialConfigSave: MicroServer.plusProductWeb + '/priceSpecialConfig/saveInfo',
    PriceItemSpecialConfigUpdateById: MicroServer.plusProductWeb + '/priceSpecialConfig/updateById',
    PriceItemSpecialConfigDelete: MicroServer.plusProductWeb + '/priceSpecialConfig/',
    PriceItemSpecialConfigBatchDelete:
      MicroServer.plusProductWeb + '/priceSpecialConfig/deleteBatch',
    PriceItemSpecialConfigDownload:
      MicroServer.plusProductWeb + '/priceSpecialConfig/templateDownload',
    PriceItemSpecialConfigImport: MicroServer.plusProductWeb + '/priceSpecialConfig/importFile',
    // 费用项管理 - 导入费用
    GetPriceImportFeesPage: MicroServer.plusProductWeb + '/priceImportFees/search/page',
    PriceImportFeesUpdateById: MicroServer.plusProductWeb + '/priceImportFees/updateById',
    PriceImportFeesBatchDelete: MicroServer.plusProductWeb + '/priceImportFees/deleteBatch',
    PriceImportFeesDownload: MicroServer.plusProductWeb + '/priceImportFees/templateDownload',
    PriceImportFeesImport: MicroServer.plusProductWeb + '/priceImportFees/importFile',
    PriceImportFeesBatchImport: MicroServer.plusProductWeb + '/priceItemManage/import', //批量导入
    PriceImportFeesBatchExport: MicroServer.plusProductWeb + '/priceItemManage/export',//批量导出
    // 费用项管理 - 导入费用 限购类型
    GetPriceLimitImportFeesPage: MicroServer.plusProductWeb + '/priceLimitImportFees/search/page',
    PriceLimitImportFeesUpdateById: MicroServer.plusProductWeb + '/priceLimitImportFees/updateById',
    PriceLimitImportFeesBatchDelete: MicroServer.plusProductWeb + '/priceLimitImportFees/batch',
    PriceLimitImportFeesDownload:
      MicroServer.plusProductWeb + '/priceLimitImportFees/templateDownload',
    PriceLimitImportFeesImport: MicroServer.plusProductWeb + '/priceLimitImportFees/import',
    // 通项管理
    GetGeneralPage: MicroServer.plusProductWeb + '/generalItemManage/search/page',
    GetGeneralList: MicroServer.plusProductWeb + '/generalItemManage/search/list',
    GeneralSave: MicroServer.plusProductWeb + '/generalItemManage',
    GeneralUpdateState: MicroServer.plusProductWeb + '/generalItemManage/updateState',
    GeneralUpdateById: MicroServer.plusProductWeb + '/generalItemManage/updateById',
    GeneralDelete: MicroServer.plusProductWeb + '/generalItemManage/',
    GeneralTemplateBatchDownload:
      MicroServer.plusProductWeb + '/generalStandard/templateBatchDownload',
    GeneralImportBatchFile: MicroServer.plusProductWeb + '/generalStandard/importBatchFile',
    // 通项管理 - 标配
    GetGeneralStandardPage: MicroServer.plusProductWeb + '/generalStandard/search/page',
    GetGeneralStandardList: MicroServer.plusProductWeb + '/generalStandard/search/list',
    GeneralStandardSave: MicroServer.plusProductWeb + '/generalStandard',
    GeneralStandardUpdateState: MicroServer.plusProductWeb + '/generalStandard/updateState',
    GeneralStandardUpdateById: MicroServer.plusProductWeb + '/generalStandard/updateById',
    GeneralStandardDelete: MicroServer.plusProductWeb + '/generalStandard/',
    SaveBatchList: MicroServer.plusProductWeb + '/generalStandard/saveBatchList',
    GeneralStandardImportFile: MicroServer.plusProductWeb + '/generalStandard/importFile',
    GeneralStandardExportFile: MicroServer.plusProductWeb + '/generalStandard/templateDownload',
    GeneralStandardBatchAdd: MicroServer.plusProductWeb + '/generalStandard/batchAdd', //  批量添加通项标配
    //  标配-迭代新增接口
    GeneralStandardBatchUpdateDate: MicroServer.plusProductWeb + '/generalStandard/batchUpdateDate', //  批量修改日期
    GeneralStandardExport: MicroServer.plusProductWeb + '/generalStandard/export', //  导出
    GeneralStandardCopy: MicroServer.plusProductWeb + '/generalStandard/copy', //  复制
    GeneralStandardSaveBatchListV2: MicroServer.plusProductWeb + '/generalStandard/saveBatchListV2', //  新增

    // 产品分类管理
    GetProductCategoryTreeList: MicroServer.plusProductWeb + '/productCategory/search/tree',
    ProductCategorySave: MicroServer.plusProductWeb + '/productCategory',
    ProductCategoryUpdateState: MicroServer.plusProductWeb + '/prodCateTree/updateState',
    ProductCategoryUpdateById: MicroServer.plusProductWeb + '/productCategory/updateById',
    ProductCategoryDelete: MicroServer.plusProductWeb + '/productCategory/',
    ProductCategoryTemplateDownload:
      MicroServer.plusProductWeb + '/productCategory/templateDownload', //下载导入模板
    ProductCategoryImportCategory: MicroServer.plusProductWeb + '/productCategory/importCategory', // 批量导入
    // 价格策略 - 提点率
    GetPriceBoostRatePage: MicroServer.plusProductWeb + '/priceBoostRate/search/page',
    PriceBoostRateSave: MicroServer.plusProductWeb + '/priceBoostRate/batSavePriceBoostRate',
    PriceBoostRateUpdateById: MicroServer.plusProductWeb + '/priceBoostRate/updateById',
    PriceBoostRateDelete: MicroServer.plusProductWeb + '/priceBoostRate/',
    PriceBoostRateBatchDelete: MicroServer.plusProductWeb + '/priceBoostRate',
    PriceBoostRateDownload: MicroServer.plusProductWeb + '/priceBoostRate/templateDownload',
    PriceBoostRateImport: MicroServer.plusProductWeb + '/priceBoostRate/importFile',
    // 价格策略 - 项目经理利率
    GetPriceProManagerRatePage: MicroServer.plusProductWeb + '/pricePromngRate/search/page',
    PriceProManagerRateSave: MicroServer.plusProductWeb + '/pricePromngRate/batSavePricePromngRate',
    PriceProManagerRateUpdateById: MicroServer.plusProductWeb + '/pricePromngRate/updateById',
    PriceProManagerRateDelete: MicroServer.plusProductWeb + '/pricePromngRate/',
    PriceProManagerRateBatchDelete: MicroServer.plusProductWeb + '/pricePromngRate',
    PriceProManagerRateDownload: MicroServer.plusProductWeb + '/pricePromngRate/templateDownload',
    PriceProManagerRateImport: MicroServer.plusProductWeb + '/pricePromngRate/importFile',
    // 价格策略 - 毛利
    GetPriceGrossRatePage: MicroServer.plusProductWeb + '/priceGrossRate/search/page',
    PriceGrossRateSave: MicroServer.plusProductWeb + '/priceGrossRate/batSavePriceGrossRate',
    PriceGrossRateUpdateById: MicroServer.plusProductWeb + '/priceGrossRate/updateById',
    PriceGrossRateDelete: MicroServer.plusProductWeb + '/priceGrossRate/',
    PriceGrossRateBatchDelete: MicroServer.plusProductWeb + '/priceGrossRate',
    PriceGrossRateDownload: MicroServer.plusProductWeb + '/priceGrossRate/templateDownload',
    PriceGrossRateImport: MicroServer.plusProductWeb + '/priceGrossRate/importFile',
    // 价格策略 - 标配、通项
    GetPriceStandardRatePage: MicroServer.plusProductWeb + '/priceStandardRate/search/page',
    PriceStandardRateSave: MicroServer.plusProductWeb + '/priceStandardRate/batSaveStandardPrice/',
    PriceStandardRateUpdateById: MicroServer.plusProductWeb + '/priceStandardRate/updateById',
    PriceStandardRateDelete: MicroServer.plusProductWeb + '/priceStandardRate/',
    PriceStandardRateBatchDelete: MicroServer.plusProductWeb + '/priceStandardRate',
    PriceStandardRateDownload: MicroServer.plusProductWeb + '/priceStandardRate/templateDownload/',
    PriceStandardRateImport: MicroServer.plusProductWeb + '/priceStandardRate/importFile/',
    // 价格策略- 价格导入 迭代
    PriceStandardRateBatchUpdateDate: MicroServer.plusProductWeb + '/priceStandardRate/batchUpdateDate', //批量修改时间
    ProductOperationSearchBusinessLog: MicroServer.plusProductWeb + '/productOperation/searchBusinessLog', //查看调整记录
    PriceStandardRateExport: MicroServer.plusProductWeb + '/priceStandardRate/export', //导出
    // 产品管理
    GetProductCommonPage: MicroServer.plusProductWeb + '/product/getIncludeCommonProdPage', //含通用
    GetProductManagementPage: MicroServer.plusProductWeb + '/product/search/page',
    GetProductSkuManagementPage: MicroServer.plusProductWeb + '/productSku/search/page', // sku查询
    FindProdCateTreeList: MicroServer.plusProductWeb + '/prodCateTree/findProdCateTreeList',
    ProductManagementDetail: MicroServer.plusProductWeb + '/product/',
    ProductSkuDetail: MicroServer.plusProductWeb + '/productSku/',
    ProductManagementUpdateState: MicroServer.plusProductWeb + '/product/updateState',
    ProductManagementUpdateById: MicroServer.plusProductWeb + '/product/updateById',
    ProductManagementDelete: MicroServer.plusProductWeb + '/product/',
    SaveCacheProductAndAttachs: MicroServer.plusProductWeb + '/product/saveCacheProductAndAttachs', // 保存产品和附件缓存-下一步
    CreateSkuByArgs: MicroServer.plusProductWeb + '/productSku/createSku', // 根据参数规格生成sku-添加配置
    SaveCacheArgManageShortcut:
      MicroServer.plusProductWeb + '/argManageShortcut/saveCacheArgManageShortcut', // 缓存参数快照-下一步
    SaveCacheProductRuleDtl: MicroServer.plusProductWeb + '/productRuleDtl/saveCacheProductRuleDtl', // 缓存价格管理
    DeleteCacheProductRuleDtl:
      MicroServer.plusProductWeb + '/productRuleDtl/deleteCacheProductRuleDtl', // 删除缓存价格管理
    SubmitProductInfo: MicroServer.plusProductWeb + '/product/submitProductInfo', // 产品将缓存转为业务数据
    SaveProduct: MicroServer.plusProductWeb + '/product', // 新增产品
    GetProductList: MicroServer.plusProductWeb + '/product/search/list', // 新增产品
    // sku
    GetSkuList: MicroServer.plusProductWeb + '/productSku/search/page', // sku列表
    GetAuthSkuList: MicroServer.plusProductWeb + '/authProductSku/search/page', // sku列表
    GetCostTemplateList: MicroServer.plusProductWeb + '/costTemplate/search/list', // 费用模板列表
    GetPriceItemDetail: MicroServer.plusProductWeb + '/priceItemDetail/getDetails', // 查询费用项列表
    GetSkuPriceCalculate: MicroServer.plusProductWeb + '/priceCalculate/productSkuPriceCalculate', // 查询单品sku价格
    GetSkuCombinationInfo: MicroServer.plusProductWeb + '/productSku/search/one', // 查组合产品明细
    GetSkuAllowCompanies: MicroServer.plusProductWeb + '/priceCalculate/getAllowCompanies/', // 查有权限的门店
    // 子项管理
    GetSubItemManagementPage: MicroServer.plusProductWeb + '/subItemManage/search/page',
    SubItemManagementUpdateState: MicroServer.plusProductWeb + '/subItemManage/updateState',
    SubItemManagementDelete: MicroServer.plusProductWeb + '/subItemManage/',
    SubItemManagementAdd: MicroServer.plusProductWeb + '/subItemManage',
    GetSubItemManagementInfo: MicroServer.plusProductWeb + '/subItemManage/updateById', // 基础数据
    UpDateSubItemManagementInfo: MicroServer.plusProductWeb + '/subItemManage/updateById', // POST保存 基础数据
    // 子项管理-新增/编辑
    SubItemManagementSaveCache: MicroServer.plusProductWeb + '/subItemManage/saveInfo', // 点击下一步调用- 存临时表
    SubItemManagementSave: MicroServer.plusProductWeb + '/subItemManage/submit', // 提交保存
    SubItemManagementCleanCache: MicroServer.plusProductWeb + '/subItemManage/cleanCache', // 取消刷新缓存
    // 子项管理-新增-子项打包
    GetSubPackTreeAddTree: MicroServer.plusProductWeb + '/subItemManage/', // 子项详情tree
    SubPackTreeSave: MicroServer.plusProductWeb + '/subPackTree/saveInfo',
    // 子项管理-编辑-子项打包
    GetSubPackTreeEditTree: MicroServer.plusProductWeb + '/subPackTree/findEditTree',
    GetSubPackTreeEditTreeTopList: MicroServer.plusProductWeb + '/subPackTree/findEditTreeTopList',
    SubPackTreeUpdateById: MicroServer.plusProductWeb + '/subPackTree/updateById',
    SubPackTreeDelete: MicroServer.plusProductWeb + '/subPackTree/deleteInfoById',
    // 打包模板
    GetPackModelPage: MicroServer.plusProductWeb + '/packModel/search/page',
    GetPackModelList: MicroServer.plusProductWeb + '/packModel/search/list',
    PackModelUpdateById: MicroServer.plusProductWeb + '/packModel/updateById',
    PackModelUpdateState: MicroServer.plusProductWeb + '/packModel/updateState',
    PackModelDelete: MicroServer.plusProductWeb + '/packModel/',
    GetPackModelDetail: MicroServer.plusProductWeb + '/packModel/',
    PackModelCopy: MicroServer.plusProductWeb + '/packModel/copyPackModel',
    GetPackModelInfo: MicroServer.plusProductWeb + '/packModel/getInfoById',
    BuildExcel: MicroServer.plusProductWeb + '/packModelPackTreeNode/buildExcel', // 打包模板 模板下载 数据导出
    ReadExcel: MicroServer.plusProductWeb + '/packModelPackTreeNode/readExcel', // 打包模板  数据导入
    // 打包模板-编辑
    PackModelDetail: MicroServer.plusProductWeb + '/packModel/getOrCachePackModel',
    PackModelSave: MicroServer.plusProductWeb + '/packModel',
    PackModelSubmit: MicroServer.plusProductWeb + '/product/submitPackModel',
    PackModelEditDownloadExcel: MicroServer.plusProductWeb + '/packModelPackTreeNode/downloadExcel', // 编辑打包模板时 模板下载
    PackModelEditImportExcel: MicroServer.plusProductWeb + '/packModelPackTreeNode/importExcel', // 编辑打包模板时 批量导入
    //第二步骤 规格
    PackModelArgSave: MicroServer.plusProductWeb + '/argManageShortcut/saveCacheArgManageShortcut',
    PackModelArgDetail:
      MicroServer.plusProductWeb + '/argManageShortcut/getOrCacheArgManageShortcut',
    PackModelCreateSkuByArgs: MicroServer.plusProductWeb + '/packModelSku/createSku',
    // 第二步 规格查询sku
    PackModelSkuSave: MicroServer.plusProductWeb + '/productRuleDtl/saveCacheProductRuleDtl',
    PackModelSkuDetail: MicroServer.plusProductWeb + '/productRuleDtl/getOrCacheProductRuleDtl',
    // 第三步 产品打包
    PackModelTreeSave: MicroServer.plusProductWeb + '/packModelTree/saveCachePackModelTree',
    PackModelTreeCreateTreeId: MicroServer.plusProductWeb + '/packModelTree/createTreeId',
    PackModelTreeUpdateTreeById: MicroServer.plusProductWeb + '/packModelTree/updatePackModelTree',
    PackModelTreeDetail: MicroServer.plusProductWeb + '/packModelTree/getOrCachePackModelTree',
    GetCachePackModelTreeDetail:
      MicroServer.plusProductWeb + '/packModelTree/getCachePackModelTree',
    // 保存提交
    PackModelTreeSubmit: MicroServer.plusProductWeb + '/packModel/submitPackModel',
    // 商品管理-上下架 销售类目
    GetGoodsManagementGoodsBaseInfo:
      MicroServer.plusProductWeb + '/outer/product/getPrdAttrAndAttrValByGoodsId',
    // 查询产品和附件-先缓存次业务
    GetOrCacheProductAndAttachs:
      MicroServer.plusProductWeb + '/product/getOrCacheProductAndAttachs',
    // 查询参数快照-先缓存次业务
    GetOrCacheArgManageShortcut:
      MicroServer.plusProductWeb + '/argManageShortcut/getOrCacheArgManageShortcut',
    // 查询价格管理-先缓存次业务
    GetOrCacheProductRuleDtl:
      MicroServer.plusProductWeb + '/productRuleDtl/getOrCacheProductRuleDtl',
    // 复制产品
    CopyProductInfo: MicroServer.plusProductWeb + '/product/copyProductInfo',
    // 查询产品价格关联-先缓存次业务
    GetOrCacheProductPriceRel:
      MicroServer.plusProductWeb + '/productPriceRel/getOrCacheProductPriceRel',
    GetCacheProductPriceRel:
      MicroServer.plusProductWeb + '/productPriceRel/getCacheProductPriceRel',
    // 保存sku关联价格缓存
    SaveCacheProductPriceRel:
      MicroServer.plusProductWeb + '/productPriceRel/saveCacheProductPriceRel',
    GetProdPriceManagePage: MicroServer.plusProductWeb + '/productPriceRel/getProdPriceManagePage', // 对应费用项分类分页列表
    // 规则
    GetFormulaRuleVariablesList: MicroServer.plusProductWeb + '/calcFormulaRule/getVariablesList',
    GetFormulaRuleSymbols: MicroServer.plusProductWeb + '/calcFormulaRule/getSymbols',
    GetFormulaRuleQlPredictInputVar:
      MicroServer.plusProductWeb + '/calcFormulaRule/getQlPredictInputVar',
    CalculationResult: MicroServer.plusProductWeb + '/calcFormulaRule/calculationResult',
    OperateCacheProductPriceRel:
      MicroServer.plusProductWeb + '/productPriceRel/operateCacheProductPriceRel',
    DeleteCacheProduct: MicroServer.plusProductWeb + '/product/deleteCacheProduct', // 删除缓存
    GetSpecialCodes: MicroServer.plusProductWeb + '/specialCodes/search/page', // 特项代码分页
    GetSpecialCodesList: MicroServer.plusProductWeb + '/specialCodes/search/list', // 特项代码list
    SpecialCodeOperate: MicroServer.plusProductWeb + '/specialCodes', // 特项代码 Id删除数据 新增
    UpdateSpecialCodes: MicroServer.plusProductWeb + '/specialCodes/updateById', // 特项代码根据Id编辑数据
    GetunitPage: MicroServer.plusProductWeb + '/unit/search/page', // 单位管理分页
    GetunitList: MicroServer.plusProductWeb + '/unit/search/list', // 单位管理list
    UnitOperate: MicroServer.plusProductWeb + '/unit', // 单位管理 Id删除数据 新增
    UpdateUnit: MicroServer.plusProductWeb + '/unit/updateById', // 单位管理根据Id编辑数据
    GetSkuPageList: MicroServer.plusProductWeb + '/productRuleDtl/search/page', // 产品sku-搜索框分页接口
    GetSpuPageList: MicroServer.plusProductWeb + '/product/search/page', // 产品spu-搜索框分页接口
    GeneralStandardAdd: MicroServer.plusProductWeb + '/generalStandard', // 新增实体 标配
    DeletedBatchByIds: MicroServer.plusProductWeb + '/generalStandard/deletedBatchByIds', // 批量删除 标配
    DiscountRatioManagePage: MicroServer.plusProductWeb + '/discountRatioManage/search/page', // 优惠系数 查询分页列表
    AddDiscountRatioManage: MicroServer.plusProductWeb + '/discountRatioManage/insertBatchEntity', // 优惠系数 批量新增
    UpdateDiscountRatioManage: MicroServer.plusProductWeb + '/discountRatioManage/updateById', // 优惠系数 编辑
    DeleteDiscountRatioManage: MicroServer.plusProductWeb + '/discountRatioManage/', // 优惠系数 Id删除数据
    DownloadDiscountRatioManage:
      MicroServer.plusProductWeb + '/discountRatioManage/templateDownload', // 优惠系数模板下载
    ImportFileDeleteDiscount: MicroServer.plusProductWeb + '/discountRatioManage/importFile', // 优惠系数 导入
    DeletedBatchByIdsDiscountRatioManage:
      MicroServer.plusProductWeb + '/discountRatioManage/deletedBatchByIds', // 优惠系数 批量删除
    BreakManagePage: MicroServer.plusProductWeb + '/breakManage/search/page', // 费用项 违约金 列表
    BreakManageUpdateById: MicroServer.plusProductWeb + '/breakManage/updateById', // 费用项 违约金 编辑
    IdGenerate: MicroServer.plusProductWeb + '/idGenerate', // 创建id
    // 活动管理
    GetActivityList: MicroServer.plusProductWeb + '/activity/search/page', // 列表
    DeleteActivity: MicroServer.plusProductWeb + '/activity', // 删除
    AddActivity: MicroServer.plusProductWeb + '/activity', // 新增
    UpdateActivity: MicroServer.plusProductWeb + '/activity/updateById', // 编辑
    ActivityType:
      MicroServer.plusProductWeb + '/enums/com.shj.saas.plus.product.enums.ActivityType', // 活动类型
    GetActivityProductList: MicroServer.plusProductWeb + '/activityProduct/search/page', // 活动产品列表
    DeleteActivityProduct: MicroServer.plusProductWeb + '/activityProduct', // 活动产品删除
    GetActivityProductDetail: MicroServer.plusProductWeb + '/activityProduct', // 活动产品详情
    AddActivityProduct: MicroServer.plusProductWeb + '/activityProduct', // 活动产品新增
    UpdateActivityProduct: MicroServer.plusProductWeb + '/activityProduct/updateById', // 活动产品编辑
    GetActivityProductShopLimitList:
      MicroServer.plusProductWeb + '/activityProductShopLimit/search/page', // 活动产品门店限制列表
    GetActivityProductShopLimitDetail: MicroServer.plusProductWeb + '/activityProductShopLimit', // 活动产品门店限制详情
    DeleteActivityProductShopLimit: MicroServer.plusProductWeb + '/activityProductShopLimit', // 活动产品门店删除
    AddActivityProductShopLimit: MicroServer.plusProductWeb + '/activityProductShopLimit', // 活动产品门店限制新增
    UpdateActivityProductShopLimit:
      MicroServer.plusProductWeb + '/activityProductShopLimit/updateById', // 活动产品门店限制编辑
    GetActivityProductSkuDetailList:
      MicroServer.plusProductWeb + '/activityProductSkuDetail/search/page', // 活动产品sku列表
    DeleteActivityProductSkuDetail: MicroServer.plusProductWeb + '/activityProductSkuDetail', // 活动产品sku删除
    AddActivityProductSkuDetail: MicroServer.plusProductWeb + '/activityProductSkuDetail', // 活动产品sku新增
    GetProductSkuList: MicroServer.plusProductWeb + '/productSku/search/list', // sku列表
    BatchUpdateProductSkuEnabled: MicroServer.plusProductWeb + '/productSku/batchUpdateProductSkuEnabled', // 批量sku启用/停用
    ActivityProductType:
      MicroServer.plusProductWeb + '/enums/com.shj.saas.plus.product.enums.ActivityProductType', // 活动产品-活动类型
    PromoType: MicroServer.plusProductWeb + '/enums/com.shj.saas.plus.product.enums.PromoType', // 活动产品-优惠类型
    PromoStyle: MicroServer.plusProductWeb + '/enums/com.shj.saas.plus.product.enums.PromoStyle', // 活动产品-优惠形式
    ActivityProductLimitType:
      MicroServer.plusProductWeb +
      '/enums/com.shj.saas.plus.product.enums.ActivityProductLimitType', // 活动产品-限制类型
    ActivityProductPmsLimitType:
      MicroServer.plusProductWeb +
      '/enums/com.shj.saas.plus.product.enums.ActivityProductPmsLimitType', // 活动产品-交付限制类型
    ActiveCostBelong:
      MicroServer.plusProductWeb + '/enums/com.shj.saas.plus.product.enums.ActiveCostBelong', // 活动产品-活动成本归属
    DeductivePricingEnum:
      MicroServer.plusProductWeb + '/enums/com.shj.saas.plus.product.enums.DeductivePricingEnum', // SPU减项计价方式
    BatchIdGenerate: MicroServer.plusProductWeb + '/idGenerate/batch/', // 批量创建id
    QueryProduct: MicroServer.plusProductWeb + '/product/search/one/', // 查询单一产品
    UpdateProductEnabled: MicroServer.plusProductWeb + '/product/updateEnabled', // 启用停用产品
    BatchDelete: MicroServer.plusProductWeb + '/product/batchDelete', // 批量删除
    ImportBaseProductInfo: MicroServer.plusProductWeb + '/productImport/importBaseInfo', // 导入产品
    ImportActivityInfo: MicroServer.plusProductWeb + '/activityProduct/batchSave', // 导入活动
    DownloadBaseProductInfo: MicroServer.plusProductWeb + '/productImport/baseInfoTemplateDownload', // 下载模板
    DownloadActivityInfo: MicroServer.plusProductWeb + '/activityProduct/templateDownload', // 下载活动模板
    ImportCombinationProductInfo:
      MicroServer.plusProductWeb + '/productCombinationDetail/templateImport', // 导入组合产品
    DownloadCombinationProductInfo:
      MicroServer.plusProductWeb + '/productCombinationDetail/templateDownload', // 下载组合产品模板
    GetCombinationProductList: MicroServer.plusProductWeb + '/productCombinationDetail/search/page', // 组合产品列表
    DeleteCombinationProductInfo: MicroServer.plusProductWeb + '/productCombinationDetail', // 删除组合产品
    BatchDeleteCombinationProductInfo: MicroServer.plusProductWeb + '/productCombinationDetail', // 批量删除组合产品
    GetCombinationSkuList: MicroServer.plusProductWeb + '/productCombinationDetail/skuPage', // 查组合包含的sku
    GetSendPackConfigList: MicroServer.plusProductWeb + '/sendPackConfig/search/page', // 发包配置列表
    DeleteSendPackConfig: MicroServer.plusProductWeb + '/sendPackConfig', // 删除发包配置
    BatchDeleteSendPackConfig: MicroServer.plusProductWeb + '/sendPackConfig/batchDelete', // 批量删除发包配置
    ImportSendPackConfig: MicroServer.plusProductWeb + '/sendPackConfig/importFile', // 导入发包配置
    DownloadSendPackConfig: MicroServer.plusProductWeb + '/sendPackConfig/templateDownload', // 下载发包配置模板
    ExportCombinationProductInfo: MicroServer.plusProductWeb + '/productCombinationDetail/export', // 组合信息导出
    DownloadSkuInfo: MicroServer.plusProductWeb + '/productSku/templateDownload', // 下载sku模板
    SkuDetailsExport: MicroServer.plusProductWeb + '/authProductSku/detailsExport', // 导出sku
    ImportSkuInfo: MicroServer.plusProductWeb + '/productSku/batchUpdate', // 导入组合产品
    SalePriceCheck: MicroServer.plusProductWeb + '/productSku/salePriceCheck', // 销售指导价检查
    /** 报价面积 */
    AddBudgetArea: MicroServer.plusProductWeb + '/productBudgetAreaConfig/batchAdd', // 添加产品报价面积类型
    GetBudgetAreaList: MicroServer.plusProductWeb + '/productBudgetAreaConfig/search/list', // 查产品报价面积列表
    UpdateBudgetArea: MicroServer.plusProductWeb + '/productBudgetAreaConfig/updateById', // 编辑产品报价面积类型
    DelBudgetArea: MicroServer.plusProductWeb + '/productBudgetAreaConfig', // 删除产品报价面积类型
    GetUpdateNodes: MicroServer.plusProductWeb + '/packModel/getUpdateNodes', // 获取更新节点
    GetTemplateCount: MicroServer.plusProductWeb + '/product/search/count', // 打包模板 查询总记录数
    GetSpaceArgPage: MicroServer.plusProductWeb + '/spaceSpecificationArg/search/page', // 获取空间规格参数分页
    AddSpaceSpecificationArg: MicroServer.plusProductWeb + '/spaceSpecificationArg', // 获取空间规格参数分页
    SpaceSpecificationArgUpdateById:
      MicroServer.plusProductWeb + '/spaceSpecificationArg/updateById', // 获取空间规格参数分页
    SpaceSpecificationArgUpdateState:
      MicroServer.plusProductWeb + '/spaceSpecificationArg/updateState', // 获取空间规格参数状态修改
    SpaceSpecificationArgDelete: MicroServer.plusProductWeb + '/spaceSpecificationArg/', // 获取空间规格参数状态修改
    GetSpaceSpecificationArgList:
      MicroServer.plusProductWeb + '/spaceSpecificationArgValue/getValuesByArgId', // 获取空间规格参数列表

    /** 空间规格配置 */
    GetSpaceSpecificationArg: MicroServer.plusProductWeb + '/spaceSpecificationArg/search/list', // 拉空间规格参数列表
    GetSpaceTagsByPackModelId:
      MicroServer.plusProductWeb + '/productPackTreeDetail/getSpaceTagsByPackModelId', // 拉打包模板空间列表
    SubmitConfigAndNode: MicroServer.plusProductWeb + '/packModelSpaceConfig/submitConfigAndNode', // 保存或更新打包空间配置和节点
    GetPackTreeNode: MicroServer.plusProductWeb + '/packTreeNode/search/list', // 查询打包节点-根据打包模板ID
    GetPackModelSpaceConfig: MicroServer.plusProductWeb + '/packModelSpaceConfig/search/list', // 查询空间规格设置-根据打包模板ID
    // 费用模版
    GetCostTemplate: MicroServer.plusProductWeb + '/costTemplate/search/page', // 获取费用模版
    AddCostTemplate: MicroServer.plusProductWeb + '/costTemplate', // 新增费用模版
    UpdateCostTemplate: MicroServer.plusProductWeb + '/costTemplate/updateById', // 编辑费用模版
    UpdateCostTemplateState: MicroServer.plusProductWeb + '/costTemplate/updateState', // 修改费用模版状态
    DeleteCostTemplate: MicroServer.plusProductWeb + '/costTemplate/', // 删除费用模版
    CopyCostTemplate: MicroServer.plusProductWeb + '/costTemplate/copyCostTemplate', // 复制费用模版
    GetCostTemplateDetail: MicroServer.plusProductWeb + '/costTemplateDtl/search/page', // 获取费用模版详情
    DownloadCostTemplate: MicroServer.plusProductWeb + '/costTemplateDtl/templateDownload', // 下载费用模版
    ImportCostTemplate: MicroServer.plusProductWeb + '/costTemplateDtl/importFile', // 批量导入模版
    ExportCostTemplate: MicroServer.plusProductWeb + '/costTemplateDtl/export', // 导出模版
    AddCostTemplateDetail: MicroServer.plusProductWeb + '/costTemplateDtl', // 新增费用模版配置
    DeleteCostTemplateDetail: MicroServer.plusProductWeb + '/costTemplateDtl', // 删除费用模版配置
    DeleteCostTemplateDetailBatch: MicroServer.plusProductWeb + '/costTemplateDtl/batchDelete', // 批量删除费用模版配置
    GetCostTemplateDetailCategoryType: MicroServer.plusProductWeb + '/CostTemplateDtlCategoryType', // 获取费用模版详情所属分类类型
    FindCostItemPage: MicroServer.plusProductWeb + '/priceItemManage/findCostItemPage', // 费用模板选择费用项分页查询
    AddCostItem: MicroServer.plusProductWeb + '/costTemplateDtl/saveCostTemplateDtl', // 加入费用项
    FindResponseListByPage: MicroServer.plusProductWeb + '/productSyncLog/findResponseListByPage', // 查询提交数据
    FindErrorResponseListByPage: MicroServer.plusProductWeb + '/productSyncLogDetail/findResponseListByPage', // 查询失败数据
    MaterialDescriptionPage: MicroServer.plusProductWeb + '/materialDescription/search/page', // 工艺说明-查询分页列表
    MaterialDescriptionAdd: MicroServer.plusProductWeb + '/materialDescription', // 工艺说明-新增实体
    MaterialDescriptionUpdate: MicroServer.plusProductWeb + '/materialDescription/updateById', // 工艺说明-根据Id编辑数据
    MaterialDescriptionImport: MicroServer.plusProductWeb + '/materialDescription/import', // 工艺说明-导入工艺及物料描述
    MaterialDescriptionTemplate:
      MicroServer.plusProductWeb + '/materialDescription/templateDownload', // 工艺说明-导入模板下载
    MaterialDescriptionExport: MicroServer.plusProductWeb + '/materialDescription/export', // 工艺说明-导出工艺及物料描述
    MaterialDescriptionDelete: MicroServer.plusProductWeb + '/materialDescription/', // 工艺说明-根据Id删除数据
    PriceImportFeesBatchUpdateDate: MicroServer.plusProductWeb + '/priceImportFees/batchUpdateDate', // 费用项导入费用-批量修改日期
    PriceLimitImportFeesBatchUpdateDate: MicroServer.plusProductWeb + '/priceLimitImportFees/batchUpdateDate', // 费用项限价导入-批量修改日期
    PriceSpecialConfigBatchUpdateDate: MicroServer.plusProductWeb + '/priceSpecialConfig/batchUpdateDate', // 费用项特殊配置-批量修改日期
    BatchUpdateApplyMaterialSelections: MicroServer.plusProductWeb + '/product/batchUpdateApplyMaterialSelections', // spu批量修改适用选材
    GetConstructionCostList: MicroServer.plusProductWeb + '/outer/getConstructionCostList', // 获取施工成本数据
    SendNotifyForHandle: MicroServer.plusProductWeb + '/productSyncLog/sendNotifyForHandle', // 选品手动发送通知

    // 方案产品
    GetPackTreeNodeList: MicroServer.plusProductWeb + '/auth/packTreeNode/search/list', // 查看打包
    GetAuthProductManagementPage: MicroServer.plusProductWeb + '/auth/product/search/page',//列表
    GetAuthGeneralStandardPage: MicroServer.plusProductWeb + '/auth/generalStandard/search/page',//标配情况

    // 选品
    BatchUpdateProductLibrary: MicroServer.plusProductWeb + '/productCategory/batchUpdateProductLibrary', // 产品分类菜单 - 批量更新所属产品库
    BatchInsertSpuRelation: MicroServer.plusProductWeb + '/categorySpuRelation/batchInsertSpuRelation', // 产品分类菜单 - 批量插入关联施工SPU
    GetProdCateTree: MicroServer.plusProductWeb + '/prodCateTree/search/tree', // SPU管理菜单 - 查询产品分类列表
    GetCategorySpuRelation: MicroServer.plusProductWeb + '/categorySpuRelation/search/list', // 产品分类菜单 - 查询分类关联施工SPU
    GetProductSkuSelectList: MicroServer.plusProductWeb + '/productSku/search/list', // 产品分类菜单 - 关联施工 - SKU明细列表查询
    ProductCombinationDetailSelectList: MicroServer.plusProductWeb + '/productCombinationDetail/search/list', // SPU管理 - 组合明细列表查询
    ProductCombinationDetailBatchUpdateDate: MicroServer.plusProductWeb + '/productCombinationDetail/batchUpdateDate', // 组合打包批量修改日期
    ProductCombinationDetailBatchInsert: MicroServer.plusProductWeb + '/productCombinationDetail/batchInsert', // 组合打包批量添加子产品
    ProductCombinationLog: MicroServer.plusProductWeb + '/productOperation/searchProductCombinationLog', // 组合明细查看操作日志
    ProductCombinationEdit: MicroServer.plusProductWeb + '/productCombinationDetail/updateById', // 组合明细编辑数据

    ProductExportProductRelation: MicroServer.plusProductWeb + '/productImport/exportProductRelation', // spu- 方案库导出

    // 预警规则
    priceWarningDetailsSummary: MicroServer.plusProductWeb + '/priceWarningDetails/summary', //  页面数据竞争定价汇总查询
    standardWarningDetailsSummary: MicroServer.plusProductWeb + '/standardWarningDetails/summary', //  页面数据通项预警汇总查询

    warningRulesPage: MicroServer.plusProductWeb + '/warningRules/search/page', //  竞争定价、通项预警
    warningRulesAdd: MicroServer.plusProductWeb + '/warningRules/batchAdd', // 竞争定价、通项预警
    warningRulesUpdate: MicroServer.plusProductWeb + '/warningRules/updateById', // 竞争定价、通项预警
    warningRulesDelete: MicroServer.plusProductWeb + '/warningRules', // 竞争定价、通项预警
    // 全局规则
    warningRulesGlobalStore: MicroServer.plusProductWeb + '/warningRules/globalStore', // 全局规则门店回显
    warningRulesGlobalStoreUpdate: MicroServer.plusProductWeb + '/warningRules/updateGlobalStore', // 全局规则门店修改
    warningRulesGlobalProduct: MicroServer.plusProductWeb + '/warningRules/globalProduct', // 全局规则产品回显
    warningRulesGlobalProductUpdate: MicroServer.plusProductWeb + '/warningRules/updateGlobalProduct', // 全局规则产品修改
    // 规则详情
    warningRulesProductsPage: MicroServer.plusProductWeb + '/warningRules/getConfigProducts', // 竞争定价
    warningRulesStoresPage: MicroServer.plusProductWeb + '/warningRules/getConfigStores', // 竞争定价
    priceWarningDetailsPage: MicroServer.plusProductWeb + '/priceWarningDetails/search/page', // 竞争定价
    priceWarningDetailsExport: MicroServer.plusProductWeb + '/priceWarningDetails/export', // 竞争定价导出
    standardWarningDetailsPage: MicroServer.plusProductWeb + '/standardWarningDetails/search/page', // 通项预警
    standardWarningDetailsExport: MicroServer.plusProductWeb + '/standardWarningDetails/export', // 通项导出
  },
  PlusGoodsWeb: {
    // 商品品类管理
    GetGoodsCategoryTreeList: MicroServer.plusGoodsWeb + '/cateTree/findList',
    GoodsCategorySave: MicroServer.plusGoodsWeb + '/cateTree',
    GoodsCategoryUpdateState: MicroServer.plusGoodsWeb + '/cateTree/updateState',
    GoodsCategoryUpdateById: MicroServer.plusGoodsWeb + '/cateTree/updateById',
    GoodsCategoryDelete: MicroServer.plusGoodsWeb + '/cateTree/',
    // 商品销售类目管理
    GetGoodsSaleCategoryTreeList: MicroServer.plusGoodsWeb + '/saleCateTree/findList',
    GoodsSaleCategorySave: MicroServer.plusGoodsWeb + '/saleCateTree',
    GoodsSaleCategoryUpdateState: MicroServer.plusGoodsWeb + '/saleCateTree/updateState',
    GoodsSaleCategoryUpdateById: MicroServer.plusGoodsWeb + '/saleCateTree/updateById',
    GoodsSaleCategoryDelete: MicroServer.plusGoodsWeb + '/saleCateTree/',
    // 商品销售类目管理- 类目介绍
    GetGoodsSaleCategoryDescList: MicroServer.plusGoodsWeb + '/fileInfo/search/list',
    GoodsSaleCategoryDescSave: MicroServer.plusGoodsWeb + '/fileInfo',
    GoodsSaleCategoryDescUpdateById: MicroServer.plusGoodsWeb + '/fileInfo/updateById',
    GoodsSaleCategoryDescDelete: MicroServer.plusGoodsWeb + '/fileInfo/',
    // 商品管理
    GetGoodsManagementPage: MicroServer.plusGoodsWeb + '/goodsInfo/search/page',
    GoodsManagementSubmit: MicroServer.plusGoodsWeb + '/goodsInfo/submit',
    GoodsManagementUpdateState: MicroServer.plusGoodsWeb + '/goodsInfo/updateState',
    GoodsManagementUpdateById: MicroServer.plusGoodsWeb + '/goodsInfo/updateById',
    GoodsManagementDelete: MicroServer.plusGoodsWeb + '/goodsInfo/delBatchByIds',
    GoodsManagementCleanCache: MicroServer.plusGoodsWeb + '/goodsInfo/cleanCache',
    GoodsManagementCopyInit: MicroServer.plusGoodsWeb + '/goodsInfo/copyInit',
    GoodsManagementSaveSaleCat: MicroServer.plusGoodsWeb + '/goodsInfo/saveSaleCat',
    PushGoodsInitInfoByProdId: MicroServer.plusGoodsWeb + '/outer/goods/pushGoodsInitInfoByProdId', // 产品发布
    //模板
    GetPrintTemplateList: MicroServer.plusGoodsWeb + '/goodsPrintTemplate/search/list',
    // 商品管理 - 编辑
    GetGoodsManagementDealProductPage: MicroServer.plusGoodsWeb + '/common/getDealGoodsPage',
    GetGoodsManagementInfo: MicroServer.plusGoodsWeb + '/goodsInfo/getInfoById',
    GoodsManagementSaveEditInfo: MicroServer.plusGoodsWeb + '/goodsInfo/saveEditInfo',
    // 商品管理 - 第二步 销售配置
    GoodsManagementGetSaleConfigByParam:
      MicroServer.plusGoodsWeb + '/GoodsSaleConf/getSaleConfigByParam',
    GoodsManagementGoodsSaleConfSave: MicroServer.plusGoodsWeb + '/GoodsSaleConf/saveEditInfo',
    // 商品管理 - 第三步 合同配置
    GoodsManagementGetQuotaConfPage: MicroServer.plusGoodsWeb + '/goodsQuotaConf/getEditPage',
    GoodsManagementGetQuotaConfDelete: MicroServer.plusGoodsWeb + '/goodsQuotaConf/deleteInfoById',
    GoodsManagementGoodsQuotaConfSave: MicroServer.plusGoodsWeb + '/goodsQuotaConf/saveEditInfo',
    GoodsManagementGetPrdArgManageListByGoodsId:
      MicroServer.plusGoodsWeb + '/goodsInfo/getPrdArgManageListByGoodsId',
    GoodsManagementGetQuotaContractInfoPage:
      MicroServer.plusGoodsWeb + '/quotaContractInfo/search/page',
    GoodsManagementGoodsQuotaConfNextSave: MicroServer.plusGoodsWeb + '/goodsInfo/updateById',

    // 商品管理 - 第四步 收款规则配置
    GoodsManagementGoodsPayeeConfPage: MicroServer.plusGoodsWeb + '/goodsPayeeConf/getEditPage',
    GoodsManagementGoodsPayeeConfSave: MicroServer.plusGoodsWeb + '/goodsPayeeConf/saveEditInfo',
    GoodsManagementGoodsPayeeConfDeleteInfoById:
      MicroServer.plusGoodsWeb + '/goodsPayeeConf/deleteInfoById',
    // 商品管理 - 上下架
    // GetGoodsManagementGoodsBaseInfo: MicroServer.plusGoodsWeb + '/outer/product/getPrdAttrAndAttrValByGoodsId',
    GoodsManagementGoodsSkuPage: MicroServer.plusGoodsWeb + '/goodsSkuInfo/getSkuPage',
    GoodsManagementGoodsSkuSave: MicroServer.plusGoodsWeb + '/goodsInfo/saveInfo',
    GoodsManagementGoodsSkuSaveSaleCate: MicroServer.plusGoodsWeb + '/goodsInfo/saveSaleCat',
    // 批量上下架
    GoodsManagementBatchChangeState: MicroServer.plusGoodsWeb + '/goodsInfo/updateOnSelf',

    // 合同
    GetContractTemplateList: MicroServer.plusGoodsWeb + '/goodsPrintTemplate/search/page', // 查询合同模板列表(分页)
    GetContractTemplateListAll: MicroServer.plusGoodsWeb + '/goodsPrintTemplate/search/list', // 查询合同模板列表(全部)
    AddNewContractTemplate: MicroServer.plusGoodsWeb + '/goodsPrintTemplate', // 合同模板新增
    UploadContractTemplate: MicroServer.plusGoodsWeb + '/goodsPrintTemplate/updateById', // 合同模板编辑
    QueryContractTemplate: MicroServer.plusGoodsWeb + '/goodsPrintTemplate/search/one', // 合同模板详情
    PreviewPrintTemplate: MicroServer.plusGoodsWeb + '/goodsPrintTemplate/previewPrintTemplate', // 2.2.1 合同模板预览接口
    DeleteContractTemplate: MicroServer.plusGoodsWeb + '/goodsPrintTemplate', // 合同模板删除
    ChangeContractTemplateStatus: MicroServer.plusGoodsWeb + '/goodsPrintTemplate/updateState', // 合同模板修改状态
    AddContractTemplateExtend: MicroServer.plusGoodsWeb + '/goodsPrintTemplateExtensions', // 合同模板扩展字段新增
    GetContractTemplateExtendList:
      MicroServer.plusGoodsWeb + '/goodsPrintTemplateExtensions/search/page', // 合同模板扩展字段列表
    UpdateContractTemplateExtend:
      MicroServer.plusGoodsWeb + '/goodsPrintTemplateExtensions/updateById', // 合同模板扩展字段编辑
    DeleteContractTemplateExtend: MicroServer.plusGoodsWeb + '/goodsPrintTemplateExtensions', // 合同模板扩展字段删除
    FilterTypeEnum:
      MicroServer.plusGoodsWeb + '/enums/com.shj.saas.plus.goods.enums.PrintFilterTypeEnum', // 过滤类型枚举
    PrintPaperDirectionEnum:
      MicroServer.plusGoodsWeb + '/enums/com.shj.saas.plus.goods.enums.PrintPaperDirectionEnum', // 纸张方向枚举
    ExtensionItemTypeEnum:
      MicroServer.plusGoodsWeb + '/enums/com.shj.saas.plus.goods.enums.PrintExtensionItemTypeEnum', // 扩展字段分类
    ExtensionFieldTypeEnum:
      MicroServer.plusGoodsWeb + '/enums/com.shj.saas.plus.goods.enums.PrintExtensionFieldTypeEnum', // 扩展字段类型
    GetContractInfoList: MicroServer.plusGoodsWeb + '/quotaContractInfo/search/page', // 查询合同配置列表(分页)
    QueryContractInfo: MicroServer.plusGoodsWeb + '/quotaContractInfo', // 报价合同配置详情
    AddNewPriceContract: MicroServer.plusGoodsWeb + '/quotaContractInfo', // 报价合同配置新增
    DeletePriceContract: MicroServer.plusGoodsWeb + '/quotaContractInfo', // 报价合同配置删除
    UploadContractInfo: MicroServer.plusGoodsWeb + '/quotaContractInfo/updateById', // 报价合同配置编辑
    ChangeContractInfoStatus: MicroServer.plusGoodsWeb + '/quotaContractInfo/updateState', // 报价合同配置修改状态
    GetCategoryByParentId: MicroServer.plusGoodsWeb + '/cGoodsCategory/search/treeByParentId', // C端销售类目
    GetBudgetTypeEnum:
      MicroServer.plusProductWeb + '/enums/com.shj.saas.plus.trade.enums.QuoteBudgetTypeEnum', // 报价类型枚举
    GetBudgetTypeEnumNew: MicroServer.plusGoodsWeb + '/quotaContractInfo/getPrintBudgetVal', // 报价类型枚举
    GetContractTypeEnum:
      MicroServer.plusTradeWeb + '/enums/com.shj.saas.plus.trade.enums.ElectronicContractTypeEnum', // 合同类型枚举
    CompanyPrintVarTypeEnum:
      MicroServer.plusGoodsWeb +
      '/enums/com.shj.saas.plus.goods.enums.print.CompanyPrintVarTypeEnum', // 变量类型枚举
    CompanyPrintVarConfig: MicroServer.plusGoodsWeb + '/companyPrintVarConfig', // 新增分公司打印变量
    UpdateCompanyPrintVarConfig: MicroServer.plusGoodsWeb + '/companyPrintVarConfig/updateById', // 编辑分公司打印变量
    DeleteCompanyPrintVarConfig: MicroServer.plusGoodsWeb + '/companyPrintVarConfig', // 删除分公司打印变量
    GetCompanyPrintVarConfig: MicroServer.plusGoodsWeb + '/companyPrintVarConfig/search/page', // 删除分公司打印变量
    queryLoanOrgList: MicroServer.plusFmsWeb + '/lendingInstitutions/search/list', // 贷款机构列表
    hasLoanOrg: MicroServer.plusTradeWeb + '/quoteBudget/haveLoansDiscount', // 是否展示贷款机构
    saveQuoteDiscountBus: MicroServer.plusTradeWeb + '/quoteDiscount/saveQuoteDiscountBus', // 保存贴息
    SelectForOnlineShop: MicroServer.plusGoodsWeb + '/goodsInfo/selectForOnlineShop', // 获取商品列表
    GetOrderCustomerPage: MicroServer.plusTradeWeb + '/order/customerPage', // 获取订单列表
    GetResponseListForCustomer:
      MicroServer.plusFmsWeb + '/orderAccount/findResponseListForCustomerByRequest', // 获取收款列表
    getSignTemplateList: MicroServer.plusGoodsWeb + '/goodsSignTemplate/search/page', // 签约模板列表
    AddSignTemplate: MicroServer.plusGoodsWeb + '/goodsSignTemplate', // 新增签约模板
    updateSignTemplate: MicroServer.plusGoodsWeb + '/goodsSignTemplate/updateById', // 修改签约模板
    deleteSignTemplate: MicroServer.plusGoodsWeb + '/goodsSignTemplate', // 删除签约模板
    getSignTemplateDetailList: MicroServer.plusGoodsWeb + '/goodsSignTemplateDetail/search/page', // 签约模板详情列表
    addSignTemplateDetail: MicroServer.plusGoodsWeb + '/goodsSignTemplateDetail/create', // 新增签约模板配置
    updateSignTemplateDetail: MicroServer.plusGoodsWeb + '/goodsSignTemplateDetail/updateById', // 修改签约模板配置
    deleteSignTemplateDetail: MicroServer.plusGoodsWeb + '/goodsSignTemplateDetail', // 删除签约模板配置
    downloadSignTemplate: MicroServer.plusGoodsWeb + '/goodsSignTemplateDetail/templateDownload', // 下载签约模板配置
    importSignTemplate: MicroServer.plusGoodsWeb + '/goodsSignTemplateDetail/import', // 导入签约模板配置
    exportSignTemplate: MicroServer.plusGoodsWeb + '/goodsSignTemplateDetail/export', // 导出签约模板配置
    deleteTemplateDetailBatch: MicroServer.plusGoodsWeb + '/goodsSignTemplateDetail/batch', // 批量删除签约模板配置
    BaWBatchAddConfigs: MicroServer.plusGoodsWeb + '/brandFilterConfig/batchAddConfigs', // 批量新增品牌过滤配置接口
    BaWUpdateById: MicroServer.plusGoodsWeb + '/brandFilterConfig/updateById', //编辑品牌过滤配置接口
    BaWPage: MicroServer.plusGoodsWeb + '/brandFilterConfig/search/page', // 分页品牌过滤配置查询
    BaWPageDelete: MicroServer.plusGoodsWeb + '/brandFilterConfig', // 分页品牌过滤配置删除
  },
  Content: {
    queryContentInfoListByPage: MicroServer.content + '/contentInfo/queryContentInfoListByPage',
    saveOrUpdateContentInfo: MicroServer.content + '/contentInfo/saveOrUpdateContentInfo',
    deleteContentInfo: MicroServer.content + '/contentInfo/deleteContentInfo',
    cGrounding: MicroServer.content + '/contentInfo/cGrounding',
    appGrounding: MicroServer.content + '/contentInfo/appGrounding',
    queryContentInfo: MicroServer.content + '/contentInfo/queryContentInfo',

    queryCategoryList: MicroServer.content + '/contentCategory/queryCategoryList',

    queryContentCategoryList: MicroServer.content + '/contentCategory/queryContentCategoryList',
    addContentCategory: MicroServer.content + '/contentCategory/addContentCategory',
    updateContentCategory: MicroServer.content + '/contentCategory/updateContentCategory',
    deleteContentCategory: MicroServer.content + '/contentCategory/deleteContentCategory',

    queryContentTagListByPage: MicroServer.content + '/contentTag/queryContentTagListByPage',
    saveOrUpdateContentTag: MicroServer.content + '/contentTag/saveOrUpdateContentTag',
    deleteContentTag: MicroServer.content + '/contentTag/deleteContentTag',

    queryBuildingInfoByEmployeeId:
      MicroServer.content + '/contentInfo/queryBuildingInfoByEmployeeId',
  },
  member: {
    queryMemberInfoListByPage: MicroServer.member + '/memberInfo/queryMemberInfoListByPage',
    saveOrUpdateMemberInfo: MicroServer.member + '/memberInfo/saveOrUpdateMemberInfo',
    deleteMemberInfo: MicroServer.member + '/memberInfo/deleteMemberInfo',
    queryMemberInfo: MicroServer.member + '/memberInfo/queryMemberInfo',
    saveOrUpdateMemberEventDetail:
      MicroServer.member + '/memberEventDetail/saveOrUpdateMemberEventDetail',
    queryMemberEventDetailListByPage:
      MicroServer.member + '/memberEventDetail/queryMemberEventDetailListByPage',

    saveOrUpdateMemberLevel: MicroServer.member + '/memberLevel/saveOrUpdateMemberLevel',
    queryMemberLevelList: MicroServer.member + '/memberLevel/queryMemberLevelList',
    queryMemberLevelListByPage: MicroServer.member + '/memberLevel/queryMemberLevelListByPage',
    deleteMemberLevel: MicroServer.member + '/memberLevel/deleteMemberLevel',

    saveOrUpdateMemberEvent: MicroServer.member + '/memberEvent/saveOrUpdateMemberEvent',
    queryMemberEventList: MicroServer.member + '/memberEvent/queryMemberEventList',
    queryMemberEventListByPage: MicroServer.member + '/memberEvent/queryMemberEventListByPage',
    deleteMemberEvent: MicroServer.member + '/memberEvent/deleteMemberEvent',
    updateState: MicroServer.member + '/memberEvent/updateState',
    saveOrUpdateMemberConfiguration:
      MicroServer.member + '/memberConfiguration/saveOrUpdateMemberConfiguration',
    saveOrUpdateBatchMemberConfiguration:
      MicroServer.member + '/memberConfiguration/saveOrUpdateBatchMemberConfiguration',

    saveOrUpdateMemberEquityCategory:
      MicroServer.member + '/memberEquityCategory/saveOrUpdateMemberEquityCategory',
    deleteMemberEquityCategory:
      MicroServer.member + '/memberEquityCategory/deleteMemberEquityCategory',
    queryMemberEquityCategoryListByPage:
      MicroServer.member + '/memberEquityCategory/queryMemberEquityCategoryListByPage',
    queryMemberEquityCategoryList:
      MicroServer.member + '/memberEquityCategory/queryMemberEquityCategoryList',
    queryMemberEquityCategoryInfo:
      MicroServer.member + '/memberEquityCategory/queryMemberEquityCategoryInfo',
    queryMemberConfigurationList:
      MicroServer.member + '/memberConfiguration/queryMemberConfigurationList',

    // 会员权益表
    saveOrUpdateMemberEquity: MicroServer.member + '/memberEquity/saveOrUpdateMemberEquity',
    queryMemberEquityListByPage: MicroServer.member + '/memberEquity/queryMemberEquityListByPage',
    deleteMemberEquity: MicroServer.member + '/memberEquity/deleteMemberEquity',
    updateStateMemberEquity: MicroServer.member + '/memberEquity/updateState',

    // 会员任务
    queryMemberTaskListByPage: MicroServer.member + '/memberTask/queryMemberTaskListByPage',
    saveOrUpdateTask: MicroServer.member + '/memberTask/saveOrUpdateMemberTask',
    memberTaskUpdateState: MicroServer.member + '/memberTask/updateState',
    deleteMemberTask: MicroServer.member + '/memberTask/deleteMemberTask',

    //评价管理
    evaluationConfigList: MicroServer.member + '/evaluationConf/search/page', //评价指标列表
    evaluationIndexList: MicroServer.member + '/evaluationMetrics/search/page', //评价指标列表
    evaluationRecordList: MicroServer.member + '/distributionRecord/search/page', //分发记录列表
    evaluationIndexStatus: MicroServer.member + '/evaluationMetrics/evaluationMetrics', //评价指标启用/停用
    evaluationIndexDelete: MicroServer.member + '/evaluationMetrics', //评价指标删除
    evaluationIndexSave: MicroServer.member + '/evaluationMetrics', //评价指标删除
    evaluationIndexUpdateById: MicroServer.member + '/evaluationMetrics/updateById', //评价指标编辑
    evaluationMetricsTemplate: MicroServer.member + '/evaluationMetricsTemplate/search/list', //查询评价标准模版数据
    evaluationMetricsConditionList: MicroServer.member + '/evaluationMetrics/search/list', //通过条件查询评价指标分数标签列表
    queryAndUpdateEvalutionIndex: MicroServer.member + '/evaluationMetrics', //通过Id查询指标评价详情/保存评价指标
    saveEvaluation: MicroServer.member + '/evaluationConf/saveEvaluation', //保存评价配置
    evaluationDisable: MicroServer.member + '/evaluationConf/evaluationDisable', //启用-停用评价配置
    queryEvalutionConfigById: MicroServer.member + '/evaluationConf', //通过Id查询评价配置详情
    evalutionConfigStatus: MicroServer.member + '/evaluationConf/evaluationDisable', //启用-停用评价配置
    evalutionConfigCopy: MicroServer.member + '/evaluationConf/evaluationCopy', //启用-停用评价配置
    evalutionRecordCreate: MicroServer.member + '/distributionRecord/distributionRecordCreate', //创建分发记录
    evaluationRecordDetail: MicroServer.member + '/distributionRecord/evaluationRecordDetail', //评价记录详情
    evaluationSave: MicroServer.member + '/distributionRecord/evaluationSave', //评价记录保存
    updateRemarkById: MicroServer.member + '/distributionRecord/updateById', //评价记录修改备注
    savePraise: MicroServer.member + '/distributionRecord/savePraise', //评价记录修改赞点
    addEvaluationType: MicroServer.member + '/evaluationType', //问题分类-新增
    updateEvaluationType: MicroServer.member + '/evaluationType/updateById', //问题分类-编辑
    updateStateEvaluationType: MicroServer.member + '/evaluationType/updateState', //问题分类-更新状态
    getTreeEvaluationType: MicroServer.member + '/evaluationType/getTree', //问题分类-获取配置树
    delEvaluationType: MicroServer.member + '/evaluationType', //问题分类-删除
    // 报名渠道配置
    queryMemberChannelRolePage: MicroServer.plusClueWeb + '/channelRoleRef/search/page', //分页查询渠道与角色关系数据
    addChannelRoleRef: MicroServer.plusClueWeb + '/channelRoleRef', //新增-渠道与角色关系数据
    editChannelRoleRef: MicroServer.plusClueWeb + '/channelRoleRef/updateById', //编辑-渠道与角色关系数据
    delChannelRoleRef: MicroServer.plusClueWeb + '/channelRoleRef', //删除-渠道与角色关系数据
    // 线索详情-绑定渠道人员
    channelClueUpdate: MicroServer.plusClueWeb + '/channelClue/bindServices',
  },
  //
  Esign: {
    EsignCommonFindCompanyConfig:
      MicroServer.esign + '/esignCommon/esigncompanyconfig/findCompanyConfig',
    EsignCommonSaveOrUpdateCompny:
      MicroServer.esign + '/esignCommon/esigncompanyconfig/saveOrUpdateCompny',
    EsignCommonDealetCompny: MicroServer.esign + '/esignCommon/esigncompanyconfig/dealetCompny',
    EsignCommonApply: MicroServer.esign + '/esignCommon/esigncompanyconfig/apply',
    EsignCommonUpdateById: MicroServer.esign + '/esignCommon/esigncompanyconfig/updateById',
    EsignCommonList: MicroServer.esign + '/esignCommon/esigncompanyconfig/search/list',
    esigncompanyconfig: MicroServer.esign + '/esignCommon/esigncompanyconfig/search/page', //财务主体
    EsignGetSignLinkUrl: MicroServer.esign + '/esignDoc/getSignLinkUrl', //整装图纸-查询签字链接
    ForcedWithdrawal: MicroServer.esign + '/esignDoc/cancelContractByElecId', //整装图纸- 强制撤回（合同）
    EsignCommonUpdateStateToUnAudit: MicroServer.esign + '/esignCommon/esigncompanyconfig/updateStateToUnAudit', //反审核
  },
  Kingdee: {
    //维度
    DimensionConfigList: MicroServer.kingdee + '/dimensionConfig/search',
    DimensionConfigSaveInfo: MicroServer.kingdee + '/dimensionConfig/saveInfo',
    //规则配置
    RuleConfigSearch: MicroServer.kingdee + '/ruleConfig/search', //分页列表
    RuleConfigSave: MicroServer.kingdee + '/ruleConfig/saveInfo', //保存规则
    RuleConfigDetails: MicroServer.kingdee + '/ruleConfig/detail', //详情by ID
    RuleConfigGetList: MicroServer.kingdee + '/ruleConfig/getList', //
    //子规则配置
    RuleConfigDtlSave: MicroServer.kingdee + '/ruleConfigDtl/saveInfo', //保存子规则
    RuleConfigDtlDelete: MicroServer.kingdee + '/ruleConfigDtl', //删除子规则
    RuleConfigDtlQuoteCheckData: MicroServer.kingdee + '/ruleConfigDtl/quoteCheckData', //子规则校验是否可引用
    RuleConfigDtlCheckData: MicroServer.kingdee + '/ruleConfigDtl/checkData', //子规则编辑校验
    RuleConfigDtlDetails: MicroServer.kingdee + '/ruleConfigDtl/detail', //子规则详情
    RuleConfigDtlAttrConver: MicroServer.kingdee + '/ruleConfigDtlAttrConver', //子规则转换
    RuleConfigDtlAttrConverDelete: MicroServer.kingdee + '/ruleConfigDtlAttrConver', //业财字段值转换列表删除
    RuleConfigDtlAttrConverBatDel: MicroServer.kingdee + '/ruleConfigDtlAttrConver/deleteBatchById', //业财字段值转换列表批量删除
    //业务事项
    BusinessMattersSearch: MicroServer.kingdee + '/businessMatters/search', //分页列表
    BusinessMattersDetails: MicroServer.kingdee + '/businessMatters/saveOrUpdate', //业务事项
    GetBusinessMattersDetails: MicroServer.kingdee + '/businessMatters', //业务事项
    // 业务事项与账套关联
    BusMattersOfBillList: MicroServer.kingdee + '/busMattersOfBill/search/list', //列表
    BusMattersOfBill: MicroServer.kingdee + '/busMattersOfBill', //新增
    UpdateByIdBusMattersOfBill: MicroServer.kingdee + '/busMattersOfBill/updateById', //编辑
    QueryBillAndMappingByBusinessId:
      MicroServer.kingdee + '/businessMatters/queryBillAndMappingByBusinessId', //查询财务
    BusinessMattersFieldMappingList:
      MicroServer.kingdee + '/businessMattersFieldMapping/search/list', //查询财务List by 账套主Id

    // 通用接口
    InterfaceConvertGetJsonAllPath: MicroServer.kingdee + '/interfaceConvert/getJsonAllPath', //获取json全路径
    CommonConvertGetJsonAllPath: MicroServer.kingdee + '/commonConvert/getJsonAllPath', //获取json全路径
    CalculationFormulaSearch: MicroServer.kingdee + '/calculationFormula/search', //表达式列表
    BillSetInfoList: MicroServer.kingdee + '/billSetInfo/search/page',
    BillSetInfoSearchList: MicroServer.kingdee + '/billSetInfo/search/list',
    CalculationFormulaList: MicroServer.kingdee + '/calculationFormula/search',
    DeleteCalculationFormula: MicroServer.kingdee + '/calculationFormula',
    SaveCalculationFormula: MicroServer.kingdee + '/calculationFormula/saveInfo',
    CheckCalculationFormula: MicroServer.kingdee + '/calculationFormula/checkData',
    GetExpressVariables: MicroServer.kingdee + '/commonConvert/getExpressVariables',
    RunExpressVariables: MicroServer.kingdee + '/commonConvert/run',
    QueryOrgDataByBillId: MicroServer.kingdee + '/kdOrganizations/queryOrgDataByBillId',
    //
    DataConverLog: MicroServer.kingdee + '/dataConverLog/pageSearch',
    UpdateMapping: MicroServer.kingdee + '/businessMattersFieldMapping/updateMapping',
    DeleteBillAndMappingDataById:
      MicroServer.kingdee + '/busMattersOfBill/deleteBillAndMappingDataById',
    CheckBusinessMatters: MicroServer.kingdee + '/businessMatters/check',
    CopyAddBusinessMatters: MicroServer.kingdee + '/businessMatters/copyAdd',
    QueryKdCompanyInfo: MicroServer.kingdee + '/businessMatters/queryKdCompanyInfo',
  },
  Fms: {
    //财务账号
    FinAccountPageList: MicroServer.fms + '/finAccount/page',
    FinAccountPageOption: MicroServer.fms + '/finAccount/option',
    FinAccountPageSaveOrUpdate: MicroServer.fms + '/finAccount/saveOrUpdate',
    //收款规则
    ProdReceiptRulePageList: MicroServer.fms + '/prodReceiptRule/search/page',
    ProdReceiptRulePageUpdateById: MicroServer.fms + '/prodReceiptRule/updateById',
    ProdReceiptRulePageAdd: MicroServer.fms + '/prodReceiptRule',
    ProdReceiptRulePageStateChange: MicroServer.fms + '/prodReceiptRule/stateChange',
    ProdReceiptRulePageprodReceiptRuleDtl: MicroServer.fms + '/prodReceiptRuleDtl/list/page',
    ProdReceiptRulePageSaveOrDeleteBatch: MicroServer.fms + '/prodReceiptRuleDtl/saveOrDeleteBatch',
    //收据打印配置
    BillPrintConfigPageList: MicroServer.fms + '/billPrintConfig/findResponsePageByParams',
    BillPrintConfigSavePage: MicroServer.fms + '/billPrintConfig/saveBillPrintConfig',
    BillPrintConfigUpdatePage: MicroServer.fms + '/billPrintConfig/update',
    BillPrintConfigStateActionPage: MicroServer.fms + '/billPrintConfig/stateAction',
    //收款计算内容配置
    TransactionCalPageList: MicroServer.fms + '/transactionCal/search/page',
    TransactionCalPage: MicroServer.fms + '/transactionCal',
    TransactionCalPageUpdateById: MicroServer.fms + '/transactionCal/updateById',
    TransactionCalDtlPageList: MicroServer.fms + '/transactionCalDtl/search/page',
    TransactionCalDtlPageSaveOrUpdateEntity:
      MicroServer.fms + '/transactionCalDtl/saveOrUpdateEntity',
    ReceiptRuleState: MicroServer.fms + '/prodReceiptRule/stateChange', //启用停用
  },
  Bd: {
    GetPrintTemplateList: MicroServer.bd + '/printTemplate/getPrintTemplateList', //打印模板
  },
  PlusFmsWeb: {
    // 收款规则 (商品管理 第四步使用)
    GetRulesPlanMainPage: MicroServer.plusFmsWeb + '/rulesPlanMain/search/page',

    FindResponseListByPage: MicroServer.plusFmsWeb + '/orderAccount/findResponseListByPage', //客户收款列表
    GetPlusEnums: MicroServer.plusFmsWeb + '/enums/', //枚举值参数获取
    //收据打印配置
    BillPrintConfigPageList: MicroServer.plusFmsWeb + '/billPrintConfig/findResponsePageByParams',
    BillPrintConfigSavePage: MicroServer.plusFmsWeb + '/billPrintConfig/saveBillPrintConfig',
    BillPrintConfigUpdatePage: MicroServer.plusFmsWeb + '/billPrintConfig/update',
    BillPrintConfigStateActionPage: MicroServer.plusFmsWeb + '/billPrintConfig/stateAction',
    // 收款核销
    ReceiptWriteOffPageList: MicroServer.plusFmsWeb + '/verifyConfig/findPageByParams',
    ReceiptWriteOffSaveOrUpdateEntity: MicroServer.plusFmsWeb + '/verifyConfig/saveOrUpdateEntity',
    ReceiptWriteOffEnable: MicroServer.plusFmsWeb + '/verifyConfig/enable/',
    ReceiptWriteOffDisable: MicroServer.plusFmsWeb + '/verifyConfig/disable/',
    ReceiptWriteOffDelete: MicroServer.plusFmsWeb + '/verifyConfig/',
    ReceiptWriteOffById: MicroServer.plusFmsWeb + '/verifyConfig/findVerifyConfigById', //根据id查询详情
    //财务账号
    FinAccountPageList: MicroServer.plusFmsWeb + '/finAccount/page',
    FinAccountList: MicroServer.plusFmsWeb + '/finAccount/search/list',
    FinAccountPageOption: MicroServer.plusFmsWeb + '/finAccount/option',
    FinAccountPageSaveOrUpdate: MicroServer.plusFmsWeb + '/finAccount/saveOrUpdate',
    AcquireFinAccountBatchFromKd: MicroServer.plusFmsWeb + '/finAccount/acquireFinAccountBatchFromKd',
    // 打印
    CustAccountPrePrint: MicroServer.plusFmsWeb + '/voucherBusData/prePrint',
    CustAccountPrint: MicroServer.plusFmsWeb + '/voucherBusData/print',
    // 贷款机构
    LendingInstitutionsList: MicroServer.plusFmsWeb + '/lendingInstitutions/page',
    LendingInstitutions: MicroServer.plusFmsWeb + '/lendingInstitutions',
    LendingInstitutionsEdit: MicroServer.plusFmsWeb + '/lendingInstitutions/updateById',
    LendingInstitutionsEnable: MicroServer.plusFmsWeb + '/lendingInstitutions/enable',
    LendingInstitutionsDisable: MicroServer.plusFmsWeb + '/lendingInstitutions/disable',
    LendingInstitutionsSearch: MicroServer.plusFmsWeb + '/lendingInstitutions/search/list',
    //收退款关系
    ChargebackRelationshipList: MicroServer.plusFmsWeb + '/chargebackRelationship/findList',
    ChargebackRelationshipSaveOrUpdate:
      MicroServer.plusFmsWeb + '/chargebackRelationship/saveOrUpdateChargebackRelationship',
    ChargebackRelationshipDelete:
      MicroServer.plusFmsWeb + '/chargebackRelationship/deleteChargebackRelationshipById',
    ChargebackRelationshipEnabled: MicroServer.plusFmsWeb + '/chargebackRelationship/enabled',
    ChargebackRelationshipDisabled: MicroServer.plusFmsWeb + '/chargebackRelationship/disabled',
    ChargebackRelationshipById:
      MicroServer.plusFmsWeb + '/chargebackRelationship/findChargebackRelationshipById',
    // 收款计划
    ReceiptRulesPlanMainPageList: MicroServer.plusFmsWeb + '/rulesPlanMain/search/page',
    ReceiptRulesPlanMainList: MicroServer.plusFmsWeb + '/rulesPlanMain/search/list',
    ReceiptRulesPlanMain: MicroServer.plusFmsWeb + '/rulesPlanMain',
    ReceiptRulesPlanMainUpdateById: MicroServer.plusFmsWeb + '/rulesPlanMain/updateById',
    ReceiptRulesPlanMainIsEnabled: MicroServer.plusFmsWeb + '/rulesPlanMain/isEnabled',
    ReceiptFindSpecialRuleVariable:
      MicroServer.plusFmsWeb + '/planCommonController/findSpecialRuleVariable', //特殊规则所有变量值
    SpecialRulesLabelAdd: MicroServer.plusFmsWeb + '/specialRulesLabel', //特殊规则名称新增或者删除
    SpecialRulesLabelUpdateById: MicroServer.plusFmsWeb + '/specialRulesLabel/updateById', //特殊规则名称编辑
    SpecialRulesLabelList: MicroServer.plusFmsWeb + '/specialRulesLabel/search/list', //特殊规则名称列表
    SpecialRulesLabelPageList: MicroServer.plusFmsWeb + '/specialRulesLabelDetail/search/page', //特殊规则明细列表
    SpecialRulesDetailAdd: MicroServer.plusFmsWeb + '/specialRulesLabelDetail', //特殊规则明细新增或者删除
    SpecialRulesDetailIsEnabled: MicroServer.plusFmsWeb + '/specialRulesLabelDetail/isEnabled', //特殊规则明细启用禁用
    SpecialRulesDetailUpdateById: MicroServer.plusFmsWeb + '/specialRulesLabelDetail/updateById', //特殊规则明细编辑
    ReceiptRulesPlanMainRulesPlanDetail:
      MicroServer.plusFmsWeb + '/rulesPlanMain/selectRulesPlanDetail', //查询明细
    ReceiptRulesPlanRulesFullPlanDetail:
      MicroServer.plusFmsWeb + '/rulesFullPlanDetail/addRulesFullPlanDetail', //添加全额明细
    ReceiptRulesPlanRulesBranchPlan: MicroServer.plusFmsWeb + '/rulesBranchPlan', //添加分期
    ReceiptRulesPlanRulesDelete: MicroServer.plusFmsWeb + '/rulesFullPlanDetail', //全额
    ReceiptRulesPlanBranchDelete: MicroServer.plusFmsWeb + '/rulesBranchPlanDetail', //分期
    ReceiptRulesPlanAddRulesBranchPlanDetail:
      MicroServer.plusFmsWeb + '/rulesBranchPlanDetail/addRulesBranchPlanDetail', //添加分期明细
    //取数规则公式
    PlanCommonControllerRule:
      MicroServer.plusFmsWeb + '/planCommonController/findFetchRuleVariable',
    PlanCommonControllerFindRelevanceItem:
      MicroServer.plusFmsWeb + '/planCommonController/findRelevanceItem',
    PlanCommonControllerFindFetchType:
      MicroServer.plusFmsWeb + '/planCommonController/findFetchType',
    PlanCommonFindSpecialRuleVariableById:
      MicroServer.plusFmsWeb + '/planCommonController/findSpecialRuleVariableById',
    //收款服务
    FindOrderAccountDtlResponseByRequest:
      MicroServer.plusFmsWeb + '/orderAccount/findOrderAccountDtlResponseByRequest',
    // 优惠券详情
    FindResponseByCouponId:
      MicroServer.plusFmsWeb + '/couponSyncRecord/findResponseByCouponId',
    // 收款计划异常
    RulesPlanErrListByPage: MicroServer.plusFmsWeb + '/rulesPlanErr/search/page',
    RulesPlanErrListByRetry: MicroServer.plusFmsWeb + '/rulesPlanErr/retryRulesPlanErr',
    RulesPlanErrCloseOrderById: MicroServer.plusFmsWeb + '/rulesPlanErr/closeOrderById',
    TransactionCalDtlFindCalType: MicroServer.plusFmsWeb + '/transactionCalDtl/findCalType', //计算的收款类型
    CustServiceBillCalFindCalType: MicroServer.plusFmsWeb + '/custServiceBillCal/findCalType', //新计算的收款类型
    TransactionCalDtlFindCalListByRequest:
      MicroServer.plusFmsWeb + '/transactionCalDtl/findCalListByRequest', //收款规则类型计算充值的金额
    CustServiceBillCalFindCalListByRequest:
      MicroServer.plusFmsWeb + '/custServiceBillCal/findCustBillCalForOrderResponseForAdminByRequest', //新收款规则类型计算充值的金额
    //收款明细
    TransactionJournalFindListByPage: MicroServer.plusFmsWeb + '/transactionJournal/findListByPage',
    TransactionJournalSaveOrUpdate: MicroServer.plusFmsWeb + '/transactionJournal/saveOrUpdate',
    TransactionJournalSaveAndReceiveToAccount:
      MicroServer.plusFmsWeb + '/transactionJournal/saveAndReceiveToAccount',
    TransactionJournalReceiveToAccount:
      MicroServer.plusFmsWeb + '/transactionJournal/receiveToAccount', //确认收款
    TransactionJournalComfireToAccount:
      MicroServer.plusFmsWeb + '/transactionJournal/comfireToAccount', //确认到账
    TransactionJournalDelete: MicroServer.plusFmsWeb + '/transactionJournal/delete', //删除
    FindVerifyApplyResponseList:
      MicroServer.plusFmsWeb + '/verifyApply/findVerifyApplyResponseList', //核销明细查询
    VerifyApplyFindResponseListByPage:
      MicroServer.plusFmsWeb + '/verifyApply/findResponseListByPage', //核销明细分页查询
    CancelVerify: MicroServer.plusFmsWeb + '/verifyApply/cancelVerify', //取消核销
    FindCanVerifyApplyBillResponse:
      MicroServer.plusFmsWeb + '/verifyApply/findCanVerifyApplyBillResponseForHandle', //核销单据
    AddVerifyApplyForHandle: MicroServer.plusFmsWeb + '/verifyApply/addVerifyApplyForHandle', //确认核销
    SendTransactionElecListByTransactionId:
      MicroServer.plusFmsWeb + '/transactionElec/sendTransactionElecListByTransactionId', //发送电子收据
    DownloadTransactionElecList: MicroServer.plusFmsWeb + '/transactionElec/exportToExportTask', //下载电子收据 原接口/transactionElec/downloadTransactionElecList
    ModifyTransactionAmount: MicroServer.plusFmsWeb + '/transactionJournal/modifyAmount', //修改金额
    ComfireToAccountBatch: MicroServer.plusFmsWeb + '/transactionJournal/comfireToAccountBatch', //批量确认到账
    SendKdMsgAgain: MicroServer.plusFmsWeb + '/transactionJournal/sendKdMsgAgain', //重发金蝶消息
    //应收明细
    ReceiptApplyPageList: MicroServer.plusFmsWeb + '/receiptApply/searchVo/page', //列表
    FindQuotationTypes: MicroServer.plusFmsWeb + '/planCommonController/findQuotationTypes', //报价类型
    ReceiptApply: MicroServer.plusFmsWeb + '/receiptApply/addEntity', //新增
    ReceiptApplySubmit: MicroServer.plusFmsWeb + '/receiptApply/submitEntity', //提交
    FindCanPaymentApplyResponseForHandle:
      MicroServer.plusFmsWeb + '/paymentApply/findCanPaymentApplyResponseForHandle', //线上收款
    PaymentApplyForHandle: MicroServer.plusFmsWeb + '/paymentApply/addVerifyApplyForHandle', //获取支付订单id
    PaymentApplyAddAndVerfiyBatch: MicroServer.plusFmsWeb + '/transactionJournal/addAndVerfiyBatch', //线下收款
    PaymentApplySelectMainContractNo:
      MicroServer.plusFmsWeb + '/receiptApplyChangeRecord/selectMainContractNo', //查询合同
    HandlerNoEffectiveData:
      MicroServer.plusFmsWeb + '/receiptApply/handlerNoEffectiveData', //手动生效
    receiptApplyDeleteApply:
      MicroServer.plusFmsWeb + '/receiptApply/deleteApply', //删除
    // 发票
    OrderInvoiceList: MicroServer.plusFmsWeb + '/orderInvoice/findResponseListByPage', //列表
    OrderInvoiceSaveOrUpdate: MicroServer.plusFmsWeb + '/orderInvoice/saveOrUpdate', //
    OrderInvoiceDelete: MicroServer.plusFmsWeb + '/orderInvoice/deleteById', //
    // 退款
    RefundApplyPageList: MicroServer.plusFmsWeb + '/refundApply/findRefundApplyResponseListByPage',
    RefundApplyGet: MicroServer.plusFmsWeb + '/refundApply/findRefundApplyResponseById',
    RefundApplyUpdateRefundApplyPayState:
      MicroServer.plusFmsWeb + '/refundApply/updateRefundApplyPayState',
    RefundApplyUpdateRefundApplyInfo: MicroServer.plusFmsWeb + '/refundApply/updateRefundApplyInfo',
    RefundApplyLogList: MicroServer.plusFmsWeb + '/refundApplyLog/findListByPage',
    RefundApplyConfirmToAccountForHandle:
      MicroServer.plusFmsWeb + '/refundApply/confirmToAccountForHandle', //已退款
    RefundApplyReceiveToAccountForHandle:
      MicroServer.plusFmsWeb + '/refundApply/receiveToAccountForHandle', //确认退款
    SelectUnionPlan: MicroServer.plusFmsWeb + '/receiptApplyChangeRecord/selectUnionPlan', //
    ChooseChangePlanMain: MicroServer.plusFmsWeb + '/receiptApplyChangeRecord/chooseChangePlanMain', //
    GetTradingStatementList: MicroServer.plusFmsWeb + '/receiptApply/getTradingStatementList', //  订单详情-交易流水  ---查通项
    // 转款
    TransferListByRequest: MicroServer.plusFmsWeb + '/refundApply/findCanTransferListByRequest', // 通过交易类型 查询可转余额
    AddTransferApply: MicroServer.plusFmsWeb + '/transferApply/addTransferApply', //
    TransferFindDetailResponseByRequest:
      MicroServer.plusFmsWeb + '/transferApply/findDetailResponseByRequest', //转款 查询
    TransferFindResponseListByPage:
      MicroServer.plusFmsWeb + '/transferApply/findResponseListByPage', //转款 查询列表
    AddPaymentApplyForOrder: MicroServer.plusFmsWeb + '/paymentApply/addPaymentApplyForOrder', // 获取支付Id
    FindCanRefundTrans:
      MicroServer.plusFmsWeb + '/refundApply/findCanRefundTransTypeResponseForHandleByRequest', // 查询可退金额
    // 异常
    FindRulesPlanErrCountResponse:
      MicroServer.plusFmsWeb + '/rulesPlanErr/findRulesPlanErrCountResponse', // 收款计划异常数量
    FindJDResponseListByPage: MicroServer.plusFmsWeb + '/jdPaymentApply/findResponseListByPage', // 分页查询京东款项列表
    FindReceiptApplyForJdPayResponseListByRequest:
      MicroServer.plusFmsWeb + '/receiptApply/findReceiptApplyForJdPayResponseListByRequest', // 查询收款list
    SubmitForPreViewList:
      MicroServer.plusFmsWeb + '/jdPaymentApply/findCanPaymentApplyResponseForHandle', // 提交应收单查看收款类型
    AddOrUpdatePaymentApply: MicroServer.plusFmsWeb + '/jdPaymentApply/addOrUpdatePaymentApply', // 新增京东收款
    CancelPaymentApply: MicroServer.plusFmsWeb + '/jdPaymentApply/cancelPaymentApply', // 取消收款
    PaymentPayedWithLog: MicroServer.plusFmsWeb + '/jdPaymentApply/paymentPayedWithLog', // 重新生成收款单
    FindDetailResponseByRequest:
      MicroServer.plusFmsWeb + '/jdPaymentApply/findDetailResponseByRequest', // 查询收款详情
    // 日志
    SearchResponsePageByParams:
      MicroServer.plusFmsWeb + '/fmsSyncKingdeeRecord/searchResponsePageByParams', // 同步金额日志列表
    SendSyncKingdeeRecordMessageReqeust:
      MicroServer.plusFmsWeb + '/fmsSyncKingdeeRecord/sendSyncKingdeeRecordMessageReqeust', // 同步金额日志重发
    GetSyncResultStatusList:
      MicroServer.plusFmsWeb + '/fmsSyncKingdeeRecord/getSyncResultStatusList', // 同步金额日志
    GetOperateTypeList: MicroServer.plusFmsWeb + '/fmsSyncKingdeeRecord/getOperateTypeList', // 同步金额日志
    //白名单
    WhiteConfigFindResponseListByPage: MicroServer.plusFmsWeb + '/receiptWhiteConfig/findResponseListByPage',
    WhiteConfigUpdateEnabled: MicroServer.plusFmsWeb + '/receiptWhiteConfig/updateEnabled',
    WhiteConfigSaveOrUpdateByRequest: MicroServer.plusFmsWeb + '/receiptWhiteConfig/saveOrUpdateByRequest',
    FindWhiteNodeResponseListByRequest: MicroServer.plusFmsWeb + '/receiptWhiteConfig/findWhiteNodeResponseListByRequest', //白名单节点
    FindAuditPassResponseListByPage: MicroServer.plusFmsWeb + '/receiptWhiteApply/findAuditPassResponseListByPage', //白名单列表
    StartReceiptWhiteApplyProcess: MicroServer.plusFmsWeb + '/fmsFlow/startReceiptWhiteApplyProcess', //收款白名单流程发起
    FindOrderAccountDtlResponseByOrderIdRequest: MicroServer.plusFmsWeb + '/orderAccount/findOrderAccountDtlResponseByOrderIdRequest', //获取收款详情，白名单审批使用
    WhiteApplyFindDetailResponseByRequest: MicroServer.plusFmsWeb + '/receiptWhiteApply/findDetailResponseByRequest', // 查询白名单详情
    // 查看全部的 收款 应收 退款
    receiptApplyFindResponseListByPageForMainPage: MicroServer.plusFmsWeb + '/receiptApply/findResponseListByPageForMainPage', //应收
    transactionJournalFindResponseListByPageForMainPage: MicroServer.plusFmsWeb + '/transactionJournal/findResponseListByPageForMainPage', //收款
    refundApplyFindResponseListByPageForMainPage: MicroServer.plusFmsWeb + '/refundApply/findResponseListByPageForMainPage', //退款
  },
  Deal: {
    GetDealkingTalkOrderPage: MicroServer.deal + `/dealkingTalkOrder/search/page`,
    DealkingTalkOrder: MicroServer.deal + `/dealkingTalkOrder`,
    UpdateDealkingTalkOrder: MicroServer.deal + `/dealkingTalkOrder/updateById`,
    GetCustemerCase: MicroServer.deal + '/dealkingTalkOrderSuggest/getCustemerCase/',
    SearchDealkingLifeSpaceList: MicroServer.deal + `/dealkingLifeSpace/search/list`,
    SearchDealkingLifeSceneList: MicroServer.deal + `/dealkingLifeScene/search/list`,
    SearchDealkingSpaceCaseTagList: MicroServer.deal + `/dealkingSpaceCaseTag/search/list`,
    AddDealkingSpaceCase: MicroServer.deal + `/dealkingSpaceCase/addOrUpdateCase`,
    GetDealkingSpaceCasePage: MicroServer.deal + `/dealkingSpaceCase/search/getPage`,
    DealTalkOrderHomeConfDelHomeConfById:
      MicroServer.deal + '/dealkingTalkOrderHomeConf/delHomeConfById', // 谈单首页配置 -- 删除
    DealkingTalkOrderHomeConfSearchPage:
      MicroServer.deal + '/dealkingTalkOrderHomeConf/search/page', // 谈单首页配置 -- 分页
    DealkingTalkOrderHomeConfHasBusPower:
      MicroServer.deal + '/dealkingTalkOrderHomeConf/hasBusPower', // 谈单首页配置 -- 查询是否拥有业务权限
    DealkingTalkOrderHomeConfSearchList:
      MicroServer.deal + '/dealkingTalkOrderHomeConf/getHomeConfWithBus', // 谈单首页配置 -- 查询分页列表(添加业务权限验证)
    DealkingTalkOrderHomeConfSaveOrUpdateFirstMenu:
      MicroServer.deal + '/dealkingTalkOrderHomeConf/saveOrUpdateFirstMenu', // 谈单首页配置 -- 二级菜单  -- 编辑或新增
    DealkingTalkOrderHomeConfUpdateById: MicroServer.deal + '/dealkingTalkOrderHomeConf/updateById', // 谈单首页配置  -- 编辑
    DealkingTalkOrderHomeConf: MicroServer.deal + '/dealkingTalkOrderHomeConf', // 谈单首页配置  -- 新增
    DealkingTalkOrderHomeConfDtlSearchPage:
      MicroServer.deal + '/dealkingTalkOrderHomeConfDtl/search/page', // 广告列表 -- 分页
    DealkingTalkOrderHomeConfDtlSearchList:
      MicroServer.deal + '/dealkingTalkOrderHomeConfDtl/getDtlPageWithWlist', // 广告列表 -- 分页
    DealkingTalkOrderHomeConfDtl: MicroServer.deal + '/dealkingTalkOrderHomeConfDtl', //广告列表 -- 删除
    TalkOrderHomeConfDtlBatchDeleteByIds:
      MicroServer.deal + '/dealkingTalkOrderHomeConfDtl/batchDeleteByIds', // 广告列表批量删除
    DealkingTalkOrderHomeConfDtlUpdateById:
      MicroServer.deal + '/dealkingTalkOrderHomeConfDtl/updateById', //广告列表 -- 编辑
    InsertOrUpdateOhcDtlVo:
      MicroServer.deal + '/dealkingTalkOrderHomeConfDtl/insertOrUpdateOhcDtlVo', //广告列表 -- 编辑、保存
    BatchInsertOhcDtlVo: MicroServer.deal + '/dealkingTalkOrderHomeConfDtl/batchInsertOhcDtlVo', //广告列表 -- 批量保存
    DealkingLifeSpaceSearchPage: MicroServer.deal + '/dealkingLifeSpace/search/page', // 空间类型管理--分页列表
    DealkingLifeSpaceSearchList: MicroServer.deal + '/dealkingLifeSpace/search/list', // 空间类型 -- 列表
    DealkingLifeSpace: MicroServer.deal + '/dealkingLifeSpace', // 空间类型  -- 新增
    DealkingLifeSpaceUpdateById: MicroServer.deal + '/dealkingLifeSpace/updateById', // 空间类型  -- 编辑
    DealkingLifeSceneSearchPage: MicroServer.deal + '/dealkingLifeScene/search/page', // 生活场景管理 -- 分页列表
    DealkingLifeScene: MicroServer.deal + '/dealkingLifeScene', // 生活场景管理  -- 新增
    DealkingLifeSceneUpdateById: MicroServer.deal + '/dealkingLifeScene/updateById', // 生活场景管理  -- 编辑
    DealkingVenueQrCodeSearchPage: MicroServer.deal + '/dealkingVenueQrCode/search/page', // 场馆二维码 -- 分页
    DealkingVenueQrCode: MicroServer.deal + '/dealkingVenueQrCode/delVenueQrCodeById/', // 场馆二维码 -- 删除
    DealkingVenueQrCodeUpdateById: MicroServer.deal + '/dealkingVenueQrCode/saveVenueQrCode', // 场馆二维码 -- 编辑
    DealkingVenueQrCodeSearchList: MicroServer.deal + '/dealkingVenueQrCode/search/list', // 展厅分类 -- 用于下拉
    DealKingRoleSaleProductList: MicroServer.deal + '/dealKingRoleSaleProduct/search/page', //角色产品配置列表
    DelRoleSaleProductById: MicroServer.deal + '/dealKingRoleSaleProduct/delRoleSaleProductById/', // 角色产品配置 -- 删除
    SaveRoleSaleProduct: MicroServer.deal + '/dealKingRoleSaleProduct/saveRoleSaleProduct', // 角色产品配置 -- 新增编辑
    GetDealkingBuildPlanList: MicroServer.deal + '/buildPlan/search/page', // DreamHome -- 楼盘方案列表
    AddOrDeleteDealkingBuildPlan: MicroServer.deal + '/buildPlan', // DreamHome -- 楼盘方案新增/删除
    UpdateDealkingBuildPlan: MicroServer.deal + '/buildPlan/updateById', // DreamHome -- 楼盘方案编辑
    GetBuildPlanConfList: MicroServer.deal + '/buildPlanConf/search/page', // DreamHome -- 楼盘方案配置列表
    AddOrDeleteBuildPlanConf: MicroServer.deal + '/buildPlanConf', // DreamHome -- 楼盘方案配置新增/删除
    UpdateDBuildPlanConf: MicroServer.deal + '/buildPlanConf/updateById', // DreamHome -- 楼盘方案配置编辑

    GetBuildPlanConfList1: MicroServer.deal + '/dealKingSaleProductStyle/search/page', // DreamHome -- 楼盘方案配置列表
    AddOrDeleteBuildPlanConf1: MicroServer.deal + '/dealKingSaleProductStyle', // DreamHome -- 楼盘方案配置新增/删除
    UpdateDBuildPlanConf1: MicroServer.deal + '/dealKingSaleProductStyle/updateById', // DreamHome -- 楼盘方案配置编辑
    GetHomeConfigTree: MicroServer.deal + '/dealkingTalkOrderHomeConf/getHomeConfigTree', // DreamHome -- 查询子级菜单树
    GetHomeConfigTreePagee: MicroServer.deal + '/dealkingTalkOrderHomeConf/getHomeConfigTreePage', // DreamHome -- 查询分页子级菜单树
    GetCustomerTag: MicroServer.deal + '/customerTag/search/list', // 查询标签
    GetUserCompanys: MicroServer.deal + '/dealkingTalkOrder/getUserCompanys', // 获取公司信息 过滤后数据
  },
  PlusTradeWeb: {
    findBuildingInfoForOrderResponseByRequest: MicroServer.plusTradeWeb + '/order/findBuildingInfoForOrderResponseByRequest', // 查楼盘
    GetOrderList: MicroServer.plusTradeWeb + '/order/search/page', // 订单列表
    OrderOpreation: MicroServer.plusTradeWeb + '/order', // 订单列表删除接口
    GetSelectBudgetDrawing: MicroServer.plusTradeWeb + '/quoteGoodsExt/selectBudgetDrawing', // 订单详情-图纸查询
    SaveOrUpdateBudgetDrawing:
      MicroServer.plusTradeWeb + '/quoteGoodsExt/saveOrUpdateBudgetDrawing', // 订单详情-图纸保存
    ReUploadDrawer:
      MicroServer.plusTradeWeb + '/packagedDrawingAuditManage/reUploadDrawing', // 订单详情-再次上传图纸
    GetQueryHousrInfo: MicroServer.plusTradeWeb + '/quoteBudgetItem/queryHousrInfo', // 订单详情-查询户型
    GetElecConctList: MicroServer.plusTradeWeb + '/elecConct/search/list', // 订单详情-合同列表
    // DelElecConct: MicroServer.plusTradeWeb + '/elecConct', // 订单详情-合同列表-删除
    DelElecConct: MicroServer.plusTradeWeb + '/elecConct/deleteElecConctSupport', // 订单详情-合同列表-删除-新
    GetquoteBudgetList: MicroServer.plusTradeWeb + '/quoteBudget/search/list', // 订单详情-报价列表
    GetOrderRelativesList: MicroServer.plusTradeWeb + '/orderRelatives/search/list', // 订单详情-服务人员
    OrderRelativesUpdate: MicroServer.plusTradeWeb + '/orderRelatives/batch/update', // 订单详情-服务人员 修改提交
    GetQuoteGoodsList: MicroServer.plusTradeWeb + '/quoteGoods/search/list', // 直接付款 订单详情
    GetQuoteFormat: MicroServer.plusTradeWeb + '/quoteGoods/getQuoteFormat', //  修改规格
    UpdateQuoteFormat: MicroServer.plusTradeWeb + '/quoteGoods/updateQuoteFormat', //  修改规格 提交
    QuoteBudgetItemTree: MicroServer.plusTradeWeb + '/quoteBudgetItem/queryTree', //  查询分类树
    QueryProjectTree: MicroServer.plusTradeWeb + '/quoteBudgetItem/queryProjectTree', //  查询项目/子项树
    ListBudgetDtl: MicroServer.plusTradeWeb + '/quoteBudgetDtl/listBudgetDtl', //  报价明细查询
    DtlDifferenceList: MicroServer.plusTradeWeb + '/quoteBudgetDtl/dtlDifferenceList', //  差异化清单查询
    SelectGeneralTerm: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/selectGeneralTerm', //  查询条件-报价通项
    SelectBrandByGeneralTerm: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/listBrand', //  查询条件-品牌列表  ---查通项
    GeneralSearch: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/generalSearch', //  通项列表查询  ---查通项
    ProjectSearch: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/projectSearch', //  搜索-项目选材搜索
    ProjectSearchPage: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/projectSearchPage', //  搜索-项目选材搜索分页
    GeneralSearchPage: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/generalSearchPage', //  搜索-通项选材搜索分页
    UpDownSearchPage: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/upDownSearchPage', //  搜索-升降级选材搜索分页
    AdditionSearchPage: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/additionSearchPage', //  搜索-增项选材搜索分页
    QueryItemOptional: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/queryItemOptional', //  查询空间
    SaveBudgetDtl: MicroServer.plusTradeWeb + '/quoteBudgetDtl/batch/saveBudgetDtl', //  保存选材
    GetElecConctSupport: MicroServer.plusTradeWeb + '/elecConct/getElecConctSupportOrderCheck', //  通过订单号查询电子合同接口
    OrderServicePersonnel: MicroServer.plusTradeWeb + '/orderRelatives/orderServicePersonnel/', // 查询订单服务人员
    OrderServicePersonnelUpdate:
      MicroServer.plusTradeWeb + '/orderRelatives/orderServicePersonnelUpdate/', // 变更订单服务人员
    QuickPlaceOrder: MicroServer.plusTradeWeb + '/order/quickPlaceOrder', // 快速创建订单
    // 新增报价
    QuoteBudgetSelectBudgetInitArg: MicroServer.plusTradeWeb + '/quoteBudget/selectBudgetInitArg', // 根据goodsId查询关联规格参数
    UpdateQuoteBudgetId: MicroServer.plusTradeWeb + '/quoteBudget/updateById', // 编辑报价
    QuoteBudgetSelectCreatorEntryPrice:
      MicroServer.plusTradeWeb + '/quoteBudget/selectCreatorEntryPrice', // 根据所选报价类型查询关联费用项参数
    QuoteBudgetInitQuoteBudgetItem: MicroServer.plusTradeWeb + '/quoteBudget/initQuoteBudgetItem', // 空间户型初始化
    MatchProductSku: MicroServer.plusTradeWeb + '/quoteBudget/matchProductSku', // 输入型参数初始化
    AddQuoteBudget: MicroServer.plusTradeWeb + '/quoteBudget/addQuoteBudget',
    // 户型管理
    QueryHouseInfo: MicroServer.plusTradeWeb + '/quoteBudgetItem/queryHouseInfo',
    SaveHouseInfo: MicroServer.plusTradeWeb + '/quoteBudgetItem/saveHouseInfo',

    QuoteBudgetPriceQueryTree: MicroServer.plusTradeWeb + '/quoteBudgetPrice/queryTree', // 查询价格明细分类树
    CalcQuoteBudgetPrice: MicroServer.plusTradeWeb + '/quoteBudgetPrice/calcQuoteBudgetPrice', // 查询价格明细分类树
    RefreshQuoteBudgetPrice: MicroServer.plusTradeWeb + '/quoteBudgetPrice/refreshQuoteBudgetPrice', // 刷新价格
    QuoteBudgetSelectQuoteBudgetInfo:
      MicroServer.plusTradeWeb + '/quoteBudget/selectQuoteBudgetInfo', //选材- 获取订单信息
    SelectQuoteBudgetDtlRefTypeEnum:
      MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/selectQuoteBudgetDtlRefType', // 选材类型
    ListProductCategory: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/listProductCategory', //  查询条件-产品分类列表
    ListBrand: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/listBrand', //  查询条件-品牌列表
    AdditionSearch: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/additionSearch', //  搜索-增项选材搜索
    AdditionSearchForGeneral: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/additionSearchForGeneral', //  搜索-增项选材通项搜索
    CalcExpress: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/calcExpress', //  选材过程-表达式计算
    ListProductSkuRelationSpuFormat:
      MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/selectProductSpu', //  选材过程-显示sku对应的spu的规格
    SubtractSearch: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/subtractNewSearch', //  搜索-减项选材搜索
    GetEnums: MicroServer.plusTradeWeb + '/enums/', // 交易枚举获取
    CancelOrder: MicroServer.plusTradeWeb + '/order/cancel', // 取消订单
    GetBudgetPrintInfoMap:
      MicroServer.plusTradeWeb + '/outer/budget/getBudgetPrintInfoMapBySignTemplate', // 查合同列表
    StartOfflineContract: MicroServer.plusTradeWeb + '/quoteBudget/startOfflineContract', // 发起线下电子合同
    SureProductSkuBySpuAndFormatArgs:
      MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/sureProductSkuBySpuAndFormatArgs', // 选材过程-根据spu以及规格对应的sku
    GetListBudgetItem:
      MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/listBudgetItemExcludeGeneralCategory', // 项目选材-项目列表
    CheckGeneralStandard: MicroServer.plusTradeWeb + '/quoteBudgetDtl/checkGeneralStandard', // 选材校验
    SubmitOfflineElec: MicroServer.plusTradeWeb + '/elecConct/submitOfflineElec', // 提交签约
    DeleteQuoteBudgetDtl: MicroServer.plusTradeWeb + '/quoteBudgetDtl/', //  根据Id删除数据 选材页面
    DeleteByIdAndBudgetId: MicroServer.plusTradeWeb + '/quoteBudgetDtl/deleteByIdAndBudgetId/', //  删除产品 选材页面
    DeleteQuoteBudget: MicroServer.plusTradeWeb + '/quoteBudget/', //  根据Id删除报价
    UpdateDynaOptions: MicroServer.plusTradeWeb + '/quoteBudgetDtl/updateDynaOptions', //  修改动态属性 --报价明细页面
    UpdateBudgetField: MicroServer.plusTradeWeb + '/quoteBudgetDtl/updateBudgetField', //  修改动态属性 --报价明细页面
    ChooseCheck: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/chooseCheck', //  选材检查
    SubSearchList: MicroServer.plusTradeWeb + '/quoteBudgetDtl/search/list', //  减项查询 物料明细
    StartRefundRetail: MicroServer.plusTradeWeb + '/refundRetail/startRefundRetail', //  零售退款
    QueryActivity: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/queryActivity', //  活动查询 活动列表
    QueryActivityProduct:
      MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/queryActivityProduct', //  活动选材 分页查询
    StartRefundNonRetail: MicroServer.plusTradeWeb + '/refundNonRetail/startRefundNonRetail', //  退单非零售，校验是否可退单
    StartRefundDeposit: MicroServer.plusTradeWeb + '/refundDeposit/startRefundDeposit', //  退定金
    StartRefundDesign: MicroServer.plusTradeWeb + '/refundDesign/startRefundDesign', //  退设计费
    StartRefundBalance: MicroServer.plusTradeWeb + '/refundBalance/startRefundBalance', //  退余额
    StartRefundReSign: MicroServer.plusTradeWeb + '/refundReSign/startRefundReSign', //  退单重签
    StartRefundReSignGetOrders: MicroServer.plusTradeWeb + '/refundReSign/getOrders', //  退单重签可选订单
    StartAbnormalReturn: MicroServer.plusTradeWeb + '/abnormalReturn/startAbnormalReturn', //  异常退单
    StartMerchOverflow: MicroServer.plusTradeWeb + '/merchOverflow/startMerchOverflow', //  超标优惠
    StartCompleteDrawing:
      MicroServer.plusTradeWeb + '/packagedDrawingAuditManage/startCompleteDrawing', //  发起整装图纸审核申请
    UpdateChooseFlag: MicroServer.plusTradeWeb + '/quoteBudgetItem/updateChooseFlag', //  修改选材状态
    UpDownSearch: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/upDownSearch', //  修改选材状态
    GetDtlRefType:
      MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/materialChange/getDtlRefType', //  缺断货可选类型
    SelectMainSpaceSpec:
      MicroServer.plusTradeWeb + '/quoteBudget/selectMainQuoteBudgetItemExistSpaceSpec', //  回显空间规格
    PreviewPackagedDrawingPdf:
      MicroServer.plusTradeWeb + '/packagedDrawingAuditManage/previewPackagedDrawingPdf', //  整装图纸预览
    FindSuppliersByOrderId:
      MicroServer.plusTradeWeb + '/customDrawingAuditManage/findSuppliersByOrderId', //  根据orderId查询供应商
    QuoteGoodsDetail: MicroServer.plusTradeWeb + '/quoteGoods', // 查详情
    SaveOrUpdateCustomDrawing:
      MicroServer.plusTradeWeb + '/quoteGoodsExt/saveOrUpdateCustomDrawing', // 定制图纸保存
    SelectCustomDrawing: MicroServer.plusTradeWeb + '/quoteGoodsExt/selectCustomDrawing', // 定制图纸查询
    updatePackDtl: MicroServer.plusTradeWeb + '/quoteBudgetDtl/updatePackDtl', // 修改套件明细
    StartCustomDrawing: MicroServer.plusTradeWeb + '/customDrawingAuditManage/startCustomDrawing', // 定制图纸审核
    SelectCustomDrawingDetail:
      MicroServer.plusTradeWeb + '/customDrawingAuditManage/selectCustomDrawingDetail', // 定制图纸详情
    DeleteCustomDrawingProcessInstance:
      MicroServer.plusTradeWeb + '/customDrawingAuditManage/deleteCustomDrawingProcessInstance', // 定制图纸撤回
    OrderGetButton: MicroServer.plusTradeWeb + '/order/getButton', // 订单按钮
    GetByFlowKeyAndOrderld: MicroServer.plusTradeWeb + '/busWorkFlow/getByFlowKeyAndOrderld', // 订单按钮
    SelectMaterialDynaOptions:
      MicroServer.plusTradeWeb + '/quoteBudgetDtl/selectMaterialDynaOptions', // 查询物料动态属性
    UpdateMaterialDynaOptions:
      MicroServer.plusTradeWeb + '/quoteBudgetDtl/updateMaterialDynaOptions', // 修改物料动态属性
    StartBpmFlow: MicroServer.plusTradeWeb + '/busWorkFlow/modifyContractAddress/startBpmFlow', //  发起修改合同地址流程
    OrderReplaceGoods: MicroServer.plusTradeWeb + '/quoteGoods/replace', // 订单替换商品
    CheckTemplateUpdate: MicroServer.plusTradeWeb + '/quoteBudget/checkTemplateUpdate', // 订单中打包数据否有更新
    ChangeBaseInfo: MicroServer.plusTradeWeb + '/quoteBudget/updateBasicInfo', // 订单中打包数据否有更新
    BudgetForSpecialCode: MicroServer.plusTradeWeb + '/quoteBudget/special-codes', // 根据报价类型获取对应的特殊代码集合
    BudgetForAllSpecialCode: MicroServer.plusTradeWeb + '/quoteBudget/all-codes', // 查询所有特殊代码映射集合
    GetJdPin: MicroServer.plusTradeWeb + '/quoteGoods/showBindJdButton', //  是否展示绑定京东订单号的按钮
    BindJdOrder: MicroServer.plusTradeWeb + '/order/bindJdOrder', // 绑定京东订单号
    GetCapitalPool: MicroServer.plusTradeWeb + '/quoteBudget/capitalPool', // 查询资金池详情
    GetConfigurations: MicroServer.plusTradeWeb + '/quoteBudget/configurations', // 查询配置清单详情
    ListBudgetDtlSimple: MicroServer.plusTradeWeb + '/quoteBudgetDtl/listBudgetDtlSimple', // 资金池详情-产品列表
    MerchOverflowList: MicroServer.plusTradeWeb + '/merchOverflow/search/list', // 优惠超标-列表
    getSubSearch: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/subtractNewSearch', // 获取减项选材列表
    StartDurationFlow: MicroServer.plusTradeWeb + '/durationApply/startDurationFlow', // 标准工期管理-发起开工待定锁定流程
    OrderStandInStartWorkFlow: MicroServer.plusTradeWeb + '/order/orderStandInStartWorkFlow', // 订单是否处于开工流程
    AdditionSearchForSpecialAdd: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/additionSearchForSpecialAdd', // 搜索-通项-预置产品增项选材搜索
    CheckForNotifyCustomer: MicroServer.plusTradeWeb + '/projectStartDateLog/checkForNotifyCustomer', // 预计开工时间-通知客户-校验[ADD]
    NotifyCustomer: MicroServer.plusTradeWeb + '/projectStartDateLog/notifyCustomer', // 预计开工时间-通知客户-发送
    CheckExpectProjectStartDate: MicroServer.plusTradeWeb + '/projectStartDateLog/checkExpectProjectStartDate', // 预计开工时间-查询预计开工时间[ADD]-检查是否发起合同
    GetOrderProjectPlan: MicroServer.plusTradeWeb + '/outer/pms/showOrderProjectPlan', //  获取开工资源占用详情
    SubmitOrderProjectPlan: MicroServer.plusTradeWeb + '/outer/pms/submitOrderProjectPlan', //  保存开工资源占用详情
    FindTemplateAndSubs: MicroServer.plusTradeWeb + '/outer/pms/findTemplateAndSubs', //  预计工期
    GetButtonNew: MicroServer.plusTradeWeb + '/order/getButtonNew', //  查交底单按钮
    QuoteBudgetItemType: MicroServer.plusTradeWeb + '/quoteBudgetItem/search/list', // 可选材类型查询（增项、升降级、优惠......）
    GetAllSapce: MicroServer.plusTradeWeb + '/quoteBudgetItem/queryTreeNew', // 获取所有空间
    BatchUpdateSort: MicroServer.plusTradeWeb + '/quoteBudgetItem/batchUpdateSort', // 空间排序
 
    SearchDiagramReviewConfig: MicroServer.plusTradeWeb + '/diagramReviewConfig/search/page', // 查询图审配置
    AddDiagramReviewConfig: MicroServer.plusTradeWeb + '/diagramReviewConfig', // 新增图审配置
    EditDiagramReviewConfig: MicroServer.plusTradeWeb + '/diagramReviewConfig/updateById', // 编辑图审配置
    DeleteDiagramReviewConfig: MicroServer.plusTradeWeb + '/diagramReviewConfig/', // 删除图审配置
    InitiateSchemeReview: MicroServer.plusTradeWeb + '/quotationProposalFlow/initiateSchemeReview', // 发起设计方案审核
    SubmitSchemeReview: MicroServer.plusTradeWeb + '/quotationProposalFlow/submitSchemeReview', // 提交设计方案审核
    CheckQuoteElecConct: MicroServer.plusTradeWeb + '/quotationProposalFlow/checkQuoteElecConct', // 发起电子合同校验
    GetQuotationFlowEnum: MicroServer.plusTradeWeb + '/enums/com.shj.saas.plus.trade.enums.QuotationFlowEnum', // 图审审核状态枚举
    QuotationProposalPage: MicroServer.plusTradeWeb + '/quotationProposalFlow/quotationProposalPage', // 图审审核列表
    ListBudgetDtlByDiff: MicroServer.plusTradeWeb + '/quoteBudgetDtl/listBudgetDtlByDiff', //  回显空间规格
    SubSearchListProcess: MicroServer.plusTradeWeb + '/quoteBudgetDtl/listBudgetDtlSubByDiff', // 查询减项
    SelectBudgetDrawingByDiff: MicroServer.plusTradeWeb + '/quoteGoodsExt/selectBudgetDrawingByDiff', //  图纸对比
    GetAuditRecord: MicroServer.plusTradeWeb + '/quotationProposalFlow/auditRecord', //  审核记录查询
    QueryReviewApproval: MicroServer.plusTradeWeb + '/quotationProposalFlow/queryReviewApproval', //  审核批复详情查询
    SaveReviewApproval: MicroServer.plusTradeWeb + '/quotationProposalFlow/saveReviewApproval', //  审核批复保存
    SelectRefActivityOrder: MicroServer.plusTradeWeb + '/order/selectRefActivityOrder', // 订单详情拉活动横幅
    CheckWarningBeforeContract: MicroServer.plusTradeWeb + '/quoteBudget/checkWarningBeforeContract', // 校验合同发起是否有优惠券
    UpdateQuoteBudgetDtl: MicroServer.plusTradeWeb + '/quoteBudgetDtl/updateQuoteBudgetDtl', // 修改规格 动态属性 组合信息
    BatchUpdateOrderSeq: MicroServer.plusTradeWeb + '/quoteBudgetDtl/batchUpdateOrderSeq', // 排序
    QueryChooseButton: MicroServer.plusTradeWeb + '/quoteBudgetProductChoose/queryChooseButton', // 选材按钮
    ExportCheckList: MicroServer.plusTradeWeb + '/quoteBudget/exportCheckList', // 导出选材清单
    CheckDesignerSetStartWorkDate: MicroServer.plusTradeWeb + '/order/checkDesignerSetStartWorkDate', // 占用开工校验接口
    BatchUpdateQuoteSort: MicroServer.plusTradeWeb + '/quotationProposalFlow/batchUpdateQuoteSort', // 排序
    GetVerifyStateEnum: MicroServer.plusTradeWeb + '/enums/com.shj.saas.plus.fms.enums.VerifyStateEnum', // 核销状态
  },
  PmsWeb: {
    QueryConstructionItem: MicroServer.pmsWeb + '/constructionItem/search/page', //  施工库分页查询
    QueryconstructionItemCategory: MicroServer.pmsWeb + '/constructionItemCategory/findList', //  施工库分类树
    ChooseSubmit: MicroServer.pmsWeb + '/outer/construction/chooseSubmit', //  选择提交
    AllSubmit: MicroServer.pmsWeb + '/outer/construction/allSubmit', //  全部提交
    VerifyOuterData: MicroServer.pmsWeb + '/projectStartWork/verifyOuterData', //  外部数据校验
    StartWork: MicroServer.pmsWeb + '/projectStartWork/startWork', //  申请开工
    submitPageDetail: MicroServer.pmsWeb + '/projectStartWork/submitPageDetail', //  提交开工页面-详情
    GetProjectList: MicroServer.pmsWeb + '/projectInfo/getProjectList', //  获取项目列表
    GetScpPlan: MicroServer.pmsWeb + '/scpPlan/match', //  获取日历详情
    CalculateEndDate: MicroServer.pmsWeb + '/engineer/assign/calculateEndDate', //  预计完工日期
    SalesBenchJumpToProject: MicroServer.pmsWeb + '/projectInfo/salesBenchJump', //  根据商机id获取项目id， 销售工作台跳转项目详情
  },
  MpmsWeb: {
    QueryMpmsSpuList: MicroServer.mpmsWeb + '/spu/search/page', //  物料库分页查询
    QueryMpmsCategoryList: MicroServer.mpmsWeb + '/common/category/findList', //  物料库分类树
    ChooseSubmit: MicroServer.mpmsWeb + '/outer/spuToProd/chooseSubmit', //  选择提交
    AllSubmit: MicroServer.mpmsWeb + '/outer/spuToProd/allSubmit', //  全部提交
    ProdCombCreateTypeEnum:
      MicroServer.mpmsWeb + '/enums/com.shj.saas.mpms.enums.outer.ProdCombCreateTypeEnum', //  命名方式枚举
    CheckSpuAndCache: MicroServer.mpmsWeb + '/outer/spuToProd/checkSpuAndCache', //  组合检查存数据
    GetSpuCachePage: MicroServer.mpmsWeb + '/outer/spuToProd/spuCachePage', //  组合检查查数据
    GetCacheSpuSerListBySpuId: MicroServer.mpmsWeb + '/outer/spuToProd/getCacheSpuSerListBySpuId', //  服务设置查询
    SaveMaterialAndProdSerCache:
      MicroServer.mpmsWeb + '/outer/spuToProd/saveMaterialAndProdSerCache', //  服务设置保存
    MaterialToProdCombSubmit: MicroServer.mpmsWeb + '/outer/spuToProd/materialToProdCombSubmit', //  组合检查提交
    CleanMaterialToProdCombCache:
      MicroServer.mpmsWeb + '/outer/spuToProd/cleanMaterialToProdCombCache', //  组合检查取消清除缓存
    FindSpuFormatPage:
      MicroServer.mpmsWeb + '/outer/spu/findSpuFormatPage', //  查规格
    FindSpuModelPage:
      MicroServer.mpmsWeb + '/outer/spu/findSpuModelPage', //  查型号
  },

  SviMoa: {
    FindByProjectsId: MicroServer.sviMoa + '/common/projectsHisVersion/findByProjectsId', //美学大师：获取历史版本
    FindProjectPageList: MicroServer.sviMoa + '/common/projects/findProjectPageList', //美学大师：获取方案列表
    FindProHistoryPageList: MicroServer.sviMoa + '/common/projects/findProHistoryPageList', //美学大师：获取版本标签
    UpdateDealRecommendVersion: MicroServer.sviMoa + '/common/cases/updateDealRecommendVersion', //美学大师：添加版本标签
    FindCasesById: MicroServer.sviMoa + '/common/cases/findById', //美学大师：获取案例名称
    UpdateCases: MicroServer.sviMoa + '/common/cases/update', //美学大师：编辑案例
    SaveCases: MicroServer.sviMoa + '/common/cases/save', //美学大师：创建案例
    UpdateDashboardUser: MicroServer.sviMoa + '/common/cases/updateDashboardUser', //美学大师：修改添加成员
    FindDashboardUsers: MicroServer.sviMoa + '/common/cases/findDashboardUsers', //美学大师：
    ClearDashboardUsers: MicroServer.sviMoa + '/common/cases/clearDashboardUsers', //美学大师：删除成员
  },
  crmTool: {
    // 通话记录
    GetAudioRecordPage: MicroServer.crmTool + '/audioRecord/search/page',
    GetAudioRecordPageByCustomerId: MicroServer.crmTool + '/audioRecord/selectPageByCustomerId',//根据客户ID获取通话记录
    ExportAudioRecord: MicroServer.crmTool + '/audioRecord/exportAudioRecord',
    AudioRecordConformity: MicroServer.crmTool + '/audioRecord/conformity',
    // 通道回调配置
    GetSeatIpConfigPage: MicroServer.crmTool + '/seatIpConfig/search/page',
    GetSeatIpConfigList: MicroServer.crmTool + '/seatIpConfig/search/list',
    SeatIpConfigSave: MicroServer.crmTool + '/seatIpConfig',
    SeatIpConfigDel: MicroServer.crmTool + '/seatIpConfig/',
    SeatIpConfigUpdate: MicroServer.crmTool + '/seatIpConfig/updateById',
    // 坐席配置
    GetSeatAccountPage: MicroServer.crmTool + '/seatAccount/search/page',
    GetSeatAccountList: MicroServer.crmTool + '/seatAccount/search/list',
    SeatAccountSave: MicroServer.crmTool + '/seatAccount',
    SeatAccountDel: MicroServer.crmTool + '/seatAccount/',
    SeatAccountUpdate: MicroServer.crmTool + '/seatAccount/updateById',
    GetSeatAccount: MicroServer.crmTool + '/seatAccount/getByUserId/',
    UpdateZitongSeatAccount: MicroServer.crmTool + '/seatAccount/updateZitongSeatAccount', // 切换智通线路
    // 线路分配
    GetLineAllocationPage: MicroServer.crmTool + '/seatLineConfig/search/page',
    GetLineAllocationList: MicroServer.crmTool + '/seatLineConfig/search/list',
    AddLineAllocation: MicroServer.crmTool + '/seatLineConfig',
    UpdateLineAllocation: MicroServer.crmTool + '/seatLineConfig/updateById',
    DeleteLineAllocation: MicroServer.crmTool + '/seatLineConfig/',
    // 量房管理
    GetMeasureRoomPage: MicroServer.crmTool + '/measureRoom/measureRoomPage',
    GetMeasureRoomList: MicroServer.crmTool + '/measureRoom/search/list',
    AddMeasurePerson: MicroServer.crmTool + '/measureRoom/add', //新增量房客户
    ModifyMeasurePerson: MicroServer.crmTool + '/measureRoom/modifyMeasurePerson', //修改量房人
    ModifyAppointmentTime: MicroServer.crmTool + '/measureRoom/modifyAppointmentTime', //修改预约时间
    CancelMeasure: MicroServer.crmTool + '/measureRoom/cancelMeasure', //取消量房
    MeasurePrepare: MicroServer.crmTool + '/measureRoom/measurePrepare', //量房准备
    MeasureConfirm: MicroServer.crmTool + '/measureRoom/measureConfirm', //量房服务
    MeasureSend: MicroServer.crmTool + '/measureRoom/sendMeasureRoom/', //推送量房报告
    MeasureDetail: MicroServer.crmTool + '/measureRoom/detail/', //量房详情
    MeasureUpdateClueDtl: MicroServer.crmTool + '/measureRoom/updateClueDtl', //录入编辑量房信息-第二部保存
    MeasureRoomConfig: MicroServer.crmTool + '/measureRoomConfig/search/one', //检测配置-下拉数据
    MeasureRoomHouseInspection: MicroServer.crmTool + '/measureRoom/houseInspection', //录入编辑量房信息-第三步保存
    MeasureRoomUpdateMeasureDtl: MicroServer.crmTool + '/measureRoom/updateMeasureDtl', //录入编辑量房信息-第四步保存
    StartMeasureRoomProcess: MicroServer.crmTool + '/flow/startMeasureRoomProcess/', //发起量房报告流程
    MeasureRoomStatistics: MicroServer.crmTool + '/statistics/', //量房数据统计
    MeasureRoomAIPolish: MicroServer.crmTool + '/measureRoom/aiPolish', //量房报告AI润色

    ZhiTongSeatAccountInfo: MicroServer.crmTool + '/seatAccount/zitongSeatAccountInfo', //智通账号配置信息
    ZhiTongReturnCall: MicroServer.crmTool + '/seatAccount/returnCall/', //智通回拨
    GetSeatAccountOne: MicroServer.crmTool + '/seatAccount/search/one', //获取坐席
  },
  PlusJdTenantWed: {
    GetJdOrderList: MicroServer.plusJdTenantWed + '/jdOrderPool/search/list', // 查询可绑定的京东订单号
  },
  crmManageWeb: {
    GetCustomerList: MicroServer.custTenantWeb + '/customer/customerPage', // 获取客户管理详情
    AddOrEditCustomer: MicroServer.custTenantWeb + '/customer/addCustomer', // 新增或编辑客户
    GetCustomerInfo: MicroServer.custTenantWeb + '/customer', // 获取客户详情，根据id删除客户
    viewPhone: MicroServer.custTenantWeb + '/customer/viewPhoneBySource', // 查看客户电话
    getContactPhonesByld: MicroServer.custTenantWeb + '/contactPerson/getContactPhonesById', // 查看联系人手机号码
    viewWeChat: MicroServer.custTenantWeb + '/customer/viewWechatNoBySource', // 查看客户微信
    GetCustomerTrackPlan: MicroServer.plusCrmWeb + '/trackPlan/trackPlanPage', // 获取客户商机
    GetCustomerFollowRecord: MicroServer.plusCrmWeb + '/followLog/search/list', // 获取客户跟进记录
  },
  GoodsFrontendTenantWeb:{
    FavoritesAdd: MicroServer.goodsFrontendTenantWeb + '/favorites/add', // 添加收藏
    FavoritesDelete: MicroServer.goodsFrontendTenantWeb + '/favorites/remove', // 取消收藏
    FavoritesList: MicroServer.goodsFrontendTenantWeb + '/favorites/search/list', // 查询收藏
    SelectProductSpuDetail: MicroServer.goodsFrontendTenantWeb + '/goodsStore/selectProductSpuDetail', //商品详情
    GoodsStorePage: MicroServer.goodsFrontendTenantWeb + '/goodsStore/search/page', //商品详情
    GoodsStoreCategoryTree: MicroServer.goodsFrontendTenantWeb + '/goodsStoreCategory/search/tree', //查询商品库
    QueryApplyPackage: MicroServer.goodsFrontendTenantWeb + '/goodsStore/queryApplyPackage', //查询适用套餐
    BrandList: MicroServer.goodsFrontendTenantWeb + '/goodsStore/brand/list', //查询品牌
    OriginList: MicroServer.goodsFrontendTenantWeb + '/goodsStore/condition/origin', //产地列表
    SpecsList: MicroServer.goodsFrontendTenantWeb + '/goodsStore/condition/specs', //规格列表
    FindResponseForFmsListByPage: MicroServer.goodsFrontendTenantWeb + '/deductionCoupon/findResponseForFmsListByPage', //优惠券列表
    FindResponseForFmsListBySourceOrTargetOrderId: MicroServer.goodsFrontendTenantWeb + '/deductionCoupon/findResponseForFmsListBySourceOrTargetOrderId', //根据订单号查询优惠券
    ExportCouponForFmsToTask: MicroServer.goodsFrontendTenantWeb + '/deductionCoupon/exportCouponForFmsToTask', //导出优惠券到任务
    GetPlusEnums: MicroServer.goodsFrontendTenantWeb + '/enums/', //枚举值参数获取

    ListBudgetDtl: MicroServer.goodsFrontendTenantWeb + '/quoteBudgetDtl/listBudgetDtl', //  报价明细查询
  },
  BpmWeb:{
    GetDetailByProcInstId: MicroServer.bpmWeb + '/bpmTask/detailByProcInstId', //流程数据
    GetFlowDetailFinish: MicroServer.bpmWeb + '/bpmTask/complete', // 流程审批
    GetFlowDetailTransfer: MicroServer.bpmWeb + '/bpmTask/transfer',
  },
}
// 获取枚举请求 Url
export const getEnumURL = (webType = 'config', path = '') => {
  return `/${webType}-web/enums/${path}`
}
export default UrlConfig
